var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 978.37 621.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#radial-gradient);}.cls-475,.cls-5,.cls-6,.cls-7,.cls-8,.cls-81{fill:#fff;}.cls-100,.cls-115,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-31,.cls-32,.cls-36,.cls-38,.cls-41,.cls-6,.cls-60,.cls-61,.cls-67,.cls-68,.cls-89,.cls-90,.cls-99{opacity:0.32;}.cls-19,.cls-53,.cls-7{opacity:0.4;}.cls-10,.cls-103,.cls-104,.cls-107,.cls-11,.cls-110,.cls-114,.cls-12,.cls-13,.cls-14,.cls-155,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-17,.cls-18,.cls-21,.cls-22,.cls-23,.cls-24,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-25,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-26,.cls-260,.cls-261,.cls-262,.cls-263,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-29,.cls-291,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-30,.cls-300,.cls-301,.cls-302,.cls-303,.cls-304,.cls-305,.cls-306,.cls-307,.cls-308,.cls-309,.cls-310,.cls-313,.cls-314,.cls-315,.cls-316,.cls-317,.cls-318,.cls-319,.cls-320,.cls-321,.cls-322,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-328,.cls-329,.cls-33,.cls-330,.cls-331,.cls-332,.cls-34,.cls-37,.cls-39,.cls-40,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-489,.cls-49,.cls-50,.cls-51,.cls-52,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-79,.cls-8,.cls-87,.cls-88,.cls-9,.cls-91,.cls-94{opacity:0.5;}.cls-10,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-156,.cls-16,.cls-17,.cls-18,.cls-180,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-188,.cls-189,.cls-19,.cls-190,.cls-191,.cls-192,.cls-194,.cls-20,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-207,.cls-21,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-22,.cls-220,.cls-221,.cls-222,.cls-223,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-23,.cls-232,.cls-233,.cls-234,.cls-235,.cls-237,.cls-238,.cls-239,.cls-24,.cls-240,.cls-241,.cls-242,.cls-25,.cls-26,.cls-264,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-311,.cls-32,.cls-33,.cls-333,.cls-334,.cls-335,.cls-336,.cls-337,.cls-338,.cls-339,.cls-34,.cls-340,.cls-341,.cls-342,.cls-343,.cls-344,.cls-345,.cls-346,.cls-347,.cls-348,.cls-349,.cls-35,.cls-350,.cls-351,.cls-352,.cls-353,.cls-354,.cls-355,.cls-356,.cls-357,.cls-358,.cls-359,.cls-36,.cls-360,.cls-361,.cls-362,.cls-363,.cls-364,.cls-365,.cls-366,.cls-367,.cls-368,.cls-369,.cls-37,.cls-370,.cls-371,.cls-372,.cls-373,.cls-374,.cls-375,.cls-376,.cls-377,.cls-378,.cls-379,.cls-38,.cls-380,.cls-381,.cls-382,.cls-383,.cls-384,.cls-385,.cls-386,.cls-387,.cls-388,.cls-389,.cls-39,.cls-390,.cls-391,.cls-392,.cls-393,.cls-394,.cls-395,.cls-396,.cls-397,.cls-398,.cls-399,.cls-40,.cls-400,.cls-401,.cls-402,.cls-403,.cls-404,.cls-405,.cls-406,.cls-407,.cls-408,.cls-409,.cls-41,.cls-410,.cls-411,.cls-412,.cls-413,.cls-414,.cls-415,.cls-416,.cls-417,.cls-418,.cls-419,.cls-42,.cls-420,.cls-421,.cls-422,.cls-423,.cls-424,.cls-425,.cls-426,.cls-427,.cls-428,.cls-429,.cls-43,.cls-430,.cls-431,.cls-432,.cls-433,.cls-434,.cls-435,.cls-436,.cls-437,.cls-438,.cls-439,.cls-44,.cls-440,.cls-441,.cls-442,.cls-443,.cls-444,.cls-445,.cls-446,.cls-447,.cls-448,.cls-449,.cls-45,.cls-450,.cls-451,.cls-452,.cls-453,.cls-454,.cls-455,.cls-456,.cls-457,.cls-458,.cls-459,.cls-46,.cls-460,.cls-461,.cls-462,.cls-463,.cls-464,.cls-465,.cls-466,.cls-467,.cls-468,.cls-469,.cls-47,.cls-470,.cls-471,.cls-472,.cls-473,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{mix-blend-mode:screen;}.cls-9{fill:url(#radial-gradient-2);}.cls-10{fill:url(#radial-gradient-3);}.cls-11{fill:url(#radial-gradient-4);}.cls-12{fill:url(#radial-gradient-5);}.cls-13{fill:url(#radial-gradient-6);}.cls-14{fill:url(#radial-gradient-7);}.cls-15{fill:url(#radial-gradient-8);}.cls-16{fill:url(#radial-gradient-9);}.cls-17{fill:url(#radial-gradient-10);}.cls-18{fill:url(#radial-gradient-11);}.cls-19{fill:url(#radial-gradient-12);}.cls-20{fill:url(#radial-gradient-13);}.cls-21{fill:url(#radial-gradient-14);}.cls-22{fill:url(#radial-gradient-15);}.cls-23{fill:url(#radial-gradient-16);}.cls-24{fill:url(#radial-gradient-17);}.cls-25{fill:url(#radial-gradient-18);}.cls-26{fill:url(#radial-gradient-19);}.cls-27{fill:url(#radial-gradient-20);}.cls-28{fill:url(#radial-gradient-21);}.cls-29{fill:url(#radial-gradient-22);}.cls-30{fill:url(#radial-gradient-23);}.cls-31{fill:url(#radial-gradient-24);}.cls-32{fill:url(#radial-gradient-25);}.cls-33{fill:url(#radial-gradient-26);}.cls-34{fill:url(#radial-gradient-27);}.cls-35{fill:url(#radial-gradient-28);}.cls-36{fill:url(#radial-gradient-29);}.cls-37{fill:url(#radial-gradient-30);}.cls-38{fill:url(#radial-gradient-31);}.cls-39{fill:url(#radial-gradient-32);}.cls-40{fill:url(#radial-gradient-33);}.cls-41{fill:url(#radial-gradient-34);}.cls-42{fill:url(#radial-gradient-35);}.cls-43{fill:url(#radial-gradient-36);}.cls-44{fill:url(#radial-gradient-37);}.cls-45{fill:url(#radial-gradient-38);}.cls-46{fill:url(#radial-gradient-39);}.cls-47{fill:url(#radial-gradient-40);}.cls-48{fill:url(#radial-gradient-41);}.cls-49{fill:url(#radial-gradient-42);}.cls-50{fill:url(#radial-gradient-43);}.cls-51{fill:url(#radial-gradient-44);}.cls-52{fill:url(#radial-gradient-45);}.cls-53{fill:url(#radial-gradient-46);}.cls-54{fill:url(#radial-gradient-47);}.cls-55{fill:url(#radial-gradient-48);}.cls-56{fill:url(#radial-gradient-49);}.cls-57{fill:url(#radial-gradient-50);}.cls-58{fill:url(#radial-gradient-51);}.cls-59{fill:url(#radial-gradient-52);}.cls-60{fill:url(#radial-gradient-53);}.cls-61{fill:url(#radial-gradient-54);}.cls-62{fill:url(#radial-gradient-55);}.cls-63{fill:url(#radial-gradient-56);}.cls-64{fill:url(#radial-gradient-57);}.cls-65{fill:url(#radial-gradient-58);}.cls-66{fill:url(#radial-gradient-59);}.cls-67{fill:url(#radial-gradient-60);}.cls-68{fill:url(#radial-gradient-61);}.cls-69{fill:url(#radial-gradient-62);}.cls-70{fill:url(#radial-gradient-63);}.cls-71{fill:url(#radial-gradient-64);}.cls-72{fill:url(#radial-gradient-65);}.cls-73{fill:url(#radial-gradient-66);}.cls-74{fill:url(#radial-gradient-67);}.cls-75{fill:url(#radial-gradient-68);}.cls-76{fill:url(#radial-gradient-69);}.cls-77{fill:url(#radial-gradient-70);}.cls-78{fill:url(#radial-gradient-71);}.cls-79{fill:url(#radial-gradient-72);}.cls-80{fill:url(#radial-gradient-73);}.cls-101,.cls-102,.cls-105,.cls-106,.cls-108,.cls-109,.cls-111,.cls-112,.cls-113,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-187,.cls-199,.cls-212,.cls-224,.cls-236,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-93,.cls-95,.cls-96,.cls-97,.cls-98{opacity:0.25;}.cls-82{fill:url(#radial-gradient-74);}.cls-83{fill:url(#radial-gradient-75);}.cls-84{fill:url(#radial-gradient-76);}.cls-85{fill:url(#radial-gradient-77);}.cls-86{fill:url(#radial-gradient-78);}.cls-87{fill:url(#radial-gradient-79);}.cls-88{fill:url(#radial-gradient-80);}.cls-89{fill:url(#radial-gradient-81);}.cls-90{fill:url(#radial-gradient-82);}.cls-91{fill:url(#radial-gradient-83);}.cls-92{fill:url(#radial-gradient-84);}.cls-93{fill:url(#radial-gradient-85);}.cls-94{fill:url(#radial-gradient-86);}.cls-95{fill:url(#radial-gradient-87);}.cls-96{fill:url(#radial-gradient-88);}.cls-97{fill:url(#radial-gradient-89);}.cls-98{fill:url(#radial-gradient-90);}.cls-99{fill:url(#radial-gradient-91);}.cls-100{fill:url(#radial-gradient-92);}.cls-101{fill:url(#radial-gradient-93);}.cls-102{fill:url(#radial-gradient-94);}.cls-103{fill:url(#radial-gradient-95);}.cls-104{fill:url(#radial-gradient-96);}.cls-105{fill:url(#radial-gradient-97);}.cls-106{fill:url(#radial-gradient-98);}.cls-107{fill:url(#radial-gradient-99);}.cls-108{fill:url(#radial-gradient-100);}.cls-109{fill:url(#radial-gradient-101);}.cls-110{fill:url(#radial-gradient-102);}.cls-111{fill:url(#radial-gradient-103);}.cls-112{fill:url(#radial-gradient-104);}.cls-113{fill:url(#radial-gradient-105);}.cls-114{fill:url(#radial-gradient-106);}.cls-115{fill:url(#radial-gradient-107);}.cls-116{fill:url(#radial-gradient-108);}.cls-117{fill:url(#radial-gradient-109);}.cls-118{fill:url(#radial-gradient-110);}.cls-119{fill:url(#radial-gradient-111);}.cls-120{fill:url(#radial-gradient-112);}.cls-121{fill:url(#radial-gradient-113);}.cls-122{fill:url(#radial-gradient-114);}.cls-123{fill:url(#radial-gradient-115);}.cls-124{fill:url(#radial-gradient-116);}.cls-125{fill:url(#radial-gradient-117);}.cls-126{fill:url(#radial-gradient-118);}.cls-127{fill:url(#radial-gradient-119);}.cls-128{fill:url(#radial-gradient-120);}.cls-129{fill:url(#radial-gradient-121);}.cls-130{fill:url(#radial-gradient-122);}.cls-131{fill:url(#radial-gradient-123);}.cls-132{fill:url(#radial-gradient-124);}.cls-133{fill:url(#radial-gradient-125);}.cls-134{fill:url(#radial-gradient-126);}.cls-135{fill:url(#radial-gradient-127);}.cls-136{fill:url(#radial-gradient-128);}.cls-137{fill:url(#radial-gradient-129);}.cls-138{fill:url(#radial-gradient-130);}.cls-139{fill:url(#radial-gradient-131);}.cls-140{fill:url(#radial-gradient-132);}.cls-141{fill:url(#radial-gradient-133);}.cls-142{fill:url(#radial-gradient-134);}.cls-143{fill:url(#radial-gradient-135);}.cls-144{fill:url(#radial-gradient-136);}.cls-145{fill:url(#radial-gradient-137);}.cls-146{fill:url(#radial-gradient-138);}.cls-147{fill:url(#radial-gradient-139);}.cls-148{fill:url(#radial-gradient-140);}.cls-149{fill:url(#radial-gradient-141);}.cls-150{fill:url(#radial-gradient-142);}.cls-151{fill:url(#radial-gradient-143);}.cls-152{fill:url(#radial-gradient-144);}.cls-153{fill:url(#radial-gradient-145);}.cls-154{fill:url(#radial-gradient-146);}.cls-155{fill:url(#radial-gradient-147);}.cls-156{fill:url(#radial-gradient-148);}.cls-157{fill:url(#radial-gradient-149);}.cls-158{fill:url(#radial-gradient-150);}.cls-159{fill:url(#radial-gradient-151);}.cls-160{fill:url(#radial-gradient-152);}.cls-161{fill:url(#radial-gradient-153);}.cls-162{fill:url(#radial-gradient-154);}.cls-163{fill:url(#radial-gradient-155);}.cls-164{fill:url(#radial-gradient-156);}.cls-165{fill:url(#radial-gradient-157);}.cls-166{fill:url(#radial-gradient-158);}.cls-167{fill:url(#radial-gradient-159);}.cls-168{fill:url(#radial-gradient-160);}.cls-169{fill:url(#radial-gradient-161);}.cls-170{fill:url(#radial-gradient-162);}.cls-171{fill:url(#radial-gradient-163);}.cls-172{fill:url(#radial-gradient-164);}.cls-173{fill:url(#radial-gradient-165);}.cls-174{fill:url(#radial-gradient-166);}.cls-175{fill:url(#radial-gradient-167);}.cls-176{fill:url(#radial-gradient-168);}.cls-177{fill:url(#radial-gradient-169);}.cls-178{fill:url(#radial-gradient-170);}.cls-179{fill:url(#radial-gradient-171);}.cls-180{fill:url(#radial-gradient-172);}.cls-181,.cls-182{fill:url(#radial-gradient-173);}.cls-183{fill:url(#radial-gradient-175);}.cls-184{fill:url(#radial-gradient-176);}.cls-185{fill:url(#radial-gradient-177);}.cls-186{fill:url(#radial-gradient-178);}.cls-187,.cls-199,.cls-212,.cls-224,.cls-236,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-266,.cls-267,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-291,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-301,.cls-302,.cls-303,.cls-304,.cls-305,.cls-306,.cls-307,.cls-308,.cls-309,.cls-310,.cls-313,.cls-314,.cls-315,.cls-316,.cls-317,.cls-318,.cls-319,.cls-320,.cls-321,.cls-322,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-328,.cls-329,.cls-330,.cls-331,.cls-332{mix-blend-mode:multiply;}.cls-187{fill:url(#radial-gradient-179);}.cls-188,.cls-200,.cls-213,.cls-225,.cls-237{opacity:0.34;}.cls-188{fill:url(#radial-gradient-180);}.cls-189,.cls-265,.cls-266{fill:#e0a326;}.cls-189,.cls-201,.cls-203,.cls-204,.cls-214,.cls-216,.cls-217,.cls-226,.cls-228,.cls-229,.cls-238,.cls-240,.cls-241,.cls-264{opacity:0.45;}.cls-190{fill:url(#radial-gradient-181);}.cls-192{fill:url(#radial-gradient-182);}.cls-193,.cls-194{fill:url(#radial-gradient-183);}.cls-195{fill:url(#radial-gradient-185);}.cls-196{fill:url(#radial-gradient-186);}.cls-197{fill:url(#radial-gradient-187);}.cls-198{fill:url(#radial-gradient-188);}.cls-199{fill:url(#radial-gradient-189);}.cls-200{fill:url(#radial-gradient-190);}.cls-201{fill:url(#radial-gradient-191);}.cls-202{fill:url(#radial-gradient-192);}.cls-203{fill:url(#radial-gradient-193);}.cls-204{fill:url(#radial-gradient-194);}.cls-205{fill:url(#radial-gradient-195);}.cls-206,.cls-207{fill:url(#radial-gradient-196);}.cls-208{fill:url(#radial-gradient-198);}.cls-209{fill:url(#radial-gradient-199);}.cls-210{fill:url(#radial-gradient-200);}.cls-211{fill:url(#radial-gradient-201);}.cls-212{fill:url(#radial-gradient-202);}.cls-213{fill:url(#radial-gradient-203);}.cls-214{fill:url(#radial-gradient-204);}.cls-215{fill:url(#radial-gradient-205);}.cls-216{fill:url(#radial-gradient-206);}.cls-217{fill:url(#radial-gradient-207);}.cls-218{fill:url(#radial-gradient-208);}.cls-219{fill:url(#radial-gradient-209);}.cls-220{fill:url(#radial-gradient-210);}.cls-221{fill:url(#radial-gradient-211);}.cls-222{fill:url(#radial-gradient-212);}.cls-223{fill:url(#radial-gradient-213);}.cls-224{fill:url(#radial-gradient-214);}.cls-225{fill:url(#radial-gradient-215);}.cls-226{fill:url(#radial-gradient-216);}.cls-227{fill:url(#radial-gradient-217);}.cls-228{fill:url(#radial-gradient-218);}.cls-229{fill:url(#radial-gradient-219);}.cls-230{fill:url(#radial-gradient-220);}.cls-231{fill:url(#radial-gradient-221);}.cls-232{fill:url(#radial-gradient-222);}.cls-233{fill:url(#radial-gradient-223);}.cls-234{fill:url(#radial-gradient-224);}.cls-235{fill:url(#radial-gradient-225);}.cls-236{fill:url(#radial-gradient-226);}.cls-237{fill:url(#radial-gradient-227);}.cls-238{fill:url(#radial-gradient-228);}.cls-239{fill:url(#radial-gradient-229);}.cls-240{fill:url(#radial-gradient-230);}.cls-241{fill:url(#radial-gradient-231);}.cls-242{fill:url(#radial-gradient-232);}.cls-243{fill:url(#radial-gradient-233);}.cls-244{fill:url(#radial-gradient-234);}.cls-245{fill:url(#radial-gradient-235);}.cls-246{fill:url(#radial-gradient-236);}.cls-247{fill:url(#radial-gradient-237);}.cls-248{fill:url(#radial-gradient-238);}.cls-249{fill:url(#radial-gradient-239);}.cls-250{fill:url(#radial-gradient-240);}.cls-251{fill:url(#radial-gradient-241);}.cls-252{fill:url(#radial-gradient-242);}.cls-253{fill:url(#radial-gradient-243);}.cls-254{fill:url(#radial-gradient-244);}.cls-255{fill:url(#radial-gradient-245);}.cls-256{fill:url(#radial-gradient-246);}.cls-257{fill:url(#radial-gradient-247);}.cls-258{fill:url(#radial-gradient-248);}.cls-259{fill:url(#radial-gradient-249);}.cls-260{fill:url(#radial-gradient-250);}.cls-261{fill:url(#radial-gradient-251);}.cls-262{fill:url(#radial-gradient-252);}.cls-263{fill:url(#radial-gradient-253);}.cls-266,.cls-267{opacity:0.54;}.cls-268{fill:url(#radial-gradient-254);}.cls-269{fill:url(#radial-gradient-255);}.cls-270{fill:url(#radial-gradient-256);}.cls-271{fill:url(#radial-gradient-257);}.cls-272{fill:url(#radial-gradient-258);}.cls-273{fill:url(#radial-gradient-259);}.cls-274{fill:url(#radial-gradient-260);}.cls-275{fill:url(#radial-gradient-261);}.cls-276{fill:url(#radial-gradient-262);}.cls-277{fill:url(#radial-gradient-263);}.cls-278{fill:url(#radial-gradient-264);}.cls-279{fill:url(#radial-gradient-265);}.cls-280{fill:url(#radial-gradient-266);}.cls-281{fill:url(#radial-gradient-267);}.cls-282{fill:url(#radial-gradient-268);}.cls-283{fill:url(#radial-gradient-269);}.cls-284{fill:url(#radial-gradient-270);}.cls-285{fill:url(#radial-gradient-271);}.cls-286{fill:url(#radial-gradient-272);}.cls-287{fill:url(#radial-gradient-273);}.cls-288{fill:url(#radial-gradient-274);}.cls-289{mix-blend-mode:color;fill:url(#radial-gradient-275);}.cls-290{fill:url(#radial-gradient-276);}.cls-291{fill:url(#radial-gradient-277);}.cls-292{fill:url(#radial-gradient-278);}.cls-293{fill:url(#radial-gradient-279);}.cls-294{fill:url(#radial-gradient-280);}.cls-295{fill:url(#radial-gradient-281);}.cls-296{fill:url(#radial-gradient-282);}.cls-297{fill:url(#radial-gradient-283);}.cls-298{fill:url(#radial-gradient-284);}.cls-299{fill:url(#radial-gradient-285);}.cls-300{fill:url(#radial-gradient-286);}.cls-301{fill:url(#radial-gradient-287);}.cls-302{fill:url(#radial-gradient-288);}.cls-303{fill:url(#radial-gradient-289);}.cls-304{fill:url(#radial-gradient-290);}.cls-305{fill:url(#radial-gradient-291);}.cls-306{fill:url(#radial-gradient-292);}.cls-307{fill:url(#radial-gradient-293);}.cls-308{fill:url(#radial-gradient-294);}.cls-309{fill:url(#radial-gradient-295);}.cls-310{fill:url(#radial-gradient-296);}.cls-311{fill:url(#radial-gradient-297);}.cls-312{fill:url(#radial-gradient-298);}.cls-313{fill:url(#radial-gradient-299);}.cls-314{fill:url(#radial-gradient-300);}.cls-315{fill:url(#radial-gradient-301);}.cls-316{fill:url(#radial-gradient-302);}.cls-317{fill:url(#radial-gradient-303);}.cls-318{fill:url(#radial-gradient-304);}.cls-319{fill:url(#radial-gradient-305);}.cls-320{fill:url(#radial-gradient-306);}.cls-321{fill:url(#radial-gradient-307);}.cls-322{fill:url(#radial-gradient-308);}.cls-323{fill:url(#radial-gradient-309);}.cls-324{fill:url(#radial-gradient-310);}.cls-325{fill:url(#radial-gradient-311);}.cls-326{fill:url(#radial-gradient-312);}.cls-327{fill:url(#radial-gradient-313);}.cls-328{fill:url(#radial-gradient-314);}.cls-329{fill:url(#radial-gradient-315);}.cls-330{fill:url(#radial-gradient-316);}.cls-331{fill:url(#radial-gradient-317);}.cls-332{fill:url(#radial-gradient-318);}.cls-333{fill:url(#radial-gradient-319);}.cls-334{fill:url(#radial-gradient-320);}.cls-335{fill:url(#radial-gradient-321);}.cls-336{fill:url(#radial-gradient-322);}.cls-337{fill:url(#radial-gradient-323);}.cls-338{fill:url(#radial-gradient-324);}.cls-339{fill:url(#radial-gradient-325);}.cls-340{fill:url(#radial-gradient-326);}.cls-341{fill:url(#radial-gradient-327);}.cls-342{fill:url(#radial-gradient-328);}.cls-343{fill:url(#radial-gradient-329);}.cls-344{fill:url(#radial-gradient-330);}.cls-345{fill:url(#radial-gradient-331);}.cls-346{fill:url(#radial-gradient-332);}.cls-347{fill:url(#radial-gradient-333);}.cls-348{fill:url(#radial-gradient-334);}.cls-349{fill:url(#radial-gradient-335);}.cls-350{fill:url(#radial-gradient-336);}.cls-351{fill:url(#radial-gradient-337);}.cls-352{fill:url(#radial-gradient-338);}.cls-353{fill:url(#radial-gradient-339);}.cls-354{fill:url(#radial-gradient-340);}.cls-355{fill:url(#radial-gradient-341);}.cls-356{fill:url(#radial-gradient-342);}.cls-357{fill:url(#radial-gradient-343);}.cls-358{fill:url(#radial-gradient-344);}.cls-359{fill:url(#radial-gradient-345);}.cls-360{fill:url(#radial-gradient-346);}.cls-361{fill:url(#radial-gradient-347);}.cls-362{fill:url(#radial-gradient-348);}.cls-363{fill:url(#radial-gradient-349);}.cls-364{fill:url(#radial-gradient-350);}.cls-365{fill:url(#radial-gradient-351);}.cls-366{fill:url(#radial-gradient-352);}.cls-367{fill:url(#radial-gradient-353);}.cls-368{fill:url(#radial-gradient-354);}.cls-369{fill:url(#radial-gradient-355);}.cls-370{fill:url(#radial-gradient-356);}.cls-371{fill:url(#radial-gradient-357);}.cls-372{fill:url(#radial-gradient-358);}.cls-373{fill:url(#radial-gradient-359);}.cls-374{fill:url(#radial-gradient-360);}.cls-375{fill:url(#radial-gradient-361);}.cls-376{fill:url(#radial-gradient-362);}.cls-377{fill:url(#radial-gradient-363);}.cls-378{fill:url(#radial-gradient-364);}.cls-379{fill:url(#radial-gradient-365);}.cls-380{fill:url(#radial-gradient-366);}.cls-381{fill:url(#radial-gradient-367);}.cls-382{fill:url(#radial-gradient-368);}.cls-383{fill:url(#radial-gradient-369);}.cls-384{fill:url(#radial-gradient-370);}.cls-385{fill:url(#radial-gradient-371);}.cls-386{fill:url(#radial-gradient-372);}.cls-387{fill:url(#radial-gradient-373);}.cls-388{fill:url(#radial-gradient-374);}.cls-389{fill:url(#radial-gradient-375);}.cls-390{fill:url(#radial-gradient-376);}.cls-391{fill:url(#radial-gradient-377);}.cls-392{fill:url(#radial-gradient-378);}.cls-393{fill:url(#radial-gradient-379);}.cls-394{fill:url(#radial-gradient-380);}.cls-395{fill:url(#radial-gradient-381);}.cls-396{fill:url(#radial-gradient-382);}.cls-397{fill:url(#radial-gradient-383);}.cls-398{fill:url(#radial-gradient-384);}.cls-399{fill:url(#radial-gradient-385);}.cls-400{fill:url(#radial-gradient-386);}.cls-401{fill:url(#radial-gradient-387);}.cls-402{fill:url(#radial-gradient-388);}.cls-403{fill:url(#radial-gradient-389);}.cls-404{fill:url(#radial-gradient-390);}.cls-405{fill:url(#radial-gradient-391);}.cls-406{fill:url(#radial-gradient-392);}.cls-407{fill:url(#radial-gradient-393);}.cls-408{fill:url(#radial-gradient-394);}.cls-409{fill:url(#radial-gradient-395);}.cls-410{fill:url(#radial-gradient-396);}.cls-411{fill:url(#radial-gradient-397);}.cls-412{fill:url(#radial-gradient-398);}.cls-413{fill:url(#radial-gradient-399);}.cls-414{fill:url(#radial-gradient-400);}.cls-415{fill:url(#radial-gradient-401);}.cls-416{fill:url(#radial-gradient-402);}.cls-417{fill:url(#radial-gradient-403);}.cls-418{fill:url(#radial-gradient-404);}.cls-419{fill:url(#radial-gradient-405);}.cls-420{fill:url(#radial-gradient-406);}.cls-421{fill:url(#radial-gradient-407);}.cls-422{fill:url(#radial-gradient-408);}.cls-423{fill:url(#radial-gradient-409);}.cls-424{fill:url(#radial-gradient-410);}.cls-425{fill:url(#radial-gradient-411);}.cls-426{fill:url(#radial-gradient-412);}.cls-427{fill:url(#radial-gradient-413);}.cls-428{fill:url(#radial-gradient-414);}.cls-429{fill:url(#radial-gradient-415);}.cls-430{fill:url(#radial-gradient-416);}.cls-431{fill:url(#radial-gradient-417);}.cls-432{fill:url(#radial-gradient-418);}.cls-433{fill:url(#radial-gradient-419);}.cls-434{fill:url(#radial-gradient-420);}.cls-435{fill:url(#radial-gradient-421);}.cls-436{fill:url(#radial-gradient-422);}.cls-437{fill:url(#radial-gradient-423);}.cls-438{fill:url(#radial-gradient-424);}.cls-439{fill:url(#radial-gradient-425);}.cls-440{fill:url(#radial-gradient-426);}.cls-441{fill:url(#radial-gradient-427);}.cls-442{fill:url(#radial-gradient-428);}.cls-443{fill:url(#radial-gradient-429);}.cls-444{fill:url(#radial-gradient-430);}.cls-445{fill:url(#radial-gradient-431);}.cls-446{fill:url(#radial-gradient-432);}.cls-447{fill:url(#radial-gradient-433);}.cls-448{fill:url(#radial-gradient-434);}.cls-449{fill:url(#radial-gradient-435);}.cls-450{fill:url(#radial-gradient-436);}.cls-451{fill:url(#radial-gradient-437);}.cls-452{fill:url(#radial-gradient-438);}.cls-453{fill:url(#radial-gradient-439);}.cls-454{fill:url(#radial-gradient-440);}.cls-455{fill:url(#radial-gradient-441);}.cls-456{fill:url(#radial-gradient-442);}.cls-457{fill:url(#radial-gradient-443);}.cls-458{fill:url(#radial-gradient-444);}.cls-459{fill:url(#radial-gradient-445);}.cls-460{fill:url(#radial-gradient-446);}.cls-461{fill:url(#radial-gradient-447);}.cls-462{fill:url(#radial-gradient-448);}.cls-463{fill:url(#radial-gradient-449);}.cls-464{fill:url(#radial-gradient-450);}.cls-465{fill:url(#radial-gradient-451);}.cls-466{fill:url(#radial-gradient-452);}.cls-467{fill:url(#radial-gradient-453);}.cls-468{fill:url(#radial-gradient-454);}.cls-469{fill:url(#radial-gradient-455);}.cls-470{fill:url(#radial-gradient-456);}.cls-471{fill:url(#radial-gradient-457);}.cls-472{fill:url(#radial-gradient-458);}.cls-473{fill:url(#radial-gradient-459);}.cls-474,.cls-478{fill:#301942;}.cls-474,.cls-475,.cls-476,.cls-479,.cls-480,.cls-481,.cls-482,.cls-483,.cls-484{fill-rule:evenodd;}.cls-476{fill:#d18d5d;}.cls-477{opacity:0.3;}.cls-479{fill:#d2d0d4;}.cls-480{fill:#887e92;}.cls-481{fill:#e3ddd8;}.cls-482{fill:#4b425f;}.cls-483{fill:#786f8f;}.cls-484{fill:#c0bfc2;}.cls-485{fill:#301b42;}.cls-486{opacity:0.35;}.cls-487{fill:#511e48;}.cls-488{fill:#1d172b;}.cls-490{fill:#58dec7;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(114.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 376.78,
    cy: 250,
    r: 310.3,
    gradientTransform: "translate(-75.85) scale(1.5 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a289c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#00092b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -947.82,
    cy: 206.47,
    r: 182.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -433.78, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0a1656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4478af"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -954.03,
    cy: 207.23,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -954.03,
    cy: 207.23,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -947.82,
    cy: 206.47,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -966.91,
    cy: 205.27,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -954.03,
    cy: 207.23,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -1024.87,
    cy: 115.05,
    r: 14.33,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 502.54,
    cy: 171.55,
    r: 14.34,
    gradientTransform: "matrix(1, 0.08, 0.08, -1, -60.98, 191.26)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -539.54,
    cy: 325.09,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -539.54,
    cy: 325.09,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -616.59,
    cy: 233.67,
    r: 14.33,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -722.92,
    cy: 43.23,
    r: 14.33,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -721.72,
    cy: 299.8,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -721.72,
    cy: 299.8,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -721.72,
    cy: 299.8,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -721.72,
    cy: 299.8,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -801.38,
    cy: 294.52,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -905.7,
    cy: 191.43,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -955.4,
    cy: 124.34,
    r: 10.4,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 300.31,
    cy: 21.7,
    r: 10.4,
    gradientTransform: "matrix(1, 0.08, 0.08, -1, -60.98, 191.26)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 1219.44,
    cy: -648.11,
    r: 132.54,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 1219.44,
    cy: -648.11,
    r: 132.55,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 1400.67,
    cy: -743.83,
    r: 132.54,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 1400.67,
    cy: -743.82,
    r: 132.55,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 1219.44,
    cy: -648.11,
    r: 132.55,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 1219.44,
    cy: -648.11,
    r: 132.55,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 1163.53,
    cy: -714.44,
    r: 10.4,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 1447.9,
    cy: -848.67,
    r: 10.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 1417.83,
    cy: -614.69,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 1417.83,
    cy: -614.69,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 1417.83,
    cy: -614.69,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 1417.83,
    cy: -614.68,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 1455.37,
    cy: -748.02,
    r: 14.7,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 1550.67,
    cy: -1020.3,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 1554.53,
    cy: -1025.23,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 1550.67,
    cy: -1020.3,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 1550.67,
    cy: -1020.3,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 1786.23,
    cy: -971.25,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 1562.52,
    cy: -1061.79,
    r: 14.34,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 1607.39,
    cy: -1163.39,
    r: 10.09,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: -595.26,
    cy: 205.66,
    r: 2.34,
    gradientTransform: "matrix(-1, 0, 0, 1, -433.78, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e47e99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e43d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b30058"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: -588.08,
    cy: 338.98,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: -640.17,
    cy: 280.58,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -601.65,
    cy: 257.13,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -622.58,
    cy: 306.97,
    r: 14.28,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -950.79,
    cy: 9.29,
    r: 2.34,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -937.4,
    cy: 141.86,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: -995.7,
    cy: 84.21,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -957.18,
    cy: 60.76,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -799.48,
    cy: 25.35,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: -1046.01,
    cy: 60.91,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: -1018.79,
    cy: 28.2,
    r: 14.22,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: -942.54,
    cy: 225.58,
    r: 14.28,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: -759.76,
    cy: 69.37,
    r: 1.7,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: -754.56,
    cy: 166.11,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: -792.35,
    cy: 123.73,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: -764.4,
    cy: 106.72,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: -649.98,
    cy: 81.03,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: -659.39,
    cy: 162.29,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: -639.64,
    cy: 138.56,
    r: 10.32,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: -779.58,
    cy: 142.88,
    r: 10.36,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: -721.93,
    cy: 214.84,
    r: 10.36,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: -729.37,
    cy: 286.77,
    r: 1.7,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: -664.65,
    cy: 214.68,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: -667.9,
    cy: 271.37,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: -699.69,
    cy: 263.64,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: -982.75,
    cy: 92.53,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: -723.49,
    cy: 177.64,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: -936.73,
    cy: 75.96,
    r: 11.18,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: -663.87,
    cy: 244.3,
    r: 11.09,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: -838.55,
    cy: 20.5,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: -837.77,
    cy: 50.12,
    r: 11.09,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: -1233.2,
    cy: 212.27,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 781.14,
    cy: 190.2,
    r: 14.34,
    gradientTransform: "matrix(1, 0.08, 0.08, -1, -60.98, 191.26)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: -1078.65,
    cy: 30.4,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: -1117.72,
    cy: 25.55,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: -1116.94,
    cy: 55.17,
    r: 11.09,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: -966.55,
    cy: 332.32,
    r: 2.34,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: -904.91,
    cy: 134.81,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: -909.38,
    cy: 212.94,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: -953.2,
    cy: 202.28,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: -958.43,
    cy: 181.93,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: -1017.84,
    cy: 189.94,
    r: 15.41,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: -489.26,
    cy: 205.71,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: -483.05,
    cy: 204.95,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: -489.26,
    cy: 205.7,
    r: 182.66,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: -560.1,
    cy: 113.53,
    r: 14.33,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: -440.93,
    cy: 189.91,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: -490.63,
    cy: 122.82,
    r: 10.4,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: 1073.1,
    cy: -414.1,
    r: 132.54,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: 1073.1,
    cy: -414.1,
    r: 132.54,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: 1120.33,
    cy: -518.94,
    r: 10.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1029.92, 471.78)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: 1223.1,
    cy: -690.58,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: 1226.96,
    cy: -695.5,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: 1223.1,
    cy: -690.58,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: 1223.1,
    cy: -690.58,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: 1458.66,
    cy: -641.52,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: 1226.96,
    cy: -695.5,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: 1234.95,
    cy: -732.07,
    r: 14.34,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: 1279.82,
    cy: -833.67,
    r: 10.09,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: -486.02,
    cy: 7.77,
    r: 2.34,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: -472.63,
    cy: 140.33,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: -530.93,
    cy: 82.68,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: -492.4,
    cy: 59.23,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: -581.24,
    cy: 59.39,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: -554.02,
    cy: 26.68,
    r: 14.22,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: -477.77,
    cy: 224.05,
    r: 14.28,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: -517.98,
    cy: 91,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: -471.95,
    cy: 74.44,
    r: 11.18,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: -501.78,
    cy: 330.8,
    r: 2.34,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-112",
    cx: -488.42,
    cy: 200.76,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-113",
    cx: -493.66,
    cy: 180.41,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-114",
    cx: -533.98,
    cy: 189.62,
    r: 15.41,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-115",
    cx: -903.83,
    cy: 175.63,
    r: 15.29,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-116",
    cx: -619.65,
    cy: 128.01,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-117",
    cx: 1363.92,
    cy: -908.73,
    r: 14.7,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-118",
    cx: -688.62,
    cy: 316.86,
    r: 10.32,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-119",
    cx: -668.62,
    cy: 306.3,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-120",
    cx: -998.7,
    cy: 346.4,
    r: 182.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-121",
    cx: -1075.75,
    cy: 254.98,
    r: 14.33,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-122",
    cx: -1180.88,
    cy: 321.11,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-123",
    cx: -1180.88,
    cy: 321.11,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-124",
    cx: -1180.88,
    cy: 321.11,
    r: 132.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-125",
    cx: 759.62,
    cy: 39.4,
    r: 10.4,
    gradientTransform: "matrix(1, 0.08, 0.08, -1, -60.98, 191.26)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-126",
    cx: 1727.44,
    cy: -954.43,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-127",
    cx: 1727.44,
    cy: -954.43,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-128",
    cx: 1727.44,
    cy: -954.43,
    r: 182.67,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-129",
    cx: 1764.98,
    cy: -1087.77,
    r: 14.7,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-130",
    cx: -1099.33,
    cy: 301.88,
    r: 2.26,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-131",
    cx: -1081.74,
    cy: 328.28,
    r: 14.28,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-132",
    cx: -1109.14,
    cy: 102.33,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-133",
    cx: -1118.55,
    cy: 183.6,
    r: 1.64,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-134",
    cx: -1098.81,
    cy: 159.87,
    r: 10.32,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-135",
    cx: -1123.82,
    cy: 235.99,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-136",
    cx: -1127.06,
    cy: 292.68,
    r: 1.44,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-137",
    cx: -1123.03,
    cy: 265.61,
    r: 11.09,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-138",
    cx: -1078.81,
    cy: 149.32,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-139",
    cx: 1673.54,
    cy: -1248.47,
    r: 14.7,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -1363.85, 640.95)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-140",
    cx: -1147.78,
    cy: 338.17,
    r: 10.32,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-141",
    cx: -1127.78,
    cy: 327.61,
    r: 1.98,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-142",
    cx: -583.59,
    cy: 93.58,
    r: 15.41,
    xlinkHref: "#radial-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-143",
    cx: 334.13,
    cy: 338.06,
    r: 449.69,
    gradientTransform: "translate(-7.05 -134.15) scale(1.12 1.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a289c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#00092b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-144",
    cx: 334.84,
    cy: 355.18,
    r: 391.58,
    xlinkHref: "#radial-gradient-143"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-145",
    cx: 324.85,
    cy: 329.84,
    r: 348.15,
    gradientTransform: "translate(-7.05 -93.91) scale(1.12 1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-146",
    cx: 369.58,
    cy: 320.9,
    r: 252.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-147",
    cx: 344.39,
    cy: 294.74,
    r: 193.42,
    gradientTransform: "matrix(1.11, 0.18, -0.17, 1.2, 55.8, -75.08)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-148",
    cx: 364.36,
    cy: 427.21,
    r: 145.04,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-149",
    cx: 413.67,
    cy: 334.28,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-150",
    cx: 413.67,
    cy: 334.29,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-151",
    cx: 413.67,
    cy: 334.29,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-152",
    cx: 413.67,
    cy: 334.29,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-153",
    cx: 413.67,
    cy: 334.29,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-154",
    cx: 413.67,
    cy: 334.29,
    r: 179.18,
    gradientTransform: "translate(-7.05 -111.92) scale(1.12 1.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-155",
    cx: 177.7,
    cy: 420.96,
    r: 54.67,
    gradientTransform: "matrix(1.06, 0.37, -0.4, 1.15, 184.52, -148.91)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-156",
    cx: 380.1,
    cy: 86.55,
    r: 54.67,
    gradientTransform: "matrix(-0.36, 1.08, -1.16, -0.31, 755.58, -11.2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-157",
    cx: 381.37,
    cy: -162.84,
    r: 54.67,
    gradientTransform: "matrix(0.74, 0.91, -0.85, 0.8, 252.67, 184.03)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-158",
    cx: 406.21,
    cy: 96.99,
    r: 23.21,
    gradientTransform: "matrix(1.02, 0.52, -0.48, 1.1, 147.79, 42.32)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-159",
    cx: 449.26,
    cy: 119.9,
    r: 23.21,
    gradientTransform: "matrix(1.02, 0.52, -0.48, 1.1, 147.79, 42.32)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-160",
    cx: 463.77,
    cy: 84.35,
    r: 23.21,
    gradientTransform: "matrix(1.02, 0.52, -0.48, 1.1, 147.79, 42.32)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-161",
    cx: 424.67,
    cy: -34.05,
    r: 23.21,
    gradientTransform: "matrix(0.87, 0.77, -0.71, 0.94, 214.77, 130.8)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-162",
    cx: 442.23,
    cy: 0.79,
    r: 37.24,
    gradientTransform: "matrix(0.95, 0.65, -0.61, 1.02, 181.89, 87.07)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-163",
    cx: 405.64,
    cy: 119.99,
    r: 37.24,
    gradientTransform: "matrix(-0.36, 1.09, -1.16, -0.3, 800.91, 14.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-164",
    cx: 249.82,
    cy: 366.55,
    r: 33.55,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-165",
    cx: 247.12,
    cy: 397.64,
    r: 33.55,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-166",
    cx: 259.31,
    cy: 395.68,
    r: 20.9,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-167",
    cx: 231.18,
    cy: 356.41,
    r: 20.9,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-168",
    cx: 200.05,
    cy: 398.86,
    r: 20.9,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-169",
    cx: 279.71,
    cy: 383.03,
    r: 54.67,
    gradientTransform: "matrix(1.06, 0.37, -0.4, 1.15, 175.77, -189.25)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-170",
    cx: 299.88,
    cy: 355.53,
    r: 20.9,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-171",
    cx: 200.14,
    cy: 366.01,
    r: 20.9,
    gradientTransform: "matrix(1.12, 0.07, -0.06, 1.21, 16.11, -90.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-172",
    cx: 791.91,
    cy: 200.6,
    r: 46.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f20074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f10174",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ed0376",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e70679",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#df0b7d",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d31182",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c51988",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b42290",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a02d98",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8b39a2",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7446ac",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-173",
    cx: 784.8,
    cy: 161.33,
    r: 117.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-175",
    cx: 660.68,
    cy: 172.43,
    r: 61.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f20074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ed0376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#df0b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c71887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a62a96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7b42a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7446ac"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-176",
    cx: 660.68,
    cy: 172.43,
    r: 61.91,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-177",
    cx: 660.68,
    cy: 172.43,
    r: 61.87,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-178",
    cx: 660.68,
    cy: 172.43,
    r: 61.87,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-179",
    cx: 671.17,
    cy: 170.91,
    r: 106.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-180",
    cx: 672.16,
    cy: 184.17,
    r: 87.47,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-181",
    cx: 668.16,
    cy: 166.2,
    r: 75.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-182",
    cx: 77.17,
    cy: 122.5,
    r: 59.3,
    gradientTransform: "translate(109.13 -18.47) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#e0a326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e0a227",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#df9e2b",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#de9833",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dd8f3e",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#db844c",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d8755d",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#d56471",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#d25089",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ce3ba3",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc2db4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-183",
    cx: -577.39,
    cy: -406.38,
    r: 151.36,
    gradientTransform: "translate(-356.1 636.29) rotate(98.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#e0a326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc2db4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-185",
    cx: -590,
    cy: -392.1,
    r: 79.59,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-186",
    cx: -590,
    cy: -392.1,
    r: 79.65,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-187",
    cx: -590,
    cy: -392.1,
    r: 79.59,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-188",
    cx: -590,
    cy: -392.1,
    r: 79.59,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-189",
    cx: -576.74,
    cy: -394.18,
    r: 137.29,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-190",
    cx: -575.22,
    cy: -377,
    r: 112.53,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-191",
    cx: 86.73,
    cy: 118.59,
    r: 44.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-192",
    cx: -580.37,
    cy: -400.11,
    r: 96.89,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-193",
    cx: 96.97,
    cy: 93.46,
    r: 9.72,
    gradientTransform: "translate(103.45 -41.06) rotate(48.81)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-194",
    cx: 112.31,
    cy: 109.97,
    r: 5.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-195",
    cx: 571.9,
    cy: 156.5,
    r: 15.54,
    gradientTransform: "translate(63.1 -147.92) rotate(15.59)",
    xlinkHref: "#radial-gradient-182"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-196",
    cx: -536,
    cy: -864.58,
    r: 39.67,
    gradientTransform: "matrix(-0.24, 0.97, -0.97, -0.24, -383.98, 467.39)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-198",
    cx: -539.31,
    cy: -860.83,
    r: 20.86,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-199",
    cx: -539.31,
    cy: -860.83,
    r: 20.88,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-200",
    cx: -539.31,
    cy: -860.83,
    r: 20.86,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-201",
    cx: -539.31,
    cy: -860.83,
    r: 20.86,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-202",
    cx: -535.83,
    cy: -861.38,
    r: 35.98,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-203",
    cx: -535.43,
    cy: -856.88,
    r: 29.49,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-204",
    cx: 574.41,
    cy: 155.47,
    r: 11.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-205",
    cx: -536.78,
    cy: -862.93,
    r: 25.4,
    gradientTransform: "translate(-278.13 692.95) rotate(89.83)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-206",
    cx: 577.1,
    cy: 148.89,
    r: 2.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-207",
    cx: 581.11,
    cy: 153.21,
    r: 1.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-208",
    cx: 546.56,
    cy: 52.54,
    r: 39.34,
    gradientTransform: "translate(14.7 -83.68) rotate(8.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f1f7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#40217e",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#422983",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#45378c",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4b4a98",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5264a8",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5a83bc",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#64a8d3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66b0d8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-209",
    cx: -310.76,
    cy: 383.54,
    r: 90.24,
    gradientTransform: "translate(470.8 -455.65) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#66b0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f1f7d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-210",
    cx: 537.12,
    cy: 22.29,
    r: 206.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-211",
    cx: 537.12,
    cy: 22.29,
    r: 206.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-212",
    cx: 537.12,
    cy: 22.29,
    r: 206.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-213",
    cx: 537.12,
    cy: 22.29,
    r: 206.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-214",
    cx: -310,
    cy: 391.01,
    r: 81.85,
    gradientTransform: "matrix(0.59, -0.81, 0.81, 0.59, 393.27, -437.87)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-215",
    cx: -308.13,
    cy: 401.1,
    r: 67.09,
    gradientTransform: "matrix(0.59, -0.81, 0.81, 0.59, 393.27, -437.87)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-216",
    cx: -686.08,
    cy: 385.69,
    r: 26.73,
    gradientTransform: "translate(-240.79 -44.06) rotate(-143.7)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-217",
    cx: -312.53,
    cy: 387.28,
    r: 57.77,
    gradientTransform: "matrix(0.59, -0.81, 0.81, 0.59, 393.27, -437.87)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-218",
    cx: -679.97,
    cy: 370.71,
    r: 5.79,
    gradientTransform: "translate(-240.79 -44.06) rotate(-143.7)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-219",
    cx: -670.83,
    cy: 380.55,
    r: 3.41,
    gradientTransform: "translate(-240.79 -44.06) rotate(-143.7)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-220",
    cx: -295.92,
    cy: -441.14,
    r: 13.65,
    gradientTransform: "translate(-321.64 -4.5) rotate(144.2)",
    xlinkHref: "#radial-gradient-208"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-221",
    cx: -405.05,
    cy: -568.16,
    r: 31.31,
    gradientTransform: "matrix(0.03, 1, -1, 0.03, -367.68, 601.97)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-222",
    cx: -299.19,
    cy: -451.63,
    r: 71.77,
    gradientTransform: "matrix(0.26, 0.97, -0.97, 0.26, -174.23, 579.06)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-223",
    cx: -299.19,
    cy: -451.63,
    r: 71.77,
    gradientTransform: "matrix(0.26, 0.97, -0.97, 0.26, -174.23, 579.06)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-224",
    cx: -299.19,
    cy: -451.63,
    r: 71.77,
    gradientTransform: "matrix(0.26, 0.97, -0.97, 0.26, -174.23, 579.06)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-225",
    cx: -299.19,
    cy: -451.63,
    r: 71.77,
    gradientTransform: "matrix(0.26, 0.97, -0.97, 0.26, -174.23, 579.06)",
    xlinkHref: "#radial-gradient-183"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-226",
    cx: -404.79,
    cy: -565.57,
    r: 28.4,
    gradientTransform: "matrix(0.93, 0.36, -0.36, 0.93, 349.58, 846.39)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-227",
    cx: -404.14,
    cy: -562.07,
    r: 23.28,
    gradientTransform: "matrix(0.93, 0.36, -0.36, 0.93, 349.58, 846.39)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-228",
    cx: 280.89,
    cy: 286.98,
    r: 9.27,
    gradientTransform: "matrix(0.37, -0.93, 0.93, 0.37, -193.52, 334.26)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-229",
    cx: -405.67,
    cy: -566.87,
    r: 20.04,
    gradientTransform: "matrix(0.93, 0.36, -0.36, 0.93, 349.58, 846.39)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-230",
    cx: 283.01,
    cy: 281.78,
    r: 2.01,
    gradientTransform: "matrix(0.37, -0.93, 0.93, 0.37, -193.52, 334.26)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-231",
    cx: 286.18,
    cy: 285.2,
    r: 1.18,
    gradientTransform: "matrix(0.37, -0.93, 0.93, 0.37, -193.52, 334.26)",
    xlinkHref: "#radial-gradient-209"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-232",
    cx: 692.22,
    cy: 307.18,
    r: 21.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-182"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-233",
    cx: 685.15,
    cy: 295.16,
    r: 38.93,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-234",
    cx: 570.84,
    cy: 298.45,
    r: 36.44,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-235",
    cx: 571.89,
    cy: 303.72,
    r: 30.62,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-236",
    cx: 573.13,
    cy: 277.92,
    r: 24,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-237",
    cx: 574.71,
    cy: 293.73,
    r: 8.07,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-238",
    cx: 578.15,
    cy: 282.71,
    r: 16.73,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-239",
    cx: 601.76,
    cy: 255.82,
    r: 10.9,
    gradientTransform: "matrix(1, 0.07, -0.11, 1.61, 4.24, -150.2)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-240",
    cx: 574.31,
    cy: 310.78,
    r: 11.46,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-241",
    cx: 586.19,
    cy: 265.21,
    r: 45.13,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-242",
    cx: 591.54,
    cy: 291.65,
    r: 11.48,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-243",
    cx: 588.65,
    cy: 298.56,
    r: 7.94,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-244",
    cx: 586.89,
    cy: 313,
    r: 6.72,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-245",
    cx: 588.29,
    cy: 289.71,
    r: 22.02,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-246",
    cx: 559.47,
    cy: 268.8,
    r: 32.19,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-247",
    cx: 561.4,
    cy: 295.91,
    r: 7.78,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-248",
    cx: 563.18,
    cy: 279.13,
    r: 19.52,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-249",
    cx: 571.83,
    cy: 288.38,
    r: 5.69,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-250",
    cx: 561.61,
    cy: 289.23,
    r: 29.05,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-251",
    cx: 562.91,
    cy: 305.18,
    r: 7.62,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-252",
    cx: 570.1,
    cy: 316.14,
    r: 6.41,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-253",
    cx: 562.51,
    cy: 304.71,
    r: 14.11,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-254",
    cx: 49.16,
    cy: -451.14,
    r: 38.93,
    gradientTransform: "translate(-179.53 188.68) rotate(61.87)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-255",
    cx: 49.16,
    cy: -447.85,
    r: 36.44,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-256",
    cx: 50.21,
    cy: -442.58,
    r: 30.62,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-257",
    cx: 51.46,
    cy: -468.39,
    r: 24.01,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-258",
    cx: 53.03,
    cy: -452.57,
    r: 8.07,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-259",
    cx: 56.48,
    cy: -463.59,
    r: 16.73,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-260",
    cx: 27.61,
    cy: -181.3,
    r: 10.9,
    gradientTransform: "matrix(0, 1, -1.62, 0, -52.77, 7.74)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-261",
    cx: 52.64,
    cy: -435.53,
    r: 11.46,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-262",
    cx: 609.46,
    cy: 160.3,
    r: 23.4,
    gradientTransform: "translate(-395.63 156.95) rotate(-25.83)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-263",
    cx: 69.87,
    cy: -454.65,
    r: 11.48,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-264",
    cx: 66.97,
    cy: -447.74,
    r: 7.94,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-265",
    cx: 65.21,
    cy: -433.3,
    r: 6.72,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-266",
    cx: 66.62,
    cy: -456.59,
    r: 22.02,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-267",
    cx: 551.47,
    cy: -75.85,
    r: 20.95,
    gradientTransform: "translate(-315.67 162.57) rotate(-8.29)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-268",
    cx: 39.72,
    cy: -450.39,
    r: 7.78,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-269",
    cx: 41.51,
    cy: -467.18,
    r: 19.52,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-270",
    cx: 50.15,
    cy: -457.93,
    r: 5.69,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-271",
    cx: -494.09,
    cy: -336.38,
    r: 18.66,
    gradientTransform: "matrix(0.08, 1, -1.05, 0.08, -82.71, 540.61)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-272",
    cx: 41.24,
    cy: -441.12,
    r: 7.62,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-273",
    cx: 48.43,
    cy: -430.16,
    r: 6.41,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-274",
    cx: 40.84,
    cy: -441.59,
    r: 14.11,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -103.94, 316.85)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-275",
    cx: 56.23,
    cy: -439.12,
    r: 21.83,
    gradientTransform: "matrix(0.74, 0.68, -0.68, 0.74, -104.81, 315.8)",
    xlinkHref: "#radial-gradient-208"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-276",
    cx: 289.38,
    cy: 250.35,
    r: 48.18,
    gradientTransform: "translate(316 -77.26) rotate(74.06)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-277",
    cx: 289.38,
    cy: 254.42,
    r: 45.11,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-278",
    cx: 290.68,
    cy: 260.95,
    r: 37.9,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-279",
    cx: 292.23,
    cy: 229,
    r: 29.71,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-280",
    cx: 294.17,
    cy: 248.58,
    r: 9.99,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-281",
    cx: 298.44,
    cy: 234.94,
    r: 20.71,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-282",
    cx: 318.45,
    cy: 242.68,
    r: 13.49,
    gradientTransform: "matrix(1, 0.01, -0.02, 1.62, -174.25, -117.72)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-283",
    cx: 293.69,
    cy: 269.68,
    r: 14.18,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-284",
    cx: 41,
    cy: 645.52,
    r: 28.96,
    gradientTransform: "translate(-488.93 130.44) rotate(-71.58)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-285",
    cx: 315.01,
    cy: 246,
    r: 14.22,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-286",
    cx: 311.43,
    cy: 254.56,
    r: 9.83,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-287",
    cx: 309.25,
    cy: 272.43,
    r: 8.32,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-288",
    cx: 310.99,
    cy: 243.6,
    r: 27.25,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-289",
    cx: 155.91,
    cy: 551.7,
    r: 25.94,
    gradientTransform: "translate(-429.32 77.07) rotate(-54.04)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-290",
    cx: 277.7,
    cy: 251.28,
    r: 9.63,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-291",
    cx: 279.91,
    cy: 230.5,
    r: 24.16,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-292",
    cx: 290.61,
    cy: 241.95,
    r: 7.04,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-293",
    cx: 161.87,
    cy: -2.97,
    r: 23.1,
    gradientTransform: "matrix(0.77, 0.64, -0.67, 0.81, 3.99, 174.2)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-294",
    cx: 279.57,
    cy: 262.75,
    r: 9.43,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-295",
    cx: 288.47,
    cy: 276.32,
    r: 7.93,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-296",
    cx: 279.08,
    cy: 262.17,
    r: 17.46,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -170.55, 33.63)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-297",
    cx: 298.13,
    cy: 265.22,
    r: 27.02,
    gradientTransform: "matrix(0.71, 0.7, -0.7, 0.71, 116.98, -116.35)",
    xlinkHref: "#radial-gradient-182"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-298",
    cx: 888.93,
    cy: 78.46,
    r: 35.64,
    gradientTransform: "translate(275.02 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-299",
    cx: 888.93,
    cy: 81.47,
    r: 33.36,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-300",
    cx: 889.89,
    cy: 86.3,
    r: 28.03,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-301",
    cx: 891.03,
    cy: 62.67,
    r: 21.98,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-302",
    cx: 892.48,
    cy: 77.15,
    r: 7.39,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-303",
    cx: 895.63,
    cy: 67.06,
    r: 15.32,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-304",
    cx: 903.52,
    cy: 107.84,
    r: 9.98,
    gradientTransform: "matrix(0.61, 0.79, -1.28, 0.99, 275.26, -744.76)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-305",
    cx: 892.11,
    cy: 92.76,
    r: 10.49,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-306",
    cx: 430.85,
    cy: 1136.02,
    r: 21.42,
    gradientTransform: "translate(-115.37 -835.46) rotate(-20.18)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-307",
    cx: 907.89,
    cy: 75.24,
    r: 10.51,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-308",
    cx: 905.24,
    cy: 81.58,
    r: 7.27,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-309",
    cx: 903.63,
    cy: 94.79,
    r: 6.15,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-310",
    cx: 904.91,
    cy: 73.47,
    r: 20.16,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-311",
    cx: 674.9,
    cy: 912.02,
    r: 19.18,
    gradientTransform: "matrix(1, -0.05, 0.05, 1, -36.1, -823.26)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-312",
    cx: 880.29,
    cy: 79.15,
    r: 7.12,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-313",
    cx: 881.92,
    cy: 63.78,
    r: 17.87,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-314",
    cx: 889.84,
    cy: 72.25,
    r: 5.21,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-315",
    cx: 481.24,
    cy: -515.61,
    r: 17.08,
    gradientTransform: "matrix(-0.02, 1, -1.05, -0.02, 159.26, -423.36)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-316",
    cx: 881.67,
    cy: 87.63,
    r: 6.97,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-317",
    cx: 888.26,
    cy: 97.66,
    r: 5.87,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-318",
    cx: 881.31,
    cy: 87.2,
    r: 12.92,
    gradientTransform: "translate(160.7 -647.53) rotate(48.13)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-319",
    cx: 895.4,
    cy: 89.46,
    r: 19.98,
    gradientTransform: "translate(436.08 -783.61) rotate(67.79)",
    xlinkHref: "#radial-gradient-182"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-320",
    cx: 66.59,
    cy: 280.7,
    r: 276.81,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-321",
    cx: 70.24,
    cy: 394.97,
    r: 0.34,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-322",
    cx: 70.07,
    cy: 395.5,
    r: 0.3,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-323",
    cx: 70.44,
    cy: 394.24,
    r: 0.5,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-324",
    cx: 74.68,
    cy: 365.42,
    r: 1.17,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-325",
    cx: 69.73,
    cy: 396.59,
    r: 0.1,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-326",
    cx: 70.65,
    cy: 393.49,
    r: 0.62,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-327",
    cx: 69.92,
    cy: 395.92,
    r: 0.3,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-328",
    cx: 69.81,
    cy: 396.33,
    r: 0.17,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-329",
    cx: 71.14,
    cy: 391.81,
    r: 0.59,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-330",
    cx: 72.81,
    cy: 384.57,
    r: 0.86,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-331",
    cx: 72.25,
    cy: 387.21,
    r: 0.89,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-332",
    cx: 70.89,
    cy: 392.72,
    r: 0.52,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-333",
    cx: 72.52,
    cy: 385.85,
    r: 1.08,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-334",
    cx: 77.81,
    cy: 394.14,
    r: 7.67,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-335",
    cx: 71.41,
    cy: 390.65,
    r: 0.84,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-336",
    cx: 71.68,
    cy: 389.65,
    r: 0.76,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-337",
    cx: 71.96,
    cy: 388.56,
    r: 0.69,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-338",
    cx: 127.79,
    cy: 457.85,
    r: 0.55,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-339",
    cx: 126.88,
    cy: 458.13,
    r: 0.28,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-340",
    cx: 129.24,
    cy: 457.49,
    r: 0.81,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-341",
    cx: 126.53,
    cy: 458.29,
    r: 0.03,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-342",
    cx: 197.4,
    cy: 483.65,
    r: 1.39,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-343",
    cx: 156.45,
    cy: 455.89,
    r: 48.6,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-344",
    cx: 198.58,
    cy: 485.71,
    r: 1.1,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-345",
    cx: 131.18,
    cy: 457.12,
    r: 1.03,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-346",
    cx: 126.54,
    cy: 458.2,
    r: 0.05,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-347",
    cx: 69.69,
    cy: 396.72,
    r: 0.04,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-348",
    cx: 126.66,
    cy: 457.9,
    r: 0.17,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-349",
    cx: 126.97,
    cy: 456.89,
    r: 0.8,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-350",
    cx: 98.74,
    cy: 393.61,
    r: 62.52,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-351",
    cx: 136.42,
    cy: 456.45,
    r: 1.36,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-352",
    cx: 133.59,
    cy: 456.75,
    r: 1.21,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-353",
    cx: 142.24,
    cy: 456.2,
    r: 0.78,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-354",
    cx: 139.61,
    cy: 456.25,
    r: 1.49,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-355",
    cx: 74.6,
    cy: 369.04,
    r: 1.56,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-356",
    cx: -4.56,
    cy: 283.19,
    r: 0.46,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-357",
    cx: -3.41,
    cy: 283.28,
    r: 0.46,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-358",
    cx: -7.58,
    cy: 282.96,
    r: 2.16,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-359",
    cx: -10.41,
    cy: 282.95,
    r: 0.32,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-360",
    cx: 73.07,
    cy: 383.15,
    r: 0.89,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-361",
    cx: 4.31,
    cy: 284.31,
    r: 0.61,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-362",
    cx: -2.21,
    cy: 283.4,
    r: 0.5,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-363",
    cx: 0.98,
    cy: 283.52,
    r: 2.41,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-364",
    cx: -15.35,
    cy: 283.1,
    r: 0.08,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-365",
    cx: 5.74,
    cy: 284.59,
    r: 0.58,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-366",
    cx: -15.57,
    cy: 283.12,
    r: 0.06,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-367",
    cx: -15.07,
    cy: 283.08,
    r: 0.1,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-368",
    cx: -11.93,
    cy: 282.95,
    r: 0.27,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-369",
    cx: -15.71,
    cy: 283.14,
    r: 0.03,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-370",
    cx: -12.62,
    cy: 282.96,
    r: 0.27,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-371",
    cx: -14.71,
    cy: 283.05,
    r: 0.13,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-372",
    cx: -13.72,
    cy: 282.98,
    r: 0.69,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-373",
    cx: -11.2,
    cy: 282.95,
    r: 0.28,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-374",
    cx: 74.2,
    cy: 374.73,
    r: 1.43,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-375",
    cx: 74.02,
    cy: 376.61,
    r: 1.16,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-376",
    cx: 74.37,
    cy: 373.07,
    r: 1.13,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-377",
    cx: 74.5,
    cy: 371.28,
    r: 1.11,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-378",
    cx: 74.65,
    cy: 367.27,
    r: 1.52,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-379",
    cx: 7.18,
    cy: 284.88,
    r: 0.59,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-380",
    cx: 73.58,
    cy: 379.93,
    r: 1.17,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-381",
    cx: 73.81,
    cy: 378.39,
    r: 0.97,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-382",
    cx: 73.34,
    cy: 381.38,
    r: 1.25,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-383",
    cx: 74.66,
    cy: 363.36,
    r: 1.31,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-384",
    cx: 8.66,
    cy: 285.2,
    r: 0.64,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-385",
    cx: 74.08,
    cy: 354.61,
    r: 1.74,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-386",
    cx: 41.3,
    cy: 284.75,
    r: 94.22,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-387",
    cx: 74.59,
    cy: 361.08,
    r: 1.67,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-388",
    cx: 74.31,
    cy: 357.14,
    r: 1.25,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-389",
    cx: 74.48,
    cy: 359.17,
    r: 1.33,
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-390",
    cx: -799.5,
    cy: 280.7,
    r: 276.81,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-391",
    cx: -795.86,
    cy: 394.97,
    r: 0.34,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-392",
    cx: -796.03,
    cy: 395.5,
    r: 0.3,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-393",
    cx: -795.66,
    cy: 394.24,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-394",
    cx: -791.42,
    cy: 365.42,
    r: 1.17,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-395",
    cx: -796.37,
    cy: 396.59,
    r: 0.1,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-396",
    cx: -795.45,
    cy: 393.49,
    r: 0.62,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-397",
    cx: -796.17,
    cy: 395.92,
    r: 0.3,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-398",
    cx: -796.29,
    cy: 396.33,
    r: 0.17,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-399",
    cx: -794.96,
    cy: 391.81,
    r: 0.59,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-400",
    cx: -793.29,
    cy: 384.57,
    r: 0.86,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-401",
    cx: -793.85,
    cy: 387.21,
    r: 0.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-402",
    cx: -795.2,
    cy: 392.72,
    r: 0.52,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-403",
    cx: -793.58,
    cy: 385.85,
    r: 1.08,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-404",
    cx: -788.28,
    cy: 394.14,
    r: 7.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-405",
    cx: -794.68,
    cy: 390.65,
    r: 0.84,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-406",
    cx: -794.41,
    cy: 389.65,
    r: 0.76,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-407",
    cx: -794.13,
    cy: 388.56,
    r: 0.69,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-408",
    cx: -738.31,
    cy: 457.85,
    r: 0.55,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-409",
    cx: -739.22,
    cy: 458.13,
    r: 0.28,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-410",
    cx: -736.86,
    cy: 457.49,
    r: 0.81,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-411",
    cx: -739.57,
    cy: 458.29,
    r: 0.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-412",
    cx: -668.69,
    cy: 483.65,
    r: 1.39,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-413",
    cx: -709.64,
    cy: 455.89,
    r: 48.6,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-414",
    cx: -667.52,
    cy: 485.71,
    r: 1.1,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-415",
    cx: -734.91,
    cy: 457.12,
    r: 1.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-416",
    cx: -739.55,
    cy: 458.2,
    r: 0.05,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-417",
    cx: -796.4,
    cy: 396.72,
    r: 0.04,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-418",
    cx: -739.44,
    cy: 457.9,
    r: 0.17,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-419",
    cx: -739.12,
    cy: 456.89,
    r: 0.8,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-420",
    cx: -767.36,
    cy: 393.61,
    r: 62.52,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-421",
    cx: -729.68,
    cy: 456.45,
    r: 1.36,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-422",
    cx: -732.5,
    cy: 456.75,
    r: 1.21,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-423",
    cx: -723.85,
    cy: 456.2,
    r: 0.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-424",
    cx: -726.48,
    cy: 456.25,
    r: 1.49,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-425",
    cx: -791.5,
    cy: 369.04,
    r: 1.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-426",
    cx: -870.65,
    cy: 283.19,
    r: 0.46,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-427",
    cx: -869.51,
    cy: 283.28,
    r: 0.46,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-428",
    cx: -873.68,
    cy: 282.96,
    r: 2.16,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-429",
    cx: -876.5,
    cy: 282.95,
    r: 0.32,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-430",
    cx: -793.02,
    cy: 383.15,
    r: 0.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-431",
    cx: -861.79,
    cy: 284.31,
    r: 0.61,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-432",
    cx: -868.31,
    cy: 283.4,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-433",
    cx: -865.11,
    cy: 283.52,
    r: 2.41,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-434",
    cx: -881.44,
    cy: 283.1,
    r: 0.08,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-435",
    cx: -860.35,
    cy: 284.59,
    r: 0.58,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-436",
    cx: -881.67,
    cy: 283.12,
    r: 0.06,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-437",
    cx: -881.16,
    cy: 283.08,
    r: 0.1,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-438",
    cx: -878.02,
    cy: 282.95,
    r: 0.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-439",
    cx: -881.8,
    cy: 283.14,
    r: 0.03,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-440",
    cx: -878.71,
    cy: 282.96,
    r: 0.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-441",
    cx: -880.8,
    cy: 283.05,
    r: 0.13,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-442",
    cx: -879.81,
    cy: 282.98,
    r: 0.69,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-443",
    cx: -877.3,
    cy: 282.95,
    r: 0.28,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-444",
    cx: -791.89,
    cy: 374.73,
    r: 1.43,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-445",
    cx: -792.08,
    cy: 376.61,
    r: 1.16,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-446",
    cx: -791.73,
    cy: 373.07,
    r: 1.13,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-447",
    cx: -791.6,
    cy: 371.28,
    r: 1.11,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-448",
    cx: -791.44,
    cy: 367.27,
    r: 1.52,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-449",
    cx: -858.91,
    cy: 284.88,
    r: 0.59,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-450",
    cx: -792.52,
    cy: 379.93,
    r: 1.17,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-451",
    cx: -792.29,
    cy: 378.39,
    r: 0.97,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-452",
    cx: -792.75,
    cy: 381.38,
    r: 1.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-453",
    cx: -791.44,
    cy: 363.36,
    r: 1.31,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-454",
    cx: -857.44,
    cy: 285.2,
    r: 0.64,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-455",
    cx: -792.02,
    cy: 354.61,
    r: 1.74,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-456",
    cx: -824.79,
    cy: 284.75,
    r: 94.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-457",
    cx: -791.5,
    cy: 361.08,
    r: 1.67,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-458",
    cx: -791.78,
    cy: 357.14,
    r: 1.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-459",
    cx: -791.62,
    cy: 359.17,
    r: 1.33,
    gradientTransform: "matrix(-1, 0, 0, 1, -116.15, 0)",
    xlinkHref: "#radial-gradient-175"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 114.32,
    width: 750,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M600.88,150.68a13.78,13.78,0,0,1-1.48,2.71,13.77,13.77,0,0,1-2.7,1.48,14.34,14.34,0,0,1,2.7,1.48,14.07,14.07,0,0,1,1.48,2.71,14.25,14.25,0,0,1,1.49-2.71,14.34,14.34,0,0,1,2.7-1.48,13.77,13.77,0,0,1-2.7-1.48A14,14,0,0,1,600.88,150.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M576.37,54.42a14.66,14.66,0,0,1-1.48,2.71,14.66,14.66,0,0,1-2.71,1.48,14.07,14.07,0,0,1,2.71,1.48,14.66,14.66,0,0,1,1.48,2.71,14.07,14.07,0,0,1,1.48-2.71,13.77,13.77,0,0,1,2.7-1.48,14.34,14.34,0,0,1-2.7-1.48A14.07,14.07,0,0,1,576.37,54.42Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M443.55,136.84a14.07,14.07,0,0,1-1.48,2.71,14.34,14.34,0,0,1-2.7,1.48,13.77,13.77,0,0,1,2.7,1.48,13.77,13.77,0,0,1,1.48,2.7,14.34,14.34,0,0,1,1.48-2.7,14.07,14.07,0,0,1,2.71-1.48,14.66,14.66,0,0,1-2.71-1.48A14.66,14.66,0,0,1,443.55,136.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440,90.73s-1.56,3.61-2.47,4.51S433,97.71,433,97.71s3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51,1.56-3.6,2.47-4.51S447,97.71,447,97.71s-3.6-1.56-4.51-2.47S440,90.73,440,90.73Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M503.61,185.49s-1.56,3.6-2.47,4.51-4.51,2.47-4.51,2.47,3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51,1.56-3.6,2.47-4.51,4.51-2.47,4.51-2.47-3.6-1.56-4.51-2.47S503.61,185.49,503.61,185.49Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.61,82.35s-1.56,3.61-2.47,4.52a24.1,24.1,0,0,1-4.51,2.46s3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51,1.56-3.6,2.47-4.51,4.51-2.47,4.51-2.47a24.1,24.1,0,0,1-4.51-2.46C615.17,86,613.61,82.35,613.61,82.35Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.52,270.51a14.34,14.34,0,0,1-1.48,2.7,14.07,14.07,0,0,1-2.71,1.48,14.25,14.25,0,0,1,2.71,1.49,14.34,14.34,0,0,1,1.48,2.7,13.77,13.77,0,0,1,1.48-2.7,14,14,0,0,1,2.71-1.49,13.78,13.78,0,0,1-2.71-1.48A13.77,13.77,0,0,1,173.52,270.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.88,172.28A14.66,14.66,0,0,1,160.4,175a14.07,14.07,0,0,1-2.71,1.48A14.66,14.66,0,0,1,160.4,178a14.66,14.66,0,0,1,1.48,2.71,14.07,14.07,0,0,1,1.48-2.71,14.66,14.66,0,0,1,2.71-1.48,14.07,14.07,0,0,1-2.71-1.48A14.07,14.07,0,0,1,161.88,172.28Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514.88,151.07a10.3,10.3,0,0,1-1.08,2,10.39,10.39,0,0,1-2,1.07,10.39,10.39,0,0,1,2,1.07,10.3,10.3,0,0,1,1.08,2,10.71,10.71,0,0,1,1.07-2,10.71,10.71,0,0,1,2-1.07,10.71,10.71,0,0,1-2-1.07A10.71,10.71,0,0,1,514.88,151.07Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.64,80.56a10.7,10.7,0,0,1-1.07,2,10.12,10.12,0,0,1-2,1.07,10.3,10.3,0,0,1,2,1.08,10.39,10.39,0,0,1,1.07,2,10,10,0,0,1,1.08-2,10,10,0,0,1,2-1.08,9.83,9.83,0,0,1-2-1.07A10.29,10.29,0,0,1,512.64,80.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.8,249.27a10.3,10.3,0,0,1-1.08,2,10.39,10.39,0,0,1-2,1.07,10,10,0,0,1,2,1.08,10,10,0,0,1,1.08,2,9.83,9.83,0,0,1,1.07-2,10.29,10.29,0,0,1,2-1.08,10.7,10.7,0,0,1-2-1.07A10.12,10.12,0,0,1,236.8,249.27Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.23,213.31a17.16,17.16,0,0,1-1.79,3.27,17.16,17.16,0,0,1-3.27,1.79,17.34,17.34,0,0,1,3.27,1.8,16.86,16.86,0,0,1,1.79,3.27,16.86,16.86,0,0,1,1.79-3.27,17.35,17.35,0,0,1,3.28-1.8,17.17,17.17,0,0,1-3.28-1.79A17.16,17.16,0,0,1,208.23,213.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M249.44,33.78a17.16,17.16,0,0,1-1.79,3.27,17.34,17.34,0,0,1-3.27,1.8,17.16,17.16,0,0,1,3.27,1.79,17.16,17.16,0,0,1,1.79,3.27,17.16,17.16,0,0,1,1.79-3.27,17.17,17.17,0,0,1,3.28-1.79,17.35,17.35,0,0,1-3.28-1.8A17.16,17.16,0,0,1,249.44,33.78Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M226,275.4a17.16,17.16,0,0,1-1.79,3.27,17.16,17.16,0,0,1-3.27,1.79,17.16,17.16,0,0,1,3.27,1.79,17.17,17.17,0,0,1,1.79,3.28,17.35,17.35,0,0,1,1.8-3.28,16.86,16.86,0,0,1,3.27-1.79,16.86,16.86,0,0,1-3.27-1.79A17.34,17.34,0,0,1,226,275.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M522.5,211.62a17.34,17.34,0,0,1-1.8,3.27,17.16,17.16,0,0,1-3.27,1.79,17.16,17.16,0,0,1,3.27,1.79,17.35,17.35,0,0,1,1.8,3.28,17.17,17.17,0,0,1,1.79-3.28,17.16,17.16,0,0,1,3.27-1.79,17.16,17.16,0,0,1-3.27-1.79A17.16,17.16,0,0,1,522.5,211.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.86,130.56a10.31,10.31,0,0,1-.63-2.15,10.31,10.31,0,0,1,.63-2.15,10.31,10.31,0,0,1-2.15.63,10.18,10.18,0,0,1-2.14-.63,10.44,10.44,0,0,1,.62,2.15,10.44,10.44,0,0,1-.62,2.15,10.18,10.18,0,0,1,2.14-.63A10.31,10.31,0,0,1,283.86,130.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.23,175a10.31,10.31,0,0,1-.63-2.15,10.31,10.31,0,0,1,.63-2.15,10.31,10.31,0,0,1-2.15.63,10.31,10.31,0,0,1-2.15-.63,10.31,10.31,0,0,1,.63,2.15,10.31,10.31,0,0,1-.63,2.15,10.31,10.31,0,0,1,2.15-.63A10.31,10.31,0,0,1,340.23,175Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M362.51,67.36a10.31,10.31,0,0,1-.63-2.15,10.31,10.31,0,0,1,.63-2.15,10.18,10.18,0,0,1-2.14.63,10.31,10.31,0,0,1-2.15-.63,10.31,10.31,0,0,1,.63,2.15,10.31,10.31,0,0,1-.63,2.15,10.31,10.31,0,0,1,2.15-.63A10.18,10.18,0,0,1,362.51,67.36Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M587.41,25.91a17.21,17.21,0,0,1-1-3.58,17.15,17.15,0,0,1,1-3.59,17.21,17.21,0,0,1-3.58,1.05,17.21,17.21,0,0,1-3.58-1.05,17.15,17.15,0,0,1,1,3.59,17.21,17.21,0,0,1-1,3.58,17.21,17.21,0,0,1,3.58-1.05A17.21,17.21,0,0,1,587.41,25.91Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.69,41.23a17.33,17.33,0,0,1-1-3.58,17.33,17.33,0,0,1,1-3.58,17,17,0,0,1-3.58,1,17.21,17.21,0,0,1-3.58-1,17.21,17.21,0,0,1,1.05,3.58,17.21,17.21,0,0,1-1.05,3.58,17.21,17.21,0,0,1,3.58-1A17,17,0,0,1,351.69,41.23Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M306.79,179.76a17.21,17.21,0,0,1-1.05-3.58,17.21,17.21,0,0,1,1.05-3.58,17.21,17.21,0,0,1-3.58,1.05,17.21,17.21,0,0,1-3.58-1.05,17.21,17.21,0,0,1,1.05,3.58,17.21,17.21,0,0,1-1.05,3.58,17.21,17.21,0,0,1,3.58-1A17.21,17.21,0,0,1,306.79,179.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.42,72.44a14.31,14.31,0,0,1-.86-3,14.31,14.31,0,0,1,.86-3,14.18,14.18,0,0,1-3,.87,14.18,14.18,0,0,1-3-.87,14.18,14.18,0,0,1,.87,3,14.18,14.18,0,0,1-.87,3,14.31,14.31,0,0,1,3-.86A14.31,14.31,0,0,1,172.42,72.44Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M212.48,98.66S211,95,211,93.72s1.44-4.94,1.44-4.94-3.65,1.45-4.93,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.94-1.45,4.94,3.65-1.45,4.94-1.45S212.48,98.66,212.48,98.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.51,36.44s-1.44-3.65-1.44-4.93,1.44-4.94,1.44-4.94S153.86,28,152.58,28s-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93S151.29,35,152.58,35,157.51,36.44,157.51,36.44Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M472.32,254.26a14.31,14.31,0,0,1-.86-3,14.31,14.31,0,0,1,.86-3,14.18,14.18,0,0,1-3,.87,14.18,14.18,0,0,1-3-.87,14.18,14.18,0,0,1,.87,3,14.18,14.18,0,0,1-.87,3,14.31,14.31,0,0,1,3-.86A14.31,14.31,0,0,1,472.32,254.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M553.17,265.32a14.18,14.18,0,0,1-.87-3,14.18,14.18,0,0,1,.87-3,5.49,5.49,0,0,1-5.93,0,14.18,14.18,0,0,1,.87,3,14.18,14.18,0,0,1-.87,3,5.49,5.49,0,0,1,5.93,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.23,291.53s-1.45-3.65-1.45-4.93,1.45-4.94,1.45-4.94-3.65,1.45-4.94,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93,3.65-1.44,4.94-1.44S593.23,291.53,593.23,291.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.31,234.32s-1.44-3.65-1.44-4.93,1.44-4.94,1.44-4.94-3.65,1.45-4.93,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93,3.65-1.44,4.94-1.44S583.31,234.32,583.31,234.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M503.92,322.07s-1.44-3.65-1.44-4.93,1.44-4.94,1.44-4.94-3.65,1.45-4.93,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93,3.65-1.44,4.94-1.44S503.92,322.07,503.92,322.07Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M450,167.68a2.34,2.34,0,1,1,2.34-2.34A2.33,2.33,0,0,1,450,167.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M494.16,40.43a8.25,8.25,0,0,0-.82-1.51,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,7.93,7.93,0,0,0,.82-1.5,7.93,7.93,0,0,0,.82,1.5,8.25,8.25,0,0,0,1.51.82,8.25,8.25,0,0,0-1.51.82A8.25,8.25,0,0,0,494.16,40.43Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M429.92,85.12a8.25,8.25,0,0,0-.82-1.51,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,7.93,7.93,0,0,0,.82-1.5,7.93,7.93,0,0,0,.82,1.5,8.25,8.25,0,0,0,1.51.82,8.25,8.25,0,0,0-1.51.82A8.25,8.25,0,0,0,429.92,85.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M455.72,116.13a8.25,8.25,0,0,0-.82-1.51,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,7.93,7.93,0,0,0,.82-1.5,7.55,7.55,0,0,0,.83,1.5,7.93,7.93,0,0,0,1.5.82,7.93,7.93,0,0,0-1.5.82A7.84,7.84,0,0,0,455.72,116.13Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M620,186a7.55,7.55,0,0,0-.83-1.5,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,7.84,7.84,0,0,0,.83-1.51,8.25,8.25,0,0,0,.82,1.51,7.93,7.93,0,0,0,1.5.82,7.93,7.93,0,0,0-1.5.82A7.93,7.93,0,0,0,620,186Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M580.09,82.81a7.93,7.93,0,0,0-.82-1.5,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,8.25,8.25,0,0,0,.82-1.51,8.25,8.25,0,0,0,.82,1.51,8.25,8.25,0,0,0,1.51.82,8.25,8.25,0,0,0-1.51.82A7.93,7.93,0,0,0,580.09,82.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M588.5,115.83a.78.78,0,0,1,.78.78.78.78,0,0,1-1.56,0A.78.78,0,0,1,588.5,115.83ZM580,103.91a1.56,1.56,0,1,0,1.55-1.55A1.55,1.55,0,0,0,580,103.91Zm-4.67,20.21a3.11,3.11,0,1,0,3.11-3.11A3.11,3.11,0,0,0,575.28,124.12Zm28.51,2.07a1.55,1.55,0,1,0,1.55-1.55A1.55,1.55,0,0,0,603.79,126.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M457,62.39a.78.78,0,0,1-.71-.84.78.78,0,1,1,1.55.13A.8.8,0,0,1,457,62.39Zm7.5,12.6a1.55,1.55,0,1,0-1.68,1.41A1.54,1.54,0,0,0,464.45,75Zm6.37-19.74a3.11,3.11,0,1,0-3.37,2.83A3.12,3.12,0,0,0,470.82,55.25Zm-28.23-4.49a1.55,1.55,0,1,0-1.68,1.42A1.55,1.55,0,0,0,442.59,50.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M192.58,305.86a8.25,8.25,0,0,0-.82-1.51,8.25,8.25,0,0,0-1.51-.82,8.25,8.25,0,0,0,1.51-.82,7.93,7.93,0,0,0,.82-1.5,3,3,0,0,0,2.33,2.32,7.94,7.94,0,0,0-1.51.82A8.25,8.25,0,0,0,192.58,305.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M165.6,200.68a7.94,7.94,0,0,0-.82-1.51,7.93,7.93,0,0,0-1.5-.82,7.93,7.93,0,0,0,1.5-.82,8.25,8.25,0,0,0,.82-1.51,7.84,7.84,0,0,0,.83,1.51,7.93,7.93,0,0,0,1.5.82,7.93,7.93,0,0,0-1.5.82A7.56,7.56,0,0,0,165.6,200.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M180.22,234.45a.77.77,0,0,1,.78.77.78.78,0,0,1-1.56,0A.77.77,0,0,1,180.22,234.45Zm-8.55-11.92a1.56,1.56,0,1,0,1.55-1.56A1.55,1.55,0,0,0,171.67,222.53ZM167,242.74a3.11,3.11,0,1,0,3.11-3.11A3.11,3.11,0,0,0,167,242.74Zm28.5,2.07a1.56,1.56,0,0,0,3.11,0,1.56,1.56,0,1,0-3.11,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M286.55,44a.77.77,0,0,1,.78.77.78.78,0,0,1-1.56,0A.77.77,0,0,1,286.55,44ZM278,32.09a1.56,1.56,0,1,0,1.55-1.56A1.55,1.55,0,0,0,278,32.09ZM273.34,52.3a3.11,3.11,0,1,0,3.11-3.11A3.11,3.11,0,0,0,273.34,52.3Zm28.5,2.07a1.56,1.56,0,1,0,1.55-1.55A1.54,1.54,0,0,0,301.84,54.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M241.45,271.65a1.7,1.7,0,1,1,1.69-1.7A1.7,1.7,0,0,1,241.45,271.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269,178.77a5.6,5.6,0,0,0-.59-1.09,5.79,5.79,0,0,0-1.1-.6A2.17,2.17,0,0,0,269,175.4a5.78,5.78,0,0,0,.6,1.09,5.6,5.6,0,0,0,1.09.59,2.23,2.23,0,0,0-1.69,1.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M222.4,211.2a2.23,2.23,0,0,0-1.69-1.69,2.23,2.23,0,0,0,1.69-1.69,2.23,2.23,0,0,0,1.69,1.69,2.23,2.23,0,0,0-1.69,1.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M245.63,234.25a2.23,2.23,0,0,0-1.69-1.69,2.23,2.23,0,0,0,1.69-1.69,5.6,5.6,0,0,0,.59,1.09,5.78,5.78,0,0,0,1.09.6,5.78,5.78,0,0,0-1.09.6A5.6,5.6,0,0,0,245.63,234.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M430.59,280.56a6.22,6.22,0,0,0-.59-1.09,5.79,5.79,0,0,0-1.1-.6,5.61,5.61,0,0,0,1.1-.59,6.22,6.22,0,0,0,.59-1.09,5.78,5.78,0,0,0,.6,1.09,5.6,5.6,0,0,0,1.09.59,2.23,2.23,0,0,0-1.69,1.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M515.34,101.16a5.6,5.6,0,0,0-.59-1.09,5.78,5.78,0,0,0-1.09-.6,5.78,5.78,0,0,0,1.09-.6,5.6,5.6,0,0,0,.59-1.09,5.78,5.78,0,0,0,.6,1.09,5.78,5.78,0,0,0,1.09.6,5.78,5.78,0,0,0-1.09.6A5.78,5.78,0,0,0,515.34,101.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M519.74,124.91a.56.56,0,1,1-.56.56A.56.56,0,0,1,519.74,124.91Zm-6.2-8.65a1.13,1.13,0,1,0,1.12-1.13A1.13,1.13,0,0,0,513.54,116.26Zm-3.39,14.66a2.26,2.26,0,1,0,2.26-2.25A2.26,2.26,0,0,0,510.15,130.92Zm20.68,1.51A1.13,1.13,0,1,0,532,131.3,1.13,1.13,0,0,0,530.83,132.43Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M242,194.7a.57.57,0,0,1-.52-.61.56.56,0,0,1,.61-.51.58.58,0,0,1,.52.61A.56.56,0,0,1,242,194.7Zm5.45,9.15a1.13,1.13,0,0,0-1-1.22,1.12,1.12,0,0,0-1.22,1,1.13,1.13,0,0,0,2.25.19Zm4.61-14.33a2.25,2.25,0,1,0-2.44,2.06A2.25,2.25,0,0,0,252.07,189.52Zm-20.48-3.25a1.12,1.12,0,0,0-1-1.22,1.13,1.13,0,0,0-1.22,1,1.12,1.12,0,1,0,2.24.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M343.4,54.82a1.7,1.7,0,1,1,0,2.4A1.7,1.7,0,0,1,343.4,54.82Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M389.59,140a2.2,2.2,0,0,0,2.38,0,5.69,5.69,0,0,0-.35,1.19,5.83,5.83,0,0,0,.35,1.2,2.2,2.2,0,0,0-2.38,0,5.83,5.83,0,0,0,.35-1.2A5.69,5.69,0,0,0,389.59,140Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M595.45,23.63a5.69,5.69,0,0,0,1.19.35,5.83,5.83,0,0,0,1.2-.35,5.83,5.83,0,0,0-.35,1.2,5.69,5.69,0,0,0,.35,1.19,5.83,5.83,0,0,0-1.2-.35,5.69,5.69,0,0,0-1.19.35,5.69,5.69,0,0,0,.35-1.19A5.83,5.83,0,0,0,595.45,23.63Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M562.73,23.76a2.2,2.2,0,0,0,2.38,0,5.69,5.69,0,0,0-.35,1.19,5.83,5.83,0,0,0,.35,1.2,2.2,2.2,0,0,0-2.38,0,5.83,5.83,0,0,0,.35-1.2A5.69,5.69,0,0,0,562.73,23.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M256,122.2a2.2,2.2,0,0,0,2.38,0,5.83,5.83,0,0,0-.35,1.2,5.69,5.69,0,0,0,.35,1.19,2.2,2.2,0,0,0-2.38,0,5.82,5.82,0,0,0,.34-1.19A6,6,0,0,0,256,122.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M323.75,162.33a5.63,5.63,0,0,0,1.2.35,5.69,5.69,0,0,0,1.19-.35,5.69,5.69,0,0,0-.35,1.19,5.83,5.83,0,0,0,.35,1.2,5.69,5.69,0,0,0-1.19-.35,5.63,5.63,0,0,0-1.2.35,5.83,5.83,0,0,0,.35-1.2A5.69,5.69,0,0,0,323.75,162.33Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M298.93,152.5a.57.57,0,1,1,0-.8A.57.57,0,0,1,298.93,152.5Zm10.5,1.73a1.13,1.13,0,1,0,0,1.6A1.13,1.13,0,0,0,309.43,154.23Zm-8-12.76a2.26,2.26,0,1,0,0,3.19A2.26,2.26,0,0,0,301.45,141.47ZM285.77,155a1.13,1.13,0,0,0-1.6,0,1.12,1.12,0,0,0,0,1.59,1.13,1.13,0,0,0,1.6,0A1.12,1.12,0,0,0,285.77,155Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M593.25,49.16a.56.56,0,1,1-.07.8A.57.57,0,0,1,593.25,49.16Zm-10.32-2.61a1.12,1.12,0,0,0,1.59.13,1.13,1.13,0,1,0-1.59-.13Zm6.86,13.39a2.26,2.26,0,1,0,.27-3.18A2.25,2.25,0,0,0,589.79,59.94Zm16.78-12.18a1.13,1.13,0,1,0,.14-1.59A1.13,1.13,0,0,0,606.57,47.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M146.09,55.17a2.34,2.34,0,1,1,0,3.31A2.34,2.34,0,0,1,146.09,55.17Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M209.73,172.55a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,7.82,7.82,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,7.7,7.7,0,0,0-1.64-.49,7.83,7.83,0,0,0-1.65.49,7.83,7.83,0,0,0,.49-1.65A7.7,7.7,0,0,0,209.73,172.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M223.56,95.52a8,8,0,0,0,1.64.48,8,8,0,0,0,1.65-.48,8,8,0,0,0-.48,1.65,8,8,0,0,0,.48,1.64,8,8,0,0,0-1.65-.48,8,8,0,0,0-1.64.48,8,8,0,0,0,.48-1.65A8,8,0,0,0,223.56,95.52Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M178.46,95.69a7.83,7.83,0,0,0,1.65.49,7.7,7.7,0,0,0,1.64-.49,8,8,0,0,0-.48,1.65,7.82,7.82,0,0,0,.48,1.64,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,7.82,7.82,0,0,0,.48-1.64A8,8,0,0,0,178.46,95.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M193.15,142.3a.78.78,0,0,1,1.1.09.78.78,0,1,1-1.19,1A.78.78,0,0,1,193.15,142.3Zm-14.22-3.6a1.56,1.56,0,1,0,.19-2.19A1.55,1.55,0,0,0,178.93,138.7Zm9.47,18.45a3.1,3.1,0,1,0,.37-4.38A3.11,3.11,0,0,0,188.4,157.15Zm23.12-16.78a1.56,1.56,0,1,0,.19-2.19A1.55,1.55,0,0,0,211.52,140.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M526.83,248.05a2.33,2.33,0,1,1,0,3.3A2.34,2.34,0,0,1,526.83,248.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M596.69,366.18a3,3,0,0,0,3.28,0,3.06,3.06,0,0,0,0,3.29,3,3,0,0,0-3.28,0,3.06,3.06,0,0,0,0-3.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M604.3,288.4a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,7.82,7.82,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,8,8,0,0,0,.48-1.65A7.82,7.82,0,0,0,604.3,288.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M559.2,288.57a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,8,8,0,0,0-.48,1.65,7.82,7.82,0,0,0,.48,1.64,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,7.7,7.7,0,0,0,.49-1.64A7.83,7.83,0,0,0,559.2,288.57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M538.17,139.66a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,8,8,0,0,0-.48,1.65,7.82,7.82,0,0,0,.48,1.64,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,7.7,7.7,0,0,0,.49-1.64A7.83,7.83,0,0,0,538.17,139.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M493.08,284.5a.77.77,0,0,1-1.1,0,.78.78,0,1,1,1.1-1.1A.77.77,0,0,1,493.08,284.5Zm14.48,2.38a1.57,1.57,0,0,0-2.2,0,1.56,1.56,0,0,0,2.2,2.2A1.57,1.57,0,0,0,507.56,286.88Zm-11-17.58a3.1,3.1,0,1,0,0,4.39A3.09,3.09,0,0,0,496.56,269.3ZM475,288a1.57,1.57,0,0,0-2.2,0,1.56,1.56,0,0,0,2.2,2.2A1.57,1.57,0,0,0,475,288Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M601.27,323.58a.78.78,0,0,1,1.09.1.77.77,0,0,1-.09,1.09.78.78,0,0,1-1.1-.09A.79.79,0,0,1,601.27,323.58ZM587.05,320a1.55,1.55,0,1,0,.18-2.19A1.55,1.55,0,0,0,587.05,320Zm9.46,18.46a3.11,3.11,0,1,0,.37-4.38A3.11,3.11,0,0,0,596.51,338.44Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M160.94,203.39a2.34,2.34,0,1,1-1.73,2.82A2.33,2.33,0,0,1,160.94,203.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M153.76,336.72a8,8,0,0,0,1.15,1.27,7.59,7.59,0,0,0,1.65.45,8.44,8.44,0,0,0-1.27,1.15,8.23,8.23,0,0,0-.45,1.65,7.91,7.91,0,0,0-1.15-1.27,8.06,8.06,0,0,0-1.65-.45,3.05,3.05,0,0,0,1.72-2.8Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M205.85,278.31a7.5,7.5,0,0,0,1.15,1.27,7.45,7.45,0,0,0,1.65.45,8,8,0,0,0-1.27,1.15,7.64,7.64,0,0,0-.45,1.66,8,8,0,0,0-1.15-1.27,7.59,7.59,0,0,0-1.65-.45A8.44,8.44,0,0,0,205.4,280,8.28,8.28,0,0,0,205.85,278.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M167.32,254.86a8.4,8.4,0,0,0,1.15,1.28,8.28,8.28,0,0,0,1.66.45,3.05,3.05,0,0,0-1.72,2.8,8,8,0,0,0-1.15-1.27,7.64,7.64,0,0,0-1.66-.45,8,8,0,0,0,1.27-1.15A7.64,7.64,0,0,0,167.32,254.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M184.85,306.71a.78.78,0,1,1-.65.88A.77.77,0,0,1,184.85,306.71ZM174.62,296.2a1.55,1.55,0,1,0,1.3-1.77A1.54,1.54,0,0,0,174.62,296.2ZM173,316.88a3.11,3.11,0,1,0,2.61-3.54A3.11,3.11,0,0,0,173,316.88Zm28.49-2.21a1.56,1.56,0,1,0,1.31-1.76A1.56,1.56,0,0,0,201.51,314.67Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M516.47,7a2.33,2.33,0,1,1-1.73,2.82A2.33,2.33,0,0,1,516.47,7Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M503.08,139.59a8.4,8.4,0,0,0,1.15,1.28,8.28,8.28,0,0,0,1.66.45,8.2,8.2,0,0,0-1.28,1.14,8.28,8.28,0,0,0-.45,1.66,7.8,7.8,0,0,0-1.14-1.27,7.64,7.64,0,0,0-1.66-.45,8,8,0,0,0,1.27-1.15A7.64,7.64,0,0,0,503.08,139.59Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M561.38,81.94a7.5,7.5,0,0,0,1.15,1.27,7.45,7.45,0,0,0,1.65.45,8,8,0,0,0-1.27,1.15,7.64,7.64,0,0,0-.45,1.66,8,8,0,0,0-1.15-1.27,7.59,7.59,0,0,0-1.65-.45,8.44,8.44,0,0,0,1.27-1.15A8.28,8.28,0,0,0,561.38,81.94Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M522.85,58.49A8.4,8.4,0,0,0,524,59.77a8.28,8.28,0,0,0,1.66.45,7.8,7.8,0,0,0-1.27,1.14,7.64,7.64,0,0,0-.45,1.66,8,8,0,0,0-1.15-1.27,7.64,7.64,0,0,0-1.66-.45,8,8,0,0,0,1.27-1.15A7.64,7.64,0,0,0,522.85,58.49Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M365.16,23.09a7.5,7.5,0,0,0,1.15,1.27,8.06,8.06,0,0,0,1.65.45A7.91,7.91,0,0,0,366.69,26a8.06,8.06,0,0,0-.45,1.65,7.91,7.91,0,0,0-1.15-1.27,8.06,8.06,0,0,0-1.65-.45,7.5,7.5,0,0,0,1.27-1.15A8.06,8.06,0,0,0,365.16,23.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M611.69,58.65a8.44,8.44,0,0,0,1.15,1.27,8.23,8.23,0,0,0,1.65.45,7.91,7.91,0,0,0-1.27,1.15,8.06,8.06,0,0,0-.45,1.65,7.5,7.5,0,0,0-1.15-1.27,7.45,7.45,0,0,0-1.65-.45,8,8,0,0,0,1.27-1.15A8.23,8.23,0,0,0,611.69,58.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M589.62,29.2a.78.78,0,1,1,.58-.94A.78.78,0,0,1,589.62,29.2Zm11.09,9.6a1.56,1.56,0,1,0-1.15,1.88A1.56,1.56,0,0,0,600.71,38.8Zm-.17-20.74a3.11,3.11,0,1,0-2.3,3.75A3.1,3.1,0,0,0,600.54,18.06Zm-28.2,4.62a1.55,1.55,0,1,0-1.15,1.87A1.55,1.55,0,0,0,572.34,22.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M504.81,225.32a.77.77,0,1,1-.65.88A.77.77,0,0,1,504.81,225.32Zm-10.23-10.51a1.55,1.55,0,1,0,1.31-1.77A1.55,1.55,0,0,0,494.58,214.81ZM493,235.49A3.11,3.11,0,1,0,495.6,232,3.11,3.11,0,0,0,493,235.49Zm28.49-2.21a1.55,1.55,0,1,0,1.3-1.77A1.55,1.55,0,0,0,521.48,233.28Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M325.59,67.73a1.69,1.69,0,1,1-1.26,2A1.69,1.69,0,0,1,325.59,67.73Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M320.38,164.47a5.49,5.49,0,0,0,.84.92,5.88,5.88,0,0,0,1.2.33,5.79,5.79,0,0,0-.92.83,5.42,5.42,0,0,0-.33,1.2,5.49,5.49,0,0,0-.84-.92,5.88,5.88,0,0,0-1.2-.33,6.22,6.22,0,0,0,.93-.83A5.86,5.86,0,0,0,320.38,164.47Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M358.18,122.09a5.79,5.79,0,0,0,.83.92,6.05,6.05,0,0,0,1.2.33,5.79,5.79,0,0,0-.92.83,6.05,6.05,0,0,0-.33,1.2,5.79,5.79,0,0,0-.83-.92,6.05,6.05,0,0,0-1.2-.33,5.79,5.79,0,0,0,.92-.83A6.05,6.05,0,0,0,358.18,122.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M330.22,105.07a5.87,5.87,0,0,0,.84.93,5.7,5.7,0,0,0,1.2.32,5.49,5.49,0,0,0-.92.84,5.28,5.28,0,0,0-.33,1.2,6.22,6.22,0,0,0-.83-.93,5.86,5.86,0,0,0-1.2-.32,5.49,5.49,0,0,0,.92-.84A5.7,5.7,0,0,0,330.22,105.07Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M215.8,79.38a5.87,5.87,0,0,0,.84.93,5.7,5.7,0,0,0,1.2.32,5.87,5.87,0,0,0-.93.84,5.7,5.7,0,0,0-.32,1.2,5.87,5.87,0,0,0-.84-.93,5.7,5.7,0,0,0-1.2-.32,5.87,5.87,0,0,0,.93-.84A5.7,5.7,0,0,0,215.8,79.38Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M225.22,160.65a5.79,5.79,0,0,0,.83.92,5.42,5.42,0,0,0,1.2.33,5.79,5.79,0,0,0-.92.83,5.86,5.86,0,0,0-.32,1.2,5.91,5.91,0,0,0-.84-.92,5.7,5.7,0,0,0-1.2-.32,5.49,5.49,0,0,0,.92-.84A5.28,5.28,0,0,0,225.22,160.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M209.21,139.29a.57.57,0,0,1-.68-.42.56.56,0,0,1,.41-.68.57.57,0,0,1,.68.42A.56.56,0,0,1,209.21,139.29Zm8,7a1.13,1.13,0,1,0-2.19.52,1.13,1.13,0,0,0,2.19-.52Zm-.12-15a2.26,2.26,0,1,0-1.67,2.72A2.25,2.25,0,0,0,217.13,131.21Zm-20.46,3.34a1.13,1.13,0,0,0-1.36-.83,1.13,1.13,0,0,0,.52,2.19A1.13,1.13,0,0,0,196.67,134.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M342.94,142.69a.57.57,0,1,1-.47.64A.57.57,0,0,1,342.94,142.69Zm-7.42-7.62a1.13,1.13,0,0,0,2.23-.34,1.13,1.13,0,1,0-2.23.34Zm-1.16,15a2.26,2.26,0,1,0,1.89-2.57A2.26,2.26,0,0,0,334.36,150.07Zm20.67-1.6a1.13,1.13,0,1,0,1-1.28A1.13,1.13,0,0,0,355,148.47Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M285.28,214.65a.56.56,0,1,1,.17,1.11.56.56,0,0,1-.64-.47A.56.56,0,0,1,285.28,214.65ZM277.86,207a1.13,1.13,0,1,0,.95-1.28A1.13,1.13,0,0,0,277.86,207Zm-1.16,15a2.26,2.26,0,1,0,1.89-2.57A2.26,2.26,0,0,0,276.7,222Zm20.67-1.6a1.13,1.13,0,1,0,2.23-.34,1.13,1.13,0,0,0-2.23.34Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M297,287.65a1.69,1.69,0,1,1-.56-2.33A1.69,1.69,0,0,1,297,287.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M232.31,215.56a5.91,5.91,0,0,0-1.24-.06,5.66,5.66,0,0,0-1.08.62,5.91,5.91,0,0,0,.06-1.24,5.75,5.75,0,0,0-.61-1.08,5.86,5.86,0,0,0,1.24.06,5.66,5.66,0,0,0,1.08-.62,5.81,5.81,0,0,0-.07,1.25A6.09,6.09,0,0,0,232.31,215.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M235.55,272.26a5.7,5.7,0,0,0-1.24-.07,6.27,6.27,0,0,0-1.08.62,5.75,5.75,0,0,0,.07-1.24,6.27,6.27,0,0,0-.62-1.08,5.91,5.91,0,0,0,1.24.06,5.66,5.66,0,0,0,1.08-.62,5.34,5.34,0,0,0-.06,1.25A5.75,5.75,0,0,0,235.55,272.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M267.35,264.52a5.91,5.91,0,0,0-1.24-.06,5.66,5.66,0,0,0-1.08.62,6,6,0,0,0,.06-1.25,5.51,5.51,0,0,0-.62-1.07,6,6,0,0,0,1.25.06,5.66,5.66,0,0,0,1.08-.62,5.75,5.75,0,0,0-.07,1.24A6.27,6.27,0,0,0,267.35,264.52Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M550.41,93.41a5.29,5.29,0,0,0-1.24-.06,5.43,5.43,0,0,0-1.08.61,5.86,5.86,0,0,0,.06-1.24,5.66,5.66,0,0,0-.62-1.08,5.75,5.75,0,0,0,1.24.07,5.89,5.89,0,0,0,1.08-.62,5.91,5.91,0,0,0-.06,1.24A5.66,5.66,0,0,0,550.41,93.41Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M291.14,178.52a5.91,5.91,0,0,0-1.24-.06,5.66,5.66,0,0,0-1.08.62,5.75,5.75,0,0,0,.07-1.24,6.27,6.27,0,0,0-.62-1.08,5.91,5.91,0,0,0,1.24.06,5.66,5.66,0,0,0,1.08-.62,5.34,5.34,0,0,0-.06,1.25A5.59,5.59,0,0,0,291.14,178.52Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M501.56,73.94a.56.56,0,0,1,.77-.19.56.56,0,1,1-.59,1A.55.55,0,0,1,501.56,73.94Zm-10.62.76a1.13,1.13,0,1,0-.37-1.55A1.12,1.12,0,0,0,490.94,74.7Zm10.73,10.56a2.26,2.26,0,1,0-.74-3.11A2.26,2.26,0,0,0,501.67,85.26Zm12.1-16.84a1.13,1.13,0,1,0-.37-1.55A1.12,1.12,0,0,0,513.77,68.42Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M231.76,246.91a.56.56,0,0,1-.79.12.57.57,0,0,1-.12-.79.57.57,0,0,1,.91.67Zm10.64.15a1.13,1.13,0,1,0,.24,1.57A1.13,1.13,0,0,0,242.4,247.06Zm-9.79-11.43a2.26,2.26,0,1,0,.48,3.15A2.25,2.25,0,0,0,232.61,235.63Zm-13.49,15.75a1.13,1.13,0,0,0-1.34,1.81,1.13,1.13,0,0,0,1.58-.24A1.12,1.12,0,0,0,219.12,251.38Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M410.69,55.1a10,10,0,0,1-1.08,2,10,10,0,0,1-2,1.08,9.83,9.83,0,0,1,2,1.07,10.29,10.29,0,0,1,1.08,2,10.7,10.7,0,0,1,1.07-2,10.12,10.12,0,0,1,2-1.07,10.3,10.3,0,0,1-2-1.08A10.39,10.39,0,0,1,410.69,55.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M403.58,21.09a17.17,17.17,0,0,1-1.79,3.28,17.16,17.16,0,0,1-3.27,1.79A17.16,17.16,0,0,1,401.79,28a17.16,17.16,0,0,1,1.79,3.27A17.16,17.16,0,0,1,405.37,28a17.17,17.17,0,0,1,3.28-1.79,17.17,17.17,0,0,1-3.28-1.79A17.17,17.17,0,0,1,403.58,21.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M406.2,21.39a5.7,5.7,0,0,0-1.24-.07,6.27,6.27,0,0,0-1.08.62A5.75,5.75,0,0,0,404,20.7a6.27,6.27,0,0,0-.62-1.08,5.29,5.29,0,0,0,1.24.06,5.75,5.75,0,0,0,1.08-.61,5.91,5.91,0,0,0-.06,1.24A5.75,5.75,0,0,0,406.2,21.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M405.65,52.74a.57.57,0,0,1-.79.12.56.56,0,0,1-.11-.79.55.55,0,0,1,.78-.12A.56.56,0,0,1,405.65,52.74Zm10.65.14a1.13,1.13,0,1,0,.23,1.57A1.12,1.12,0,0,0,416.3,52.88Zm-9.8-11.43A2.25,2.25,0,1,0,407,44.6,2.24,2.24,0,0,0,406.5,41.45ZM393,57.2a1.13,1.13,0,1,0,.23,1.58A1.12,1.12,0,0,0,393,57.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M719.14,95.78s-1.56,3.6-2.47,4.51-4.51,2.47-4.51,2.47,3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51,1.56-3.6,2.47-4.51,4.51-2.47,4.51-2.47-3.6-1.56-4.51-2.47S719.14,95.78,719.14,95.78Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M641.69,72.4a10.31,10.31,0,0,1-.63-2.15,10.31,10.31,0,0,1,.63-2.15,4,4,0,0,1-4.3,0,10.31,10.31,0,0,1,.63,2.15,10.31,10.31,0,0,1-.63,2.15,4,4,0,0,1,4.3,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M709.09,90.16a7.93,7.93,0,0,0-.82-1.5,7.93,7.93,0,0,0-1.5-.82,7.55,7.55,0,0,0,1.5-.83,7.93,7.93,0,0,0,.82-1.5,7.55,7.55,0,0,0,.83,1.5,7.55,7.55,0,0,0,1.5.83,7.93,7.93,0,0,0-1.5.82A7.55,7.55,0,0,0,709.09,90.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M736.12,67.43a.78.78,0,1,1,.84-.71A.77.77,0,0,1,736.12,67.43ZM743.63,80A1.56,1.56,0,1,0,742,81.45,1.56,1.56,0,0,0,743.63,80ZM750,60.29a3.11,3.11,0,1,0-3.36,2.83A3.11,3.11,0,0,0,750,60.29Zm-28.22-4.48a1.56,1.56,0,1,0-1.68,1.41A1.56,1.56,0,0,0,721.77,55.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M644.33,28.13a8,8,0,0,0,1.15,1.27,7.81,7.81,0,0,0,1.66.46A8.2,8.2,0,0,0,645.86,31a8.28,8.28,0,0,0-.45,1.66,7.5,7.5,0,0,0-1.15-1.27,7.45,7.45,0,0,0-1.65-.45,8,8,0,0,0,1.27-1.15A7.64,7.64,0,0,0,644.33,28.13Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M689.86,60.14a10.71,10.71,0,0,1-1.07,2,10.71,10.71,0,0,1-2,1.07,10.71,10.71,0,0,1,2,1.07,10.71,10.71,0,0,1,1.07,2,10.3,10.3,0,0,1,1.08-2,10.39,10.39,0,0,1,2-1.07,10.39,10.39,0,0,1-2-1.07A10.3,10.3,0,0,1,689.86,60.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M682.76,26.14A17.16,17.16,0,0,1,681,29.41a17.17,17.17,0,0,1-3.28,1.79A17.35,17.35,0,0,1,681,33a17.16,17.16,0,0,1,1.79,3.27A17.16,17.16,0,0,1,684.55,33a17.34,17.34,0,0,1,3.27-1.8,17.16,17.16,0,0,1-3.27-1.79A17.16,17.16,0,0,1,682.76,26.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M685.38,26.43a5.91,5.91,0,0,0-1.24-.06,5.36,5.36,0,0,0-1.08.62,5.91,5.91,0,0,0,.06-1.24,5.36,5.36,0,0,0-.62-1.08,5.91,5.91,0,0,0,1.24.06,5.36,5.36,0,0,0,1.08-.62,5.91,5.91,0,0,0-.06,1.24A5.36,5.36,0,0,0,685.38,26.43Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M684.83,57.78a.57.57,0,0,1-.91-.67.57.57,0,1,1,.91.67Zm10.64.14a1.13,1.13,0,1,0,.24,1.58A1.13,1.13,0,0,0,695.47,57.92Zm-9.79-11.43a2.26,2.26,0,1,0,.47,3.16A2.26,2.26,0,0,0,685.68,46.49ZM672.19,62.24a1.13,1.13,0,1,0,.24,1.58A1.13,1.13,0,0,0,672.19,62.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M534.76,333.54a2.33,2.33,0,1,1-.77-3.21A2.34,2.34,0,0,1,534.76,333.54Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M473.11,136a7.88,7.88,0,0,0-1.72-.09,8,8,0,0,0-1.48.85,7.93,7.93,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,3,3,0,0,0,3.2-.76,7.93,7.93,0,0,0-.08,1.71A8.19,8.19,0,0,0,473.11,136Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M477.58,214.16a3,3,0,0,0-3.2.76,7.93,7.93,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,3,3,0,0,0,3.2-.76,7.93,7.93,0,0,0-.08,1.71A8.19,8.19,0,0,0,477.58,214.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M521.4,203.5a3,3,0,0,0-3.2.76,7.93,7.93,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,3,3,0,0,0,3.2-.76,7.93,7.93,0,0,0-.08,1.71A7.85,7.85,0,0,0,521.4,203.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M526.64,183.14a3.06,3.06,0,0,0-3.2.77,8,8,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,3,3,0,0,0,3.2-.76,8.47,8.47,0,0,0-.09,1.71A7.94,7.94,0,0,0,526.64,183.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M582.15,187.15a.78.78,0,0,1,1.07-.25.77.77,0,1,1-.81,1.32A.78.78,0,0,1,582.15,187.15Zm-14.63,1a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,567.52,188.2Zm14.78,14.55a3.11,3.11,0,1,0-1-4.28A3.11,3.11,0,0,0,582.3,202.75ZM599,179.55a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,599,179.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M117,150.37a14.07,14.07,0,0,1-1.48,2.71,14.34,14.34,0,0,1-2.7,1.48,13.77,13.77,0,0,1,2.7,1.48,13.77,13.77,0,0,1,1.48,2.7,14.34,14.34,0,0,1,1.48-2.7,14.07,14.07,0,0,1,2.71-1.48,14.66,14.66,0,0,1-2.71-1.48A14.66,14.66,0,0,1,117,150.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M111.59,52.9a14.07,14.07,0,0,1-1.48,2.71,14.34,14.34,0,0,1-2.7,1.48,13.77,13.77,0,0,1,2.7,1.48,13.77,13.77,0,0,1,1.48,2.7,14,14,0,0,1,1.49-2.7,13.77,13.77,0,0,1,2.7-1.48,14.34,14.34,0,0,1-2.7-1.48A14.25,14.25,0,0,1,111.59,52.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M38.84,184s-1.56,3.6-2.47,4.51S31.86,191,31.86,191s3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51a24.1,24.1,0,0,1,2.46-4.51c.91-.91,4.52-2.47,4.52-2.47s-3.61-1.56-4.52-2.47A24.1,24.1,0,0,1,38.84,184Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.84,80.83s-1.56,3.6-2.47,4.51-4.51,2.47-4.51,2.47,3.6,1.56,4.51,2.47,2.47,4.51,2.47,4.51,1.55-3.6,2.46-4.51,4.52-2.47,4.52-2.47-3.61-1.56-4.52-2.47S148.84,80.83,148.84,80.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M50.11,149.55a10,10,0,0,1-1.08,2,10,10,0,0,1-2,1.08,10.39,10.39,0,0,1,2,1.07,10.3,10.3,0,0,1,1.08,2,10.12,10.12,0,0,1,1.07-2,10.7,10.7,0,0,1,2-1.07,10.29,10.29,0,0,1-2-1.08A9.83,9.83,0,0,1,50.11,149.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M47.87,79a10.71,10.71,0,0,1-1.07,2,10.71,10.71,0,0,1-2,1.07,10.3,10.3,0,0,1,2,1.08,10.39,10.39,0,0,1,1.07,2,10.39,10.39,0,0,1,1.07-2,10.3,10.3,0,0,1,2-1.08,10.71,10.71,0,0,1-2-1.07A10.71,10.71,0,0,1,47.87,79Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M57.72,210.09a17.17,17.17,0,0,1-1.79,3.28,17.16,17.16,0,0,1-3.27,1.79A17.16,17.16,0,0,1,55.93,217a17.16,17.16,0,0,1,1.79,3.27A17.16,17.16,0,0,1,59.51,217a17.17,17.17,0,0,1,3.28-1.79,17.17,17.17,0,0,1-3.28-1.79A17.17,17.17,0,0,1,57.72,210.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.64,24.39a17.15,17.15,0,0,1-1-3.59,17.21,17.21,0,0,1,1-3.58,17.21,17.21,0,0,1-3.58,1.05,17.21,17.21,0,0,1-3.58-1.05,17.21,17.21,0,0,1,1,3.58,17.15,17.15,0,0,1-1,3.59,17.21,17.21,0,0,1,3.58-1.05A17.21,17.21,0,0,1,122.64,24.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M88.39,263.8a14.31,14.31,0,0,1-.86-3,14.31,14.31,0,0,1,.86-3,14.31,14.31,0,0,1-3,.86,14.31,14.31,0,0,1-3-.86,14.18,14.18,0,0,1,.87,3,14.18,14.18,0,0,1-.87,3,14.18,14.18,0,0,1,3-.87A14.18,14.18,0,0,1,88.39,263.8Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M128.45,290s-1.44-3.65-1.44-4.93,1.44-4.94,1.44-4.94-3.65,1.45-4.93,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93,3.65-1.44,4.94-1.44S128.45,290,128.45,290Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M99.45,234S98,230.36,98,229.07s1.44-4.93,1.44-4.93-3.65,1.44-4.93,1.44-4.94-1.44-4.94-1.44S91,227.79,91,229.07,89.58,234,89.58,234s3.65-1.45,4.94-1.45S99.45,234,99.45,234Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M39.15,320.55s-1.44-3.65-1.44-4.94,1.44-4.93,1.44-4.93-3.65,1.44-4.93,1.44-4.94-1.44-4.94-1.44,1.45,3.65,1.45,4.93-1.45,4.94-1.45,4.94,3.65-1.44,4.94-1.44S39.15,320.55,39.15,320.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M29.39,38.91a7.94,7.94,0,0,0-.82-1.51,7.94,7.94,0,0,0-1.51-.82,7.94,7.94,0,0,0,1.51-.82,8.25,8.25,0,0,0,.82-1.51,8.25,8.25,0,0,0,.82,1.51,8.25,8.25,0,0,0,1.51.82,8.25,8.25,0,0,0-1.51.82A7.94,7.94,0,0,0,29.39,38.91Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M136.09,185.72a7.55,7.55,0,0,0-.83-1.5,7.55,7.55,0,0,0-1.5-.83,7.93,7.93,0,0,0,1.5-.82,7.55,7.55,0,0,0,.83-1.5,7.38,7.38,0,0,0,.82,1.5,7.93,7.93,0,0,0,1.5.82,7.55,7.55,0,0,0-1.5.83A7.38,7.38,0,0,0,136.09,185.72Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M115.32,81.29a7.93,7.93,0,0,0-.82-1.5A8.25,8.25,0,0,0,113,79a7.84,7.84,0,0,0,1.51-.83,7.93,7.93,0,0,0,.82-1.5,7.93,7.93,0,0,0,.82,1.5,7.55,7.55,0,0,0,1.5.83,7.93,7.93,0,0,0-1.5.82A7.93,7.93,0,0,0,115.32,81.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M123.73,114.31a.76.76,0,0,1,.77.77.77.77,0,0,1-.77.78.78.78,0,0,1-.78-.78A.77.77,0,0,1,123.73,114.31Zm-8.55-11.92a1.56,1.56,0,0,0,3.11,0,1.56,1.56,0,1,0-3.11,0Zm-4.67,20.21a3.11,3.11,0,1,0,3.11-3.11A3.11,3.11,0,0,0,110.51,122.6Zm28.5,2.07a1.56,1.56,0,1,0,3.11,0,1.56,1.56,0,0,0-3.11,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M50.57,99.64a5.61,5.61,0,0,0-.59-1.1,5.61,5.61,0,0,0-1.1-.59,5.79,5.79,0,0,0,1.1-.6,5.6,5.6,0,0,0,.59-1.09,5.78,5.78,0,0,0,.6,1.09,5.78,5.78,0,0,0,1.09.6,5.6,5.6,0,0,0-1.09.59A5.79,5.79,0,0,0,50.57,99.64Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M55,123.38a.57.57,0,0,1,.56.57.56.56,0,0,1-.56.56.57.57,0,0,1-.57-.56A.58.58,0,0,1,55,123.38Zm-6.21-8.64a1.13,1.13,0,1,0,1.13-1.13A1.13,1.13,0,0,0,48.76,114.74ZM45.38,129.4a2.26,2.26,0,1,0,2.26-2.26A2.26,2.26,0,0,0,45.38,129.4Zm20.68,1.5a1.13,1.13,0,1,0,1.13-1.12A1.13,1.13,0,0,0,66.06,130.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M130.68,22.11a5.69,5.69,0,0,0,1.19.35,5.69,5.69,0,0,0,1.19-.35,5.69,5.69,0,0,0-.35,1.19,5.83,5.83,0,0,0,.35,1.2,5.69,5.69,0,0,0-1.19-.35,5.69,5.69,0,0,0-1.19.35,5.83,5.83,0,0,0,.35-1.2A5.69,5.69,0,0,0,130.68,22.11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M98,22.24a5.83,5.83,0,0,0,1.2.35,5.69,5.69,0,0,0,1.19-.35,5.69,5.69,0,0,0-.35,1.19,5.69,5.69,0,0,0,.35,1.19,5.69,5.69,0,0,0-1.19-.35,5.83,5.83,0,0,0-1.2.35,5.69,5.69,0,0,0,.35-1.19A5.69,5.69,0,0,0,98,22.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M128.47,47.64a.57.57,0,0,1,.8.07.56.56,0,0,1-.86.72A.57.57,0,0,1,128.47,47.64ZM118.16,45a1.13,1.13,0,1,0,.13-1.59A1.13,1.13,0,0,0,118.16,45ZM125,58.42a2.26,2.26,0,1,0,.27-3.18A2.26,2.26,0,0,0,125,58.42ZM141.8,46.24a1.13,1.13,0,0,0,1.73-1.45,1.13,1.13,0,1,0-1.73,1.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M62.06,246.53a2.33,2.33,0,1,1,0,3.3A2.34,2.34,0,0,1,62.06,246.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M131.91,364.66a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,7.82,7.82,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,7.83,7.83,0,0,0,.49-1.65A7.7,7.7,0,0,0,131.91,364.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M139.53,286.88a8,8,0,0,0,1.64.48,8,8,0,0,0,1.65-.48,7.82,7.82,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,7.83,7.83,0,0,0-1.65-.49,7.89,7.89,0,0,0-1.64.49,8,8,0,0,0,.48-1.65A7.82,7.82,0,0,0,139.53,286.88Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M94.43,287.05a8,8,0,0,0,1.65.48,7.82,7.82,0,0,0,1.64-.48,3.06,3.06,0,0,0,0,3.29,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,3.06,3.06,0,0,0,0-3.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M73.4,138.14a8,8,0,0,0,1.65.48,8,8,0,0,0,1.64-.48,8,8,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,8,8,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,8,8,0,0,0,.48-1.65A8,8,0,0,0,73.4,138.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M41.18,395.45a8,8,0,0,0,1.65.48,8,8,0,0,0,1.64-.48,7.82,7.82,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,7.89,7.89,0,0,0-1.64-.49,7.83,7.83,0,0,0-1.65.49,8,8,0,0,0,.48-1.65A7.82,7.82,0,0,0,41.18,395.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M28.31,283a.78.78,0,1,1,0-1.1A.77.77,0,0,1,28.31,283Zm14.48,2.38a1.56,1.56,0,1,0,0,2.2A1.57,1.57,0,0,0,42.79,285.36Zm-11-17.59a3.11,3.11,0,1,0,0,4.4A3.11,3.11,0,0,0,31.79,267.77ZM10.17,286.46a1.55,1.55,0,1,0,0,2.2A1.54,1.54,0,0,0,10.17,286.46Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M136.49,322.06a.78.78,0,1,1-.09,1.1A.79.79,0,0,1,136.49,322.06Zm-14.22-3.6a1.55,1.55,0,1,0,.19-2.19A1.57,1.57,0,0,0,122.27,318.46Zm9.47,18.46a3.11,3.11,0,1,0,.37-4.38A3.11,3.11,0,0,0,131.74,336.92Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M51.69,5.5A2.33,2.33,0,1,1,50,8.31,2.34,2.34,0,0,1,51.69,5.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M38.31,138.07a7.5,7.5,0,0,0,1.15,1.27,7.45,7.45,0,0,0,1.65.45,8.44,8.44,0,0,0-1.27,1.15,8.28,8.28,0,0,0-.45,1.66,7.5,7.5,0,0,0-1.15-1.27,7.45,7.45,0,0,0-1.65-.45,8,8,0,0,0,1.27-1.15A8.28,8.28,0,0,0,38.31,138.07Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M96.6,80.42a8,8,0,0,0,1.15,1.27,7.64,7.64,0,0,0,1.66.45,8,8,0,0,0-1.27,1.15,7.59,7.59,0,0,0-.45,1.65,8.44,8.44,0,0,0-1.15-1.27,8.28,8.28,0,0,0-1.66-.45,7.5,7.5,0,0,0,1.27-1.15A7.45,7.45,0,0,0,96.6,80.42Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M58.08,57a8,8,0,0,0,1.15,1.27,7.59,7.59,0,0,0,1.65.45,8.44,8.44,0,0,0-1.27,1.15,8.28,8.28,0,0,0-.45,1.66A7.5,7.5,0,0,0,58,60.23a7.45,7.45,0,0,0-1.65-.45,8,8,0,0,0,1.27-1.15A7.64,7.64,0,0,0,58.08,57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M146.92,57.12a7.5,7.5,0,0,0,1.15,1.27,7.45,7.45,0,0,0,1.65.45A8,8,0,0,0,148.45,60a8.28,8.28,0,0,0-.45,1.66,7.5,7.5,0,0,0-1.15-1.27,7.45,7.45,0,0,0-1.65-.45,8.44,8.44,0,0,0,1.27-1.15A8.28,8.28,0,0,0,146.92,57.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M124.85,27.68a.78.78,0,1,1,.57-.94A.78.78,0,0,1,124.85,27.68Zm11.09,9.6a1.56,1.56,0,1,0-1.15,1.88A1.56,1.56,0,0,0,135.94,37.28Zm-.17-20.74a3.11,3.11,0,1,0-2.3,3.75A3.11,3.11,0,0,0,135.77,16.54Zm-28.2,4.62A1.55,1.55,0,1,0,106.42,23,1.55,1.55,0,0,0,107.57,21.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M40,223.79a.79.79,0,0,1,.89.66.78.78,0,1,1-.89-.66Zm-10.23-10.5a1.55,1.55,0,1,0,1.3-1.77A1.56,1.56,0,0,0,29.81,213.29ZM28.21,234a3.11,3.11,0,1,0,2.61-3.53A3.12,3.12,0,0,0,28.21,234Zm28.49-2.2A1.56,1.56,0,1,0,58,230,1.56,1.56,0,0,0,56.7,231.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M85.64,91.89a5.81,5.81,0,0,0-1.25-.07,6.27,6.27,0,0,0-1.08.62,5.75,5.75,0,0,0,.07-1.24,6.27,6.27,0,0,0-.62-1.08,5.29,5.29,0,0,0,1.24.06,5.75,5.75,0,0,0,1.08-.61A5.91,5.91,0,0,0,85,90.81,5.66,5.66,0,0,0,85.64,91.89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M36.79,72.42a.56.56,0,0,1,.77-.19.56.56,0,1,1-.59,1A.55.55,0,0,1,36.79,72.42Zm-10.62.76a1.13,1.13,0,1,0-.37-1.55A1.13,1.13,0,0,0,26.17,73.18ZM36.9,83.74a2.26,2.26,0,1,0-.75-3.11A2.25,2.25,0,0,0,36.9,83.74ZM49,66.9a1.13,1.13,0,1,0-.37-1.55A1.12,1.12,0,0,0,49,66.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M70,332a2.34,2.34,0,1,1-.77-3.21A2.34,2.34,0,0,1,70,332Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M56.62,202a7.93,7.93,0,0,0-1.71-.08,8,8,0,0,0-1.48.85,8,8,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,7.82,7.82,0,0,0,1.71.09,7.85,7.85,0,0,0,1.49-.85,7.78,7.78,0,0,0-.09,1.71A8,8,0,0,0,56.62,202Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M61.86,181.62a7.93,7.93,0,0,0-1.71-.08,8.19,8.19,0,0,0-1.49.85,7.82,7.82,0,0,0,.09-1.71,7.85,7.85,0,0,0-.85-1.49,7.93,7.93,0,0,0,1.71.08,7.33,7.33,0,0,0,1.49-.85,7.88,7.88,0,0,0-.09,1.72A8,8,0,0,0,61.86,181.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M98.29,186.84a.77.77,0,1,1,1.32.81.77.77,0,0,1-1.06.26A.78.78,0,0,1,98.29,186.84Zm-14.63,1a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,83.66,187.89Zm14.78,14.55a3.11,3.11,0,1,0-1-4.28A3.12,3.12,0,0,0,98.44,202.44Zm16.68-23.21a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,115.12,179.23Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M472.35,179.23a.78.78,0,0,1-1.26-.92.78.78,0,0,1,1.26.92Zm14.66.2a1.55,1.55,0,1,0,.33,2.17A1.55,1.55,0,0,0,487,179.43Zm-13.49-15.76a3.11,3.11,0,1,0,.65,4.35A3.12,3.12,0,0,0,473.52,163.67Zm-18.59,21.71a1.56,1.56,0,1,0,.33,2.17A1.55,1.55,0,0,0,454.93,185.38Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M187.85,129.22a8,8,0,0,0-1.71-.08,7.85,7.85,0,0,0-1.49.85,8,8,0,0,0,.08-1.71,7.85,7.85,0,0,0-.85-1.49,7.82,7.82,0,0,0,1.71.09,7.76,7.76,0,0,0,1.49-.86,8,8,0,0,0-.08,1.72A8,8,0,0,0,187.85,129.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M242.13,320.59a.79.79,0,0,1,1.1.1.78.78,0,0,1-.1,1.09.77.77,0,0,1-1.09-.09A.78.78,0,0,1,242.13,320.59ZM227.91,317a1.55,1.55,0,1,0,.19-2.19A1.55,1.55,0,0,0,227.91,317Zm9.46,18.46a3.11,3.11,0,1,0,.38-4.38A3.11,3.11,0,0,0,237.37,335.45Zm23.13-16.79a1.55,1.55,0,1,0,.18-2.19A1.55,1.55,0,0,0,260.5,318.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M258.18,317.58a.56.56,0,1,1,.42-.68A.56.56,0,0,1,258.18,317.58Zm8.05,7a1.13,1.13,0,1,0-.84,1.36A1.13,1.13,0,0,0,266.23,324.55Zm-.12-15.05a2.26,2.26,0,1,0-1.67,2.72A2.26,2.26,0,0,0,266.11,309.5Zm-20.46,3.35a1.13,1.13,0,0,0-2.2.53,1.13,1.13,0,0,0,2.2-.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M236.82,307.52a7.78,7.78,0,0,0-1.71-.09,8.19,8.19,0,0,0-1.49.85,7.78,7.78,0,0,0,.09-1.71,8,8,0,0,0-.85-1.48,7.93,7.93,0,0,0,1.71.08,7.85,7.85,0,0,0,1.49-.85,3,3,0,0,0,.76,3.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M632.68,291.82a14.34,14.34,0,0,1-1.48,2.7,14.07,14.07,0,0,1-2.71,1.48,14.66,14.66,0,0,1,2.71,1.48,14.66,14.66,0,0,1,1.48,2.71,14.07,14.07,0,0,1,1.48-2.71,14.66,14.66,0,0,1,2.71-1.48,14.07,14.07,0,0,1-2.71-1.48A13.77,13.77,0,0,1,632.68,291.82Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M696,270.58a4,4,0,0,1-3,3,4,4,0,0,1,3,3,4,4,0,0,1,3-3,10.71,10.71,0,0,1-2-1.07A10.71,10.71,0,0,1,696,270.58Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M667.39,234.62a17.16,17.16,0,0,1-1.79,3.27,17.16,17.16,0,0,1-3.27,1.79,17.16,17.16,0,0,1,3.27,1.79,17.17,17.17,0,0,1,1.79,3.28,17.17,17.17,0,0,1,1.79-3.28,17.17,17.17,0,0,1,3.28-1.79,17.17,17.17,0,0,1-3.28-1.79A17.16,17.16,0,0,1,667.39,234.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M708.6,55.09a17.16,17.16,0,0,1-1.79,3.27,17.16,17.16,0,0,1-3.27,1.79,17.75,17.75,0,0,1,3.27,1.79,17.17,17.17,0,0,1,1.79,3.28,17.35,17.35,0,0,1,1.8-3.28,17.75,17.75,0,0,1,3.27-1.79,17.16,17.16,0,0,1-3.27-1.79A17.34,17.34,0,0,1,708.6,55.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M685.14,296.71a17.34,17.34,0,0,1-1.8,3.27,17.16,17.16,0,0,1-3.27,1.79,17.16,17.16,0,0,1,3.27,1.79,17.35,17.35,0,0,1,1.8,3.28,17.17,17.17,0,0,1,1.79-3.28,17.16,17.16,0,0,1,3.27-1.79,17.16,17.16,0,0,1-3.27-1.79A17.16,17.16,0,0,1,685.14,296.71Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M631.58,93.75a14.31,14.31,0,0,1-.86-3,14.31,14.31,0,0,1,.86-3,5.47,5.47,0,0,1-5.92,0,14.18,14.18,0,0,1,.87,3,14.18,14.18,0,0,1-.87,3,5.52,5.52,0,0,1,5.92,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M671.65,120s-1.45-3.65-1.45-4.93,1.45-4.94,1.45-4.94-3.65,1.45-4.94,1.45-4.94-1.45-4.94-1.45,1.45,3.65,1.45,4.94-1.45,4.93-1.45,4.93,3.65-1.44,4.94-1.44S671.65,120,671.65,120Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M651.74,327.17a8.25,8.25,0,0,0-.82-1.51,7.94,7.94,0,0,0-1.51-.82,3,3,0,0,0,2.33-2.32,7.93,7.93,0,0,0,.82,1.5,8.25,8.25,0,0,0,1.51.82,3,3,0,0,0-2.33,2.33Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M639.38,255.75a.78.78,0,1,1-.78.78A.78.78,0,0,1,639.38,255.75Zm-8.55-11.91a1.56,1.56,0,1,0,1.56-1.56A1.56,1.56,0,0,0,630.83,243.84Zm-4.66,20.21a3.11,3.11,0,1,0,3.11-3.11A3.1,3.1,0,0,0,626.17,264.05Zm28.5,2.07a1.56,1.56,0,0,0,3.11,0,1.56,1.56,0,1,0-3.11,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M700.61,293a1.7,1.7,0,1,1,1.69-1.7A1.7,1.7,0,0,1,700.61,293Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M681.56,232.51a2.23,2.23,0,0,0-1.69-1.69,2.23,2.23,0,0,0,1.69-1.69,2.23,2.23,0,0,0,1.69,1.69,2.23,2.23,0,0,0-1.69,1.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M704.79,255.56a5.49,5.49,0,0,0-.6-1.09,5.78,5.78,0,0,0-1.09-.6,2.23,2.23,0,0,0,1.69-1.69,5.6,5.6,0,0,0,.59,1.09,5.79,5.79,0,0,0,1.1.6,5.79,5.79,0,0,0-1.1.6A5.33,5.33,0,0,0,704.79,255.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M701.17,216a.56.56,0,0,1-.51-.61.55.55,0,0,1,.6-.51.56.56,0,1,1-.09,1.12Zm5.45,9.15a1.13,1.13,0,0,0-1-1.22,1.12,1.12,0,1,0,1,1.22Zm4.61-14.33a2.25,2.25,0,1,0-2.44,2.06A2.25,2.25,0,0,0,711.23,210.83Zm-20.47-3.25a1.13,1.13,0,1,0-1.22,1A1.13,1.13,0,0,0,690.76,207.58Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M668.9,193.86a7.82,7.82,0,0,0,1.64.48,8,8,0,0,0,1.65-.48,7.7,7.7,0,0,0-.49,1.64,7.7,7.7,0,0,0,.49,1.64,8,8,0,0,0-1.65-.48,7.82,7.82,0,0,0-1.64.48,7.82,7.82,0,0,0,.48-1.64A7.82,7.82,0,0,0,668.9,193.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M682.72,116.83a3.06,3.06,0,0,0,3.29,0,8,8,0,0,0-.48,1.64,8,8,0,0,0,.48,1.65,3.06,3.06,0,0,0-3.29,0,8,8,0,0,0,.48-1.65A8,8,0,0,0,682.72,116.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M637.62,117a7.83,7.83,0,0,0,1.65.49,7.7,7.7,0,0,0,1.64-.49,8,8,0,0,0-.48,1.65,7.82,7.82,0,0,0,.48,1.64,7.82,7.82,0,0,0-1.64-.48,8,8,0,0,0-1.65.48,7.7,7.7,0,0,0,.49-1.64A7.83,7.83,0,0,0,637.62,117Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M652.31,163.61a.78.78,0,0,1,1.1.09.78.78,0,1,1-1.19,1A.77.77,0,0,1,652.31,163.61ZM638.1,160a1.55,1.55,0,1,0,.18-2.19A1.55,1.55,0,0,0,638.1,160Zm9.46,18.45a3.1,3.1,0,1,0,.37-4.38A3.11,3.11,0,0,0,647.56,178.46Zm23.12-16.78a1.56,1.56,0,1,0,.19-2.19A1.55,1.55,0,0,0,670.68,161.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M665,299.62a3.05,3.05,0,0,0,2.8,1.72,8,8,0,0,0-1.27,1.15,8.28,8.28,0,0,0-.45,1.66,3.05,3.05,0,0,0-2.8-1.72,8.44,8.44,0,0,0,1.27-1.15A8.28,8.28,0,0,0,665,299.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M644,328a.77.77,0,1,1,.23,1.53A.77.77,0,0,1,644,328Zm-10.23-10.51a1.55,1.55,0,1,0,1.3-1.77A1.55,1.55,0,0,0,633.78,317.51Zm-1.6,20.68a3.11,3.11,0,1,0,2.61-3.54A3.11,3.11,0,0,0,632.18,338.19ZM660.67,336a1.56,1.56,0,1,0,1.31-1.77A1.56,1.56,0,0,0,660.67,336Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M675,100.69a5.87,5.87,0,0,0,.84.93,5.7,5.7,0,0,0,1.2.32,5.49,5.49,0,0,0-.92.84,5.28,5.28,0,0,0-.33,1.2,5.87,5.87,0,0,0-.84-.93,5.65,5.65,0,0,0-1.19-.32,5.91,5.91,0,0,0,.92-.84A5.7,5.7,0,0,0,675,100.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M684.38,182a5.49,5.49,0,0,0,.84.92,5.28,5.28,0,0,0,1.2.33,6.22,6.22,0,0,0-.93.83,5.86,5.86,0,0,0-.32,1.2,5.49,5.49,0,0,0-.84-.92,5.88,5.88,0,0,0-1.2-.33,2.17,2.17,0,0,0,1.25-2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M668.37,160.6a.57.57,0,0,1-.26-1.1.55.55,0,0,1,.67.42A.56.56,0,0,1,668.37,160.6Zm8,7a1.13,1.13,0,1,0-2.19.53,1.13,1.13,0,0,0,2.19-.53Zm-.12-15a2.25,2.25,0,1,0-1.67,2.71A2.25,2.25,0,0,0,676.29,152.52Zm-20.46,3.34a1.13,1.13,0,1,0-.83,1.36A1.12,1.12,0,0,0,655.83,155.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M691.47,236.87a5.91,5.91,0,0,0-1.24-.06,5.66,5.66,0,0,0-1.08.62,5.29,5.29,0,0,0,.06-1.24,5.43,5.43,0,0,0-.61-1.08,5.91,5.91,0,0,0,1.24.06,5.66,5.66,0,0,0,1.08-.62,5.75,5.75,0,0,0-.07,1.24A5.89,5.89,0,0,0,691.47,236.87Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M694.72,293.56a6,6,0,0,0-1.25-.06,5.66,5.66,0,0,0-1.08.62,5.75,5.75,0,0,0,.07-1.24,6.27,6.27,0,0,0-.62-1.08,5.91,5.91,0,0,0,1.24.06,5.66,5.66,0,0,0,1.08-.62,5.91,5.91,0,0,0-.06,1.24A5.36,5.36,0,0,0,694.72,293.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M690.92,268.22a.56.56,0,0,1-.79.12.57.57,0,1,1,.67-.91A.56.56,0,0,1,690.92,268.22Zm10.64.14a1.12,1.12,0,0,0-1.57.24,1.13,1.13,0,1,0,1.57-.24Zm-9.79-11.42a2.26,2.26,0,1,0,.48,3.15A2.25,2.25,0,0,0,691.77,256.94Zm-13.49,15.74a1.13,1.13,0,1,0,.24,1.58A1.12,1.12,0,0,0,678.28,272.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M647,150.53a8,8,0,0,0-1.71-.08,7.85,7.85,0,0,0-1.49.85,8,8,0,0,0,.08-1.71,7.33,7.33,0,0,0-.85-1.49,3.06,3.06,0,0,0,3.2-.77,8,8,0,0,0-.08,1.71A7.85,7.85,0,0,0,647,150.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M701.29,341.9a.79.79,0,0,1,1.1.1.78.78,0,0,1-.1,1.09.77.77,0,0,1-1.09-.09A.78.78,0,0,1,701.29,341.9Zm-14.22-3.6a1.55,1.55,0,1,0,.19-2.19A1.56,1.56,0,0,0,687.07,338.3Zm9.46,18.46a3.11,3.11,0,1,0,.38-4.38A3.11,3.11,0,0,0,696.53,356.76ZM719.66,340a1.55,1.55,0,1,0,.19-2.19A1.55,1.55,0,0,0,719.66,340Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M717.34,338.89a.56.56,0,1,1,.42-.68A.56.56,0,0,1,717.34,338.89Zm8,7A1.13,1.13,0,0,0,724,345a1.13,1.13,0,1,0,.53,2.19A1.13,1.13,0,0,0,725.39,345.86Zm-.12-15.05a2.26,2.26,0,1,0-1.67,2.72A2.26,2.26,0,0,0,725.27,330.81Zm-20.46,3.35a1.13,1.13,0,1,0-.84,1.36A1.14,1.14,0,0,0,704.81,334.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M696,328.83a7.78,7.78,0,0,0-1.71-.09,8,8,0,0,0-1.48.85,7.93,7.93,0,0,0,.08-1.71,8.19,8.19,0,0,0-.85-1.49,3,3,0,0,0,3.2-.76,3,3,0,0,0,.76,3.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M147.89,90.8a.78.78,0,1,1,.26,1.06A.77.77,0,0,1,147.89,90.8Zm-14.63,1a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,133.26,91.85Zm14.79,14.54a3.1,3.1,0,1,0-1-4.27A3.09,3.09,0,0,0,148.05,106.39Zm16.67-23.2a1.56,1.56,0,1,0-.51-2.14A1.56,1.56,0,0,0,164.72,83.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M864.05,505.05C771.28,378.92,591.38,293.39,384.64,293.39c-222.4,0-413.74,99-499,241v86.89H864.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M800.84,498.88C720.06,389.05,563.4,314.57,383.38,314.57c-193.66,0-360.28,86.19-434.48,209.86v75.66H800.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M753.6,500.93c-71.82-91.52-211.1-153.58-371.17-153.58-172.18,0-320.32,71.82-386.3,174.86v63H753.6Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M118,423.7c-3.56,38.24,107.45,43,234.12,31.34s215.63,31.87,274-.53c23.11-12.83,22-30.83,9.84-48.28-70.63-37-158.39-58.88-253.48-58.88-98.52,0-189.16,23.53-261,62.95A46.53,46.53,0,0,0,118,423.7Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M553.35,404.15c-1.17,8.43-18.35,12.65-38.38,9.44s-35.33-12.65-34.17-21.07,18.34-12.65,38.37-9.44S554.51,395.73,553.35,404.15ZM183.5,392.77c-18.91,7.82-31.95,20.6-29.13,28.55s20.45,8.07,39.36.25,32-20.59,29.14-28.55S202.42,385,183.5,392.77Zm64,13.76c-13.62,5.25-23.13,14.15-21.23,19.88s14.48,6.12,28.11.87,23.13-14.16,21.23-19.89S261.12,401.27,247.49,406.53Zm30.61-41.76c-10.3,3.49-17.63,9.84-16.36,14.17s10.63,5,20.94,1.51,17.62-9.84,16.36-14.17S288.4,361.27,278.1,364.77Zm330.62,49.55c-9.87-4.72-19.25-5.18-21-1s4.92,11.35,14.79,16.06,19.26,5.18,21,1S618.6,419,608.72,414.32ZM561.8,432.15c-12.18-1.52-22.51,1.41-23.06,6.53s8.89,10.51,21.07,12,22.51-1.41,23.06-6.53S574,433.67,561.8,432.15Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M199.54,421c-8.66,3.58-17,5.49-23.86,5.75a78.81,78.81,0,0,0,18-5.18c18.92-7.81,32-20.59,29.14-28.55-1.54-4.31-7.42-6.31-15.51-6,11-1.67,19.44.14,21.32,5.43C231.5,400.41,218.46,413.19,199.54,421Zm65-18.16c5.84-.1,10.07,1.42,11.11,4.55,1.9,5.73-7.61,14.63-21.23,19.89a58.55,58.55,0,0,1-11.2,3.11,51.66,51.66,0,0,0,17-3.68c13.62-5.26,23.13-14.16,21.23-19.89C280.05,402.73,273.24,401.38,264.49,402.84Zm254.68-19.76c20,3.21,35.34,12.65,34.18,21.07-.69,5-6.94,8.47-16.06,9.85,12.2-.6,21-4.46,21.87-10.42,1.16-8.42-14.14-17.86-34.18-21.07a74.13,74.13,0,0,0-22.32-.42A80.16,80.16,0,0,1,519.17,383.08Zm95.36,30.67c-7.52-3.6-14.75-4.71-18.53-3.2a38,38,0,0,1,12.72,3.77c9.88,4.72,16.5,11.91,14.79,16.06a4.09,4.09,0,0,1-2.43,2.17c4.21.37,7.33-.52,8.24-2.74C631,425.66,624.41,418.47,614.53,413.75Zm-46.92,17.83a44.93,44.93,0,0,0-13.31.2,51.15,51.15,0,0,1,7.5.37c12.19,1.52,21.62,6.91,21.07,12-.32,3.06-4.14,5.32-9.75,6.33,8.66-.22,15.13-2.87,15.56-6.9C589.23,438.49,579.8,433.1,567.61,431.58Zm-277.31-69c4.66,0,8,1.27,8.74,3.74,1.26,4.33-6.06,10.68-16.36,14.17a45.58,45.58,0,0,1-6.4,1.67,39.28,39.28,0,0,0,12.21-2.24c10.3-3.49,17.62-9.84,16.36-14.17C303.85,362.3,297.84,361.17,290.3,362.54Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M578.52,448.91a43.4,43.4,0,0,0-14.68-4.33c-7.6-.94-14.47-.16-18.71,1.8a43.17,43.17,0,0,0,14.68,4.33C567.41,451.66,574.28,450.88,578.52,448.91Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M551.44,408.05c-5.69-5.52-16.91-10.4-30.23-12.54-16.65-2.67-31.32-.2-36.47,5.54,5.69,5.51,16.91,10.4,30.23,12.54C531.61,416.26,546.28,413.79,551.44,408.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M593.06,423.28a43.18,43.18,0,0,0,9.49,6.07c7,3.35,13.75,4.54,17.69,3.48a42.88,42.88,0,0,0-9.48-6.08C603.75,423.4,597,422.21,593.06,423.28Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M158,425.31c6.68,3.65,20.79,2.43,35.7-3.74,13.09-5.4,23.36-13.19,27.51-20.1-6.68-3.66-20.79-2.43-35.7,3.73C172.45,410.61,162.18,418.39,158,425.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M280.13,377.2a41,41,0,0,0-10.83,5.45,37.26,37.26,0,0,0,13.38-2.2A41,41,0,0,0,293.51,375,37.26,37.26,0,0,0,280.13,377.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M231.49,430.36c5.31,1.38,13.85.39,22.88-3.08,7.84-3,14.31-7.27,18-11.41-5.31-1.38-13.85-.39-22.88,3.09C241.68,422,235.21,426.22,231.49,430.36Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-163",
    cx: 197.91,
    cy: 435.04,
    rx: 14.6,
    ry: 5.97,
    transform: "translate(-17.92 89.45) rotate(-19.23)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-164",
    cx: 482.85,
    cy: 369.55,
    rx: 6,
    ry: 14.51,
    transform: "translate(158.78 790.88) rotate(-81.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M663.23,438.42c-1.61,2.83-8.44,1.49-15.28-3s-11.07-10.43-9.46-13.27,8.44-1.49,15.27,3S664.83,435.58,663.23,438.42Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M516.08,375.13c-.18,1.4-3.05,2.13-6.42,1.63s-5.94-2-5.76-3.44,3.05-2.12,6.41-1.62S516.26,373.74,516.08,375.13Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M548.83,422.58c-.18,1.4-3.05,2.12-6.41,1.62s-5.95-2-5.77-3.43,3.05-2.13,6.41-1.63S549,421.18,548.83,422.58Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M580.67,391.11c-.18,1.39-3,2.12-6.42,1.62s-5.94-2-5.76-3.43,3-2.13,6.41-1.63S580.85,389.71,580.67,391.11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M607.47,440.18c-.48,1.31-3.43,1.27-6.59-.09s-5.32-3.52-4.84-4.83,3.44-1.27,6.59.09S608,438.87,607.47,440.18Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M600.45,402.53c-.55,2.18-5.26,2.7-10.52,1.17s-9.08-4.55-8.53-6.74,5.26-2.7,10.52-1.17S601,400.34,600.45,402.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-171",
    cx: 492.35,
    cy: 415.56,
    rx: 4.09,
    ry: 9.89,
    transform: "translate(111.13 827.32) rotate(-79.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M285.21,389.52c.46,2-3,4.64-7.77,6s-9,.78-9.46-1.19,3-4.64,7.77-5.95S284.74,387.54,285.21,389.52Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M280.3,427c.47,2-3,4.64-7.76,6s-9,.78-9.46-1.2,3-4.64,7.76-5.95S279.83,425,280.3,427Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M290.08,417.84c.29,1.23-1.87,2.89-4.83,3.71s-5.6.49-5.9-.74,1.88-2.89,4.84-3.71S289.79,416.61,290.08,417.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M260.87,368.44c.29,1.23-1.88,2.89-4.84,3.71s-5.6.49-5.89-.74,1.87-2.89,4.83-3.71S260.57,367.21,260.87,368.44Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M223.36,417.84c.29,1.23-1.87,2.89-4.83,3.71s-5.6.49-5.9-.74,1.88-2.89,4.84-3.71S223.07,416.61,223.36,417.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-177",
    cx: 312.61,
    cy: 389.04,
    rx: 14.6,
    ry: 5.97,
    transform: "translate(3.63 124.66) rotate(-19.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M338.06,371.84c.29,1.23-1.87,2.89-4.84,3.71s-5.6.49-5.89-.74,1.87-2.89,4.83-3.71S337.77,370.61,338.06,371.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M225.43,378.06c.3,1.22-1.87,2.88-4.83,3.7s-5.6.49-5.89-.74,1.87-2.89,4.83-3.71S225.14,376.83,225.43,378.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-180",
    cx: 791.02,
    cy: 199.94,
    r: 46.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 791.02,
    cy: 199.94,
    r: 40.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-182",
    cx: 791.02,
    cy: 199.94,
    r: 40.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M693.68,215.36a2.9,2.9,0,0,0,.55-1.8c-.16-1.23-1.65-1.81-2.89-1.83-3,0-5.68,1.59-8,3.37s-4.64,3.8-7.42,4.8-6.32.69-8.14-1.65-1.26-6-2.56-8.86a2.23,2.23,0,0,0-.75-1c-.86-.54-2,.06-2.79.64-4.76,3.25-10.07,6-15.8,6.59a21,21,0,0,1-6.17-.23A40.24,40.24,0,0,0,655,233.66a7.05,7.05,0,0,1,.44-1.32c2.14-4.55,8.14-5.3,13.15-5.68a50.53,50.53,0,0,0,14-2.63A21.58,21.58,0,0,0,693.68,215.36Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M716.52,204.77c-2.7.07-5.36.27-7.58,1.71-3.71,2.39-4.75,7.45-4.17,11.82a6.25,6.25,0,0,1-.1,3.41,5,5,0,0,1-1.37,1.61c-5.08,4.36-11.57,6.65-17.37,10-2.54,1.47-5.22,3.68-5.23,6.55A40.12,40.12,0,0,0,716.52,204.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M636.58,199.94c0,.24,0,.47,0,.7a8,8,0,0,0,2.16,1.15c1.76.61,3.8.65,5.23,1.84.79.65,1.3,1.58,2.07,2.24,1.94,1.64,5,1.11,7-.48s3.1-4,4.21-6.25,2.34-4.63,4.42-6.09a7.9,7.9,0,0,1,6-1.25c1.82.37,3.57,1.39,5.41,1.16,2.4-.32,4.07-2.81,4.16-5.22a11.46,11.46,0,0,0-2.46-6.7,13.08,13.08,0,0,1-1.85-3c-1.08-3,.74-6.36,3-8.68s5-4.24,6.53-7.08a5.87,5.87,0,0,0,.65-1.9,40.81,40.81,0,0,0-6.39-.51A40.12,40.12,0,0,0,636.58,199.94Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M693.25,169.82c.72,2.41,2.23,4.5,3.31,6.77s1.72,5,.65,7.27c-1.31,2.79-4.59,3.89-7.39,5.18a29.32,29.32,0,0,0-7,4.46c-2.32,2-4.47,4.81-4,7.83s3.79,5.12,6.89,5.94a8.65,8.65,0,0,0,5.92-.13c3.45-1.66,4.41-6.51,7.86-8.18,2.77-1.33,6-.12,9.07.13a14.92,14.92,0,0,0,8.09-1.74,40.15,40.15,0,0,0-23.41-33.92A11.12,11.12,0,0,0,693.25,169.82Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M702.91,169.58a40.11,40.11,0,0,1-65.14,40.09,40.12,40.12,0,1,0,65.14-40.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M709.9,183.15a37.33,37.33,0,0,1-68.4,29.47,37.33,37.33,0,1,0,68.4-29.47Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M639.07,203.5a40.11,40.11,0,0,1,71.73-24.69,40.12,40.12,0,1,0-65.71,45.83A40,40,0,0,1,639.07,203.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M642.5,208c-1.19-4.76.68-12,1.64-15.44A38.14,38.14,0,0,1,657.91,172c17.85-13.31,38.4-3.6,43.86,2.35s-1,12.37-10.82,12.21-19.57-.31-25.21,4.7-5.17,17.69-12.68,20.35c-2.49.88-6.09,1.73-8.43,0A6.14,6.14,0,0,1,642.5,208Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M660.32,177.26c2.18,1.92,1.18,6.59-2.21,10.45s-7.91,5.43-10.08,3.52-1.18-6.59,2.21-10.45S658.15,175.35,660.32,177.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M671.88,169.81c.8,1.5-.72,3.87-3.4,5.28s-5.48,1.34-6.27-.17.72-3.87,3.39-5.28S671.09,168.3,671.88,169.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-192",
    cx: 76.87,
    cy: 122.5,
    r: 60.27,
    transform: "translate(50.21 90.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-193",
    cx: 76.87,
    cy: 122.5,
    r: 51.61,
    transform: "translate(97.58 12.26) rotate(-8.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-194",
    cx: 76.87,
    cy: 122.5,
    r: 51.61,
    transform: "translate(97.58 12.26) rotate(-8.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M57.1,144.4a3.72,3.72,0,0,0,2.31.7c1.6-.21,2.33-2.12,2.35-3.73,0-3.8-2.06-7.29-4.36-10.33s-4.91-5.94-6.21-9.52-.91-8.13,2.09-10.47,7.77-1.65,11.4-3.34a2.73,2.73,0,0,0,1.25-1c.69-1.1-.09-2.51-.83-3.58-4.2-6.11-7.71-12.93-8.55-20.3a26.8,26.8,0,0,1,.28-7.94A51.87,51.87,0,0,0,33.4,94.67a9.28,9.28,0,0,1,1.71.57C41,98,42,105.69,42.46,112.13c.48,6.13,1.26,12.31,3.45,18.06S51.82,141.27,57.1,144.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M70.81,173.75c-.1-3.48-.36-6.9-2.22-9.76-3.1-4.75-9.6-6.08-15.23-5.31-1.47.2-3,.5-4.39-.12a6.43,6.43,0,0,1-2.07-1.75C41.27,150.29,38.3,142,34,134.5c-1.9-3.25-4.76-6.69-8.45-6.7A51.63,51.63,0,0,0,70.81,173.75Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M76.71,70.88l-.89,0a10,10,0,0,0-1.48,2.77c-.77,2.28-.81,4.9-2.34,6.75-.84,1-2,1.67-2.88,2.67-2.1,2.49-1.4,6.46.65,9s5.12,4,8.06,5.4,6,3,7.84,5.66a10.14,10.14,0,0,1,1.63,7.71c-.46,2.34-1.77,4.59-1.46,7,.41,3.08,3.62,5.22,6.73,5.32s6.06-1.4,8.6-3.19a17.39,17.39,0,0,1,3.93-2.38c3.9-1.4,8.18.92,11.17,3.79s5.47,6.42,9.13,8.37a7.18,7.18,0,0,0,2.45.83A51.64,51.64,0,0,0,76.71,70.88Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M115.68,143.67c-3.1.94-5.78,2.88-8.7,4.28s-6.41,2.24-9.35.88c-3.59-1.68-5-5.9-6.68-9.5a38,38,0,0,0-5.77-8.94c-2.57-3-6.21-5.74-10.09-5.06-4.07.71-6.57,4.89-7.62,8.89-.65,2.51-.93,5.28.2,7.62,2.14,4.43,8.39,5.65,10.55,10.07,1.73,3.56.17,7.74-.13,11.68A19.18,19.18,0,0,0,80.36,174a51.61,51.61,0,0,0,43.55-30.25A14.41,14.41,0,0,0,115.68,143.67Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M116.14,155.86A51.6,51.6,0,0,1,64.33,72.21a51.62,51.62,0,1,0,51.81,83.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M98.6,165.15A48,48,0,0,1,60.43,77.27,48,48,0,1,0,98.6,165.15Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M72.14,74.1a51.61,51.61,0,0,1,32,92.19A51.61,51.61,0,1,0,45,81.93,51.32,51.32,0,0,1,72.14,74.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M66.35,78.54c6.12-1.56,15.4.83,19.86,2a49,49,0,0,1,26.54,17.63c17.19,22.91,4.78,49.39-2.85,56.43S94,153.47,94.15,140.78s.33-25.18-6.14-32.41-22.78-6.58-26.23-16.24c-1.15-3.2-2.25-7.82,0-10.84A7.89,7.89,0,0,1,66.35,78.54Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-203",
    cx: 96.97,
    cy: 93.46,
    rx: 6.74,
    ry: 11.97,
    transform: "translate(77.09 104.89) rotate(-48.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M115.62,116.19c-1.94,1-5-.92-6.81-4.35s-1.74-7,.19-8.08,5,.92,6.81,4.35S117.55,115.16,115.62,116.19Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-205",
    cx: 571.83,
    cy: 156.5,
    r: 15.8,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, 93.3, 159.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-206",
    cx: 571.83,
    cy: 156.5,
    r: 13.53,
    transform: "translate(93.39 145.47) rotate(-14.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-207",
    cx: 571.83,
    cy: 156.5,
    r: 13.53,
    transform: "translate(93.39 145.47) rotate(-14.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M566.65,162.24a.94.94,0,0,0,.6.18c.42,0,.61-.56.62-1a4.52,4.52,0,0,0-1.15-2.7,10.11,10.11,0,0,1-1.62-2.5,2.45,2.45,0,0,1,.54-2.75c.83-.64,2-.43,3-.87a.7.7,0,0,0,.33-.25c.18-.29,0-.66-.22-.94a12,12,0,0,1-2.24-5.32,7.25,7.25,0,0,1,.07-2.08,13.59,13.59,0,0,0-6.14,5.17,2.16,2.16,0,0,1,.45.15c1.54.72,1.8,2.74,1.93,4.43a17.22,17.22,0,0,0,.9,4.73A7.31,7.31,0,0,0,566.65,162.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M570.24,169.93a4.93,4.93,0,0,0-.58-2.56,4.07,4.07,0,0,0-4-1.39,2.13,2.13,0,0,1-1.15,0,1.73,1.73,0,0,1-.55-.46c-1.47-1.71-2.25-3.9-3.39-5.85-.5-.85-1.24-1.75-2.21-1.76A13.53,13.53,0,0,0,570.24,169.93Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M571.79,143h-.24a3,3,0,0,0-.39.73,5.24,5.24,0,0,1-.61,1.77c-.22.26-.53.44-.75.7a1.92,1.92,0,0,0,.17,2.36,5.89,5.89,0,0,0,2.11,1.41,5,5,0,0,1,2,1.49,2.61,2.61,0,0,1,.43,2,6,6,0,0,0-.38,1.83,1.79,1.79,0,0,0,1.76,1.39,3.81,3.81,0,0,0,2.26-.83,4.74,4.74,0,0,1,1-.63,3,3,0,0,1,2.92,1,12.11,12.11,0,0,0,2.4,2.19,1.87,1.87,0,0,0,.64.22,12.73,12.73,0,0,0,.16-2.15A13.52,13.52,0,0,0,571.79,143Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M582,162.05a15.53,15.53,0,0,0-2.28,1.12,3,3,0,0,1-2.45.23c-.94-.44-1.32-1.55-1.75-2.49a10,10,0,0,0-1.51-2.35,3.08,3.08,0,0,0-2.65-1.32,3.52,3.52,0,0,0-1.94,4.33c.56,1.16,2.2,1.48,2.76,2.64.45.93.05,2,0,3.06a5,5,0,0,0,.59,2.72,13.54,13.54,0,0,0,11.42-7.93A3.7,3.7,0,0,0,582,162.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M582.12,165.24a13.53,13.53,0,0,1-16.84-13.07,13.47,13.47,0,0,1,3.26-8.85,13.53,13.53,0,1,0,13.58,21.92Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M577.52,167.67a12.59,12.59,0,0,1-10-23,12.59,12.59,0,0,0,4.23,24.46A12.44,12.44,0,0,0,577.52,167.67Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M570.59,143.81A13.52,13.52,0,0,1,579,168a13.53,13.53,0,1,0-15.52-22.11A13.47,13.47,0,0,1,570.59,143.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M569.07,145c1.6-.4,4,.22,5.21.54a12.88,12.88,0,0,1,7,4.62c4.51,6,1.25,13-.75,14.79s-4.17-.31-4.12-3.63.08-6.6-1.61-8.5-6-1.72-6.88-4.25a3.19,3.19,0,0,1,0-2.84A2.12,2.12,0,0,1,569.07,145Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M579.46,151c-.65.74-2.22.41-3.53-.73s-1.84-2.67-1.2-3.4,2.23-.4,3.53.74S580.1,150.22,579.46,151Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M582,154.84c-.5.27-1.3-.24-1.78-1.14s-.46-1.85,0-2.12,1.3.24,1.78,1.14S582.49,154.57,582,154.84Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-218",
    cx: 546.56,
    cy: 52.87,
    r: 39.63,
    transform: "translate(112.7 84.94) rotate(-8.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-219",
    cx: 546.56,
    cy: 52.87,
    r: 30.77,
    transform: "translate(112.7 84.94) rotate(-8.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M563.79,49.32a2.18,2.18,0,0,0-.86-1.15c-.84-.46-1.87.2-2.44,1-1.37,1.82-1.59,4.23-1.56,6.5s.26,4.59-.37,6.77-2.44,4.23-4.7,4.3-4.32-2-6.66-2.43a1.67,1.67,0,0,0-.94,0c-.72.29-.84,1.24-.87,2-.13,4.42-.86,8.94-3,12.77a16,16,0,0,1-2.94,3.72,30.91,30.91,0,0,0,18.23-1.22,5,5,0,0,1-.62-.88c-1.85-3.38.4-7.44,2.43-10.71a38.72,38.72,0,0,0,4.71-9.89A16.52,16.52,0,0,0,563.79,49.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M567.56,30.38a10.89,10.89,0,0,0-2.37,5.47c-.19,3.38,2.46,6.31,5.44,7.93a4.77,4.77,0,0,1,2.06,1.6,3.75,3.75,0,0,1,.38,1.58c.41,5.12-1.11,10.17-1.66,15.28-.23,2.24-.07,4.9,1.69,6.2A30.76,30.76,0,0,0,567.56,30.38Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M528.42,77.72l.44.31a6.3,6.3,0,0,0,1.69-.82c1.17-.82,2.12-2.06,3.5-2.41.76-.19,1.57-.08,2.33-.27,1.89-.45,3-2.61,2.86-4.55a13.33,13.33,0,0,0-2-5.44,11.52,11.52,0,0,1-1.77-5.48,6,6,0,0,1,1.93-4.28c1-1,2.47-1.58,3.16-2.83A4.09,4.09,0,0,0,539.24,47,8.69,8.69,0,0,0,534,45.51a10.37,10.37,0,0,1-2.73-.24c-2.37-.7-3.6-3.33-4-5.76s-.36-5-1.43-7.25a4.46,4.46,0,0,0-.88-1.26,30.41,30.41,0,0,0-3.21,3.73A30.77,30.77,0,0,0,528.42,77.72Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M535.39,29a38.48,38.48,0,0,0,5.69,1c1.89.36,3.87,1.19,4.8,2.88,1.13,2.07.33,4.61-.14,6.92a22.43,22.43,0,0,0-.39,6.33c.19,2.34,1,5,3.07,6s4.88,0,6.79-1.59a6.6,6.6,0,0,0,2.6-3.73c.53-2.89-2-5.67-1.51-8.56.42-2.32,2.64-3.78,4.18-5.57a11.48,11.48,0,0,0,2.58-5.79,30.77,30.77,0,0,0-31.6-.84A8.56,8.56,0,0,0,535.39,29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M539.85,22.78a30.79,30.79,0,0,1,13.27,46.66,30.65,30.65,0,0,1-17.9,11.82,30.77,30.77,0,1,0,4.63-58.48Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M552,23.65a28.63,28.63,0,0,1-12.67,55.7A28.63,28.63,0,1,0,552,23.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M531.75,77.79a30.76,30.76,0,0,1,17.14-55.6,30.77,30.77,0,1,0-1.32,61.43A30.68,30.68,0,0,1,531.75,77.79Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M536.1,77.7c-3.49-1.41-7.11-5.83-8.82-8a29.28,29.28,0,0,1-6.53-17.84c-.17-17.08,15.14-25.42,21.29-26.11S549.27,32,544.71,38s-9,12-8.49,17.74,8.63,11.2,6.88,17.06c-.58,1.94-1.68,4.55-3.84,5.2A4.74,4.74,0,0,1,536.1,77.7Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M525.11,52.76c2.17-.48,4.62,2.24,5.47,6.09s-.21,7.36-2.38,7.84-4.61-2.25-5.47-6.1S522.94,53.24,525.11,52.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M525.72,42.23c1.29.18,2.07,2.19,1.73,4.49s-1.65,4-2.94,3.81-2.07-2.2-1.74-4.49S524.43,42,525.72,42.23Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-230",
    cx: 176.36,
    cy: 180.1,
    r: 13.75,
    transform: "translate(59.39 280.33) rotate(-69.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 176.36,
    cy: 180.1,
    r: 10.68,
    transform: "translate(55.64 271.17) rotate(-66.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M179.08,185.56a.9.9,0,0,0,.31-.39c.08-.33-.24-.61-.55-.74a3.66,3.66,0,0,0-2.31.06,8.07,8.07,0,0,1-2.31.48,2,2,0,0,1-1.85-1.2c-.24-.79.27-1.62.22-2.45a.66.66,0,0,0-.09-.31c-.17-.22-.5-.17-.76-.11a9.6,9.6,0,0,1-4.55.11,5.64,5.64,0,0,1-1.51-.66,10.69,10.69,0,0,0,2,6,1.68,1.68,0,0,1,.24-.29c1-.92,2.53-.53,3.81-.14a13.24,13.24,0,0,0,3.73.71A5.79,5.79,0,0,0,179.08,185.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M185.76,185.14a3.83,3.83,0,0,0-2-.31,3.21,3.21,0,0,0-2.18,2.53,1.66,1.66,0,0,1-.35.84,1.33,1.33,0,0,1-.5.26,28.9,28.9,0,0,1-5.27.8,2.33,2.33,0,0,0-1.93,1.12A10.67,10.67,0,0,0,185.76,185.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M166.41,176.22l-.06.17a1.83,1.83,0,0,0,.42.5c.38.32.88.52,1.12,1,.13.24.17.52.3.75a1.51,1.51,0,0,0,1.78.56,4.62,4.62,0,0,0,1.65-1.14,3.93,3.93,0,0,1,1.68-1.08,2.05,2.05,0,0,1,1.6.27c.42.26.75.69,1.23.8a1.42,1.42,0,0,0,1.54-.89,3,3,0,0,0,0-1.89,3.38,3.38,0,0,1-.17-.94,2.37,2.37,0,0,1,1.58-1.86,9.29,9.29,0,0,0,2.3-1.13,1.39,1.39,0,0,0,.35-.41,11.5,11.5,0,0,0-1.54-.74A10.68,10.68,0,0,0,166.41,176.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M183.37,174.23a13.5,13.5,0,0,0,.17,2,2.36,2.36,0,0,1-.54,1.86,3.57,3.57,0,0,1-2.34.57,8,8,0,0,0-2.16.43,2.4,2.4,0,0,0-1.73,1.56,2.79,2.79,0,0,0,2.61,2.68c1-.08,1.72-1.19,2.74-1.27.81-.06,1.5.55,2.24.91a4,4,0,0,0,2.17.35A10.66,10.66,0,0,0,184,172.65,3,3,0,0,0,183.37,174.23Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M185.85,175.17a10.93,10.93,0,0,1-.64,2.53,10.68,10.68,0,0,1-19.39,1.11,10.68,10.68,0,1,0,20-3.64Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M186.64,179.32a10.08,10.08,0,0,1-.67,3.25A9.94,9.94,0,0,1,166.83,180a9.94,9.94,0,1,0,19.81-.7Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M166.68,177.34a10.67,10.67,0,0,1,20.17.81,10.67,10.67,0,1,0-20.72,5A10.64,10.64,0,0,1,166.68,177.34Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M167.1,178.79a9.39,9.39,0,0,1,1.9-3.67,10.11,10.11,0,0,1,5.4-3.77,9.36,9.36,0,0,1,10.65,4.82c.77,2-1.44,3-3.87,2s-4.82-2-6.7-1.27-3,3.89-5.11,3.82a2.53,2.53,0,0,1-2.09-.82A1.65,1.65,0,0,1,167.1,178.79Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M174.49,172.89c.35.69-.35,1.75-1.56,2.38s-2.49.58-2.84-.1.34-1.75,1.56-2.38S174.13,172.21,174.49,172.89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M178.07,172.16c.06.45-.55.89-1.35,1s-1.49-.2-1.54-.65.55-.89,1.35-1S178,171.71,178.07,172.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-242",
    cx: 692.08,
    cy: 307.81,
    r: 21.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-243",
    cx: 692.08,
    cy: 307.81,
    r: 17.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M560.89,308.71a17.69,17.69,0,0,1,30.3-12.42,17.7,17.7,0,1,0-26,23.94A17.65,17.65,0,0,1,560.89,308.71Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M567.32,317.37a15.69,15.69,0,0,1,26.59-11.28,15.69,15.69,0,1,0-26.38,13.85A15.55,15.55,0,0,1,567.32,317.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M588.76,293.94a16.31,16.31,0,0,1,.74,4.87A16.15,16.15,0,0,1,560.06,308a17.7,17.7,0,1,0,28.7-14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M592.58,300.24A16.69,16.69,0,0,1,562,313.45a16.69,16.69,0,1,0,30.57-13.21Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M589.34,299.58c-.75,1.88-3.48,2.56-6.09,1.53s-4.14-3.4-3.39-5.29,3.47-2.56,6.09-1.53S590.08,297.7,589.34,299.58Zm-11-.18c-1.21-.48-2.46-.16-2.8.7s.35,2,1.55,2.43,2.46.16,2.8-.7S579.53,299.88,578.33,299.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M578.33,299.4c-1.21-.48-2.46-.16-2.8.7a1.15,1.15,0,0,0-.08.41,2.36,2.36,0,0,1,2.51-.3,2.32,2.32,0,0,1,1.64,2,1.15,1.15,0,0,0,.28-.41C580.23,301,579.53,299.88,578.33,299.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M586,294.29c-2.62-1-5.34-.35-6.09,1.53,0,.11-.08.23-.11.34,1-1.51,3.46-2,5.84-1.05s3.95,3.13,3.49,4.95a2.77,2.77,0,0,0,.26-.48C590.08,297.7,588.56,295.33,586,294.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M583.56,319c-.11,1.58-2,2.73-4.18,2.57s-3.88-1.56-3.77-3.13,2-2.74,4.18-2.58S583.67,317.38,583.56,319Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M583.24,317.67v.24c-.11,1.58-2,2.73-4.18,2.58a4.33,4.33,0,0,1-3.45-1.85c.07,1.48,1.69,2.75,3.77,2.89s4.07-1,4.18-2.57A2.28,2.28,0,0,0,583.24,317.67Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M593,306.86c1.16.46,1.26,3,.22,5.57s-2.82,4.36-4,3.9-1.27-2.95-.23-5.57S591.87,306.4,593,306.86Zm-4.79,11.76c-.77.67-1.15,1.5-.85,1.84s1.17.07,1.94-.6,1.15-1.5.85-1.85S589,317.94,588.24,318.62Zm3.09-15.21c.26,1.39,1,2.43,1.6,2.31s.91-1.35.64-2.74-1-2.43-1.6-2.31S591.06,302,591.33,303.41Zm-2.11,2.64c-.43.93-.44,1.84,0,2s1.1-.41,1.53-1.34.44-1.84,0-2S589.65,305.12,589.22,306.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M592.86,302.83c.24,1.29,0,2.42-.52,2.68a.74.74,0,0,0,.59.21c.62-.12.91-1.35.64-2.74s-1-2.43-1.6-2.31l-.13.05A3.82,3.82,0,0,1,592.86,302.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M590,306.59a2.81,2.81,0,0,1-1,1.26.43.43,0,0,0,.21.23c.41.19,1.1-.41,1.53-1.34s.44-1.84,0-2a.57.57,0,0,0-.51.07A2.39,2.39,0,0,1,590,306.59Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M589.49,317.91c.24.37-.13,1.15-.87,1.8a3.16,3.16,0,0,1-1.26.7l0,0c.3.34,1.17.07,1.94-.6s1.15-1.5.85-1.85C590.05,317.86,589.8,317.84,589.49,317.91Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M593,306.86a1.09,1.09,0,0,0-.54-.06c1,.64,1,3,0,5.48-.89,2.24-2.32,3.83-3.45,4a1,1,0,0,0,.18.09c1.16.46,2.94-1.28,4-3.9S594.19,307.32,593,306.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M571.27,293.87c1,.8.31,3.2-1.47,5.38s-4,3.31-5,2.52-.31-3.2,1.47-5.38S570.3,293.08,571.27,293.87Zm2.54-1.5c-.94.4-1.56,1.06-1.38,1.48s1.09.44,2,0,1.56-1.06,1.38-1.48S574.75,292,573.81,292.37ZM562.22,303.1c-.51.9-.59,1.8-.19,2s1.12-.32,1.62-1.21.59-1.8.19-2S562.72,302.21,562.22,303.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M562.64,303.86c.43-.77,1-1.28,1.45-1.26,0-.34-.06-.61-.25-.71-.39-.23-1.12.32-1.62,1.21s-.59,1.8-.19,2a.35.35,0,0,0,.18.05A3.23,3.23,0,0,1,562.64,303.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M566.71,297.15c1.77-2.17,4-3.29,5-2.53a1.28,1.28,0,0,0-.4-.75c-1-.79-3.2.34-5,2.52s-2.44,4.59-1.47,5.38h0C564.63,300.68,565.33,298.85,566.71,297.15Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M574.23,293.13a3,3,0,0,1,1.55-.27.52.52,0,0,0,.06-.46c-.18-.42-1.09-.43-2,0s-1.56,1.06-1.38,1.48a.62.62,0,0,0,.48.31A2.75,2.75,0,0,1,574.23,293.13Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M569.38,320.4c-.67.72-2.48.13-4-1.32s-2.27-3.21-1.59-3.94,2.49-.13,4,1.32S570.06,319.68,569.38,320.4Zm3.44.61c-.9-.55-1.85-.65-2.1-.23s.27,1.21,1.18,1.76,1.85.65,2.1.22S573.73,321.56,572.82,321Zm-7.38-9.1c-.65-.84-1.5-1.26-1.89-1s-.17,1.22.49,2.05,1.5,1.26,1.89.95S566.1,312.74,565.44,311.91Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M565.93,314a.57.57,0,0,0,.18-.46,2.38,2.38,0,0,1-1.59-1,2.67,2.67,0,0,1-.67-1.6.49.49,0,0,0-.3.1c-.39.3-.17,1.22.49,2.05S565.54,314.27,565.93,314Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M572.38,322a2.42,2.42,0,0,1-1.24-1.43.57.57,0,0,0-.42.23c-.25.43.27,1.21,1.18,1.76s1.85.65,2.1.22a.47.47,0,0,0,.06-.31A2.7,2.7,0,0,1,572.38,322Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M565.82,318.52c-1.33-1.25-2-2.72-1.78-3.57a1.07,1.07,0,0,0-.28.19c-.68.73,0,2.49,1.59,3.94s3.36,2,4,1.32a.86.86,0,0,0,.2-.36C568.77,320.41,567.2,319.81,565.82,318.52Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M571.18,297.68c.93.81.51,2.8-.94,4.43s-3.35,2.31-4.27,1.5-.5-2.8.94-4.43S570.26,296.87,571.18,297.68Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M576.09,294.52c.34.64-.31,1.64-1.44,2.24s-2.33.57-2.67-.07.31-1.64,1.44-2.24S575.75,293.88,576.09,294.52Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M608.15,291.8c-1.52-2.94-9.5-2-19.94,1.78a11,11,0,0,1,1.62,1.44c6.66-2,11.53-2.26,12.59-.23,1.8,3.46-8.09,12.19-22.09,19.5s-26.83,10.42-28.64,7c-1.14-2.19,2.42-6.51,8.75-11.24a8.09,8.09,0,0,1-.31-2c-9.88,6.72-15.78,13.16-14.18,16.23,2.22,4.25,17.94.43,35.12-8.53S610.37,296,608.15,291.8Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M591.23,293.17a1.67,1.67,0,0,1,0-.63c-1,.31-2,.66-3,1a11,11,0,0,1,1.62,1.44c6.66-2,11.53-2.26,12.59-.23,1.8,3.46-8.09,12.19-22.09,19.5s-26.83,10.42-28.64,7c-1.14-2.19,2.42-6.51,8.75-11.24a8.09,8.09,0,0,1-.31-2c-5.44,3.7-9.67,7.32-12.11,10.33,2.93-2.72,8-7.28,8.16-6.37.22,1.27-11.36,8.18-3.93,11.15s26.77-7.43,34.21-11.57,16.46-11.48,18.37-16.57S591.77,295.51,591.23,293.17Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M552.2,324c0,.08-.34.06-.8.12a13.25,13.25,0,0,1-1.78.14,2.83,2.83,0,0,1-1.9-.74,2.27,2.27,0,0,1-.42-.66,1.76,1.76,0,0,1-.09-.29,1.79,1.79,0,0,1,0-.29,2.56,2.56,0,0,1,.1-.71,5.79,5.79,0,0,1,.85-1.68c.72-1.09,1.61-2,1.73-1.93a12.63,12.63,0,0,1-1,2.32,5.72,5.72,0,0,0-.53,1.51,1.28,1.28,0,0,0,0,.57.91.91,0,0,0,.18.47,2,2,0,0,0,1.21.64c.56.11,1.22.11,1.71.21S552.22,324,552.2,324Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M603.4,300c-.11-.11,1.22-1.7,2.3-3.44a8.35,8.35,0,0,0,1.18-2.4,2.87,2.87,0,0,0,.06-.77c0-.18,0-.28,0-.28a1.44,1.44,0,0,0-.06-.27,1.5,1.5,0,0,0-.32-.61,2,2,0,0,0-.92-.53,8.06,8.06,0,0,0-1.4-.28,10.29,10.29,0,0,0-2.75.06c-.76.12-1.26.26-1.29.18s.42-.35,1.18-.6a8.61,8.61,0,0,1,2.91-.44,7.85,7.85,0,0,1,1.6.18,3,3,0,0,1,1.4.7,2.59,2.59,0,0,1,.64,1,3.92,3.92,0,0,1,.12.42s0,.16,0,.43a3.76,3.76,0,0,1-.16,1.09,8.41,8.41,0,0,1-1.53,2.59A12.09,12.09,0,0,1,603.4,300Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-268",
    cx: 233.58,
    cy: 31.38,
    r: 17.7,
    transform: "translate(117.14 79.28) rotate(-19.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M220.53,20.65A17.7,17.7,0,0,1,251.27,32a17.7,17.7,0,1,0-35.38.07A17.6,17.6,0,0,1,220.53,20.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M219.42,31.38A15.69,15.69,0,0,1,246.66,41a15.69,15.69,0,1,0-28.81-7.6A15.85,15.85,0,0,1,219.42,31.38Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M251.06,28.58a16.15,16.15,0,0,1-30.65-9,17.7,17.7,0,1,0,30.65,9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M249.62,35.81a16.69,16.69,0,0,1-31.46-10.9,16.69,16.69,0,1,0,31.46,10.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M247.68,33.13c-1.82.88-4.3-.45-5.53-3s-.75-5.3,1.07-6.19,4.3.45,5.53,3S249.5,32.25,247.68,33.13Zm-8-7.57c-.57-1.16-1.7-1.77-2.54-1.37s-1.06,1.68-.49,2.85,1.7,1.77,2.54,1.37S240.24,26.73,239.68,25.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M239.68,25.56c-.57-1.16-1.7-1.77-2.54-1.37a1.15,1.15,0,0,0-.33.25,2.35,2.35,0,0,1,2.05,1.48,2.32,2.32,0,0,1-.16,2.6,1.4,1.4,0,0,0,.49-.11C240,28,240.24,26.73,239.68,25.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M248.75,27c-1.23-2.54-3.7-3.87-5.53-3l-.3.18c1.75-.45,3.89.86,5,3.16s.8,5-.77,6a2.47,2.47,0,0,0,.52-.18C249.5,32.25,250,29.48,248.75,27Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-274",
    cx: 227.59,
    cy: 40.63,
    rx: 2.86,
    ry: 3.98,
    transform: "translate(148.77 167.69) rotate(-43.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M231,42.35a.93.93,0,0,1-.16.18c-1.15,1.09-3.31.68-4.82-.92a4.32,4.32,0,0,1-1.3-3.69c-.94,1.13-.61,3.17.83,4.68s3.67,2,4.82.92A2.2,2.2,0,0,0,231,42.35Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M245.48,41c.55,1.12-1.06,3-3.6,4.26s-5,1.31-5.57.18,1.07-3,3.6-4.26S244.94,39.87,245.48,41ZM234,46.43c-1,0-1.86.33-1.87.79s.81.84,1.84.86,1.86-.32,1.87-.78S235,46.46,234,46.43Zm12.55-9.13c-.75,1.21-.92,2.46-.38,2.79s1.58-.38,2.32-1.59.92-2.46.38-2.79S247.31,36.09,246.56,37.3Zm-3.34.53c-.94.39-1.57,1.05-1.39,1.47s1.08.44,2,.05,1.57-1.06,1.39-1.48S244.17,37.43,243.22,37.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M248.08,37.9c-.69,1.12-1.63,1.8-2.19,1.64a.71.71,0,0,0,.29.55c.54.33,1.58-.38,2.32-1.59s.92-2.46.38-2.79l-.13,0A3.75,3.75,0,0,1,248.08,37.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M243.44,38.75a2.86,2.86,0,0,1-1.61.25.44.44,0,0,0,0,.3c.17.42,1.08.44,2,.05s1.57-1.06,1.39-1.48a.55.55,0,0,0-.42-.29A2.44,2.44,0,0,1,243.44,38.75Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M235.41,46.76c-.07.43-.88.75-1.86.73a3.07,3.07,0,0,1-1.4-.33s0,0,0,.06c0,.45.81.84,1.84.86s1.86-.32,1.87-.78C235.85,47.1,235.69,46.91,235.41,46.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M245.48,41a1.08,1.08,0,0,0-.36-.41c.31,1.14-1.26,2.91-3.66,4.07-2.17,1.05-4.3,1.26-5.22.59a1.07,1.07,0,0,0,.07.19c.54,1.13,3,1,5.57-.18S246,42.12,245.48,41Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M238.21,16.72c.18,1.24-1.94,2.57-4.72,3s-5.19-.27-5.37-1.51,1.93-2.57,4.72-3S238,15.48,238.21,16.72Zm2.89.61c-1-.34-1.87-.27-2,.16s.51,1.05,1.48,1.4,1.87.26,2-.17S242.07,17.67,241.1,17.33Zm-15.8.08c-1,.32-1.65.93-1.51,1.37s1.05.52,2,.2,1.65-.93,1.51-1.36S226.27,17.09,225.3,17.41Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M225.1,18.26a2.1,2.1,0,0,1,1.92,0c.24-.24.37-.49.3-.69-.14-.44-1-.53-2-.21s-1.65.93-1.51,1.37a.49.49,0,0,0,.1.15A3.28,3.28,0,0,1,225.1,18.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M232.63,16.06c2.77-.4,5.17.26,5.37,1.49a1.22,1.22,0,0,0,.21-.83c-.19-1.24-2.59-1.91-5.37-1.5s-4.9,1.73-4.72,3v0C228.72,17.25,230.47,16.38,232.63,16.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M240.9,18.18a3,3,0,0,1,1.32.84.53.53,0,0,0,.36-.3c.15-.43-.51-1-1.48-1.39s-1.87-.27-2,.16a.62.62,0,0,0,.16.55A2.73,2.73,0,0,1,240.9,18.18Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M218.9,35c-1,.08-1.92-1.58-2.09-3.7s.51-3.9,1.49-4,1.93,1.58,2.09,3.69S219.89,34.93,218.9,35ZM221,37.78c-.3-1-.93-1.72-1.4-1.58s-.62,1.07-.32,2.09.93,1.72,1.4,1.58S221.33,38.8,221,37.78Zm.7-11.7c.08-1-.26-1.94-.75-2s-1,.79-1,1.84.26,1.95.75,2S221.65,27.14,221.73,26.08Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M220.7,27.93a.57.57,0,0,0,.45-.22,2.36,2.36,0,0,1-.47-1.84,2.7,2.7,0,0,1,.58-1.63.43.43,0,0,0-.28-.13c-.49,0-1,.79-1,1.84S220.21,27.9,220.7,27.93Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M220,38.2a2.35,2.35,0,0,1,.06-1.89.54.54,0,0,0-.47-.11c-.48.14-.62,1.07-.32,2.09s.93,1.72,1.4,1.58a.51.51,0,0,0,.25-.19A2.82,2.82,0,0,1,220,38.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M217.54,31.22c-.14-1.82.34-3.39,1.1-3.84a1,1,0,0,0-.34,0c-1,.07-1.65,1.85-1.49,4s1.1,3.78,2.09,3.7a.9.9,0,0,0,.39-.13C218.44,34.61,217.69,33.1,217.54,31.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-289",
    cx: 233.58,
    cy: 31.38,
    r: 21.63,
    transform: "translate(114.22 0.72) rotate(-0.18)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M235.57,19.47c.13,1.22-1.52,2.4-3.69,2.64s-4-.57-4.16-1.79,1.52-2.4,3.69-2.63S235.44,18.25,235.57,19.47Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M241.33,20.45c-.19.7-1.34,1-2.58.68s-2.1-1.15-1.92-1.85,1.34-1,2.58-.68S241.51,19.75,241.33,20.45Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M266.81,40.1c.85-3.19-5.65-7.9-15.91-12.15a11,11,0,0,1,.22,2.15c6.28,3,10,6.12,9.44,8.34-1,3.77-14.2,3.53-29.46-.54s-26.83-10.44-25.82-14.21c.64-2.39,6.18-3.17,14-2.38a8.13,8.13,0,0,1,1.12-1.69c-11.82-1.71-20.52-.94-21.41,2.4-1.24,4.63,12.94,12.43,31.65,17.42S265.58,44.73,266.81,40.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M253.41,29.69a1.26,1.26,0,0,1,.43-.46c-.94-.43-1.92-.86-2.94-1.28a11,11,0,0,1,.22,2.15c6.28,3,10,6.12,9.44,8.34-1,3.77-14.2,3.53-29.46-.54s-26.83-10.44-25.82-14.21c.64-2.39,6.18-3.17,14-2.38a8.13,8.13,0,0,1,1.12-1.69c-6.51-.94-12.07-1.13-15.9-.56,4,0,10.82.05,10.32.82-.71,1.08-13.91-1.65-10.43,5.57S229.19,38,237.47,40s19.89,2.66,24.74.19S252.22,31.77,253.41,29.69Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M203.78,26.08c-.07,0-.3-.18-.67-.45a14.46,14.46,0,0,1-1.41-1.09,2.81,2.81,0,0,1-.9-1.84,2,2,0,0,1,.14-.77,2.42,2.42,0,0,1,.12-.27,2.69,2.69,0,0,1,.18-.23,2.46,2.46,0,0,1,.55-.46,5.75,5.75,0,0,1,1.77-.66,5.48,5.48,0,0,1,2.58-.25,12.84,12.84,0,0,1-2.34,1,5.64,5.64,0,0,0-1.41.76,1.26,1.26,0,0,0-.37.43.93.93,0,0,0-.18.47A2,2,0,0,0,202.3,24c.34.46.82.91,1.12,1.31S203.84,26,203.78,26.08Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M257.79,42.92c0-.16,2-.43,4-1a7.87,7.87,0,0,0,2.49-1,2.5,2.5,0,0,0,.57-.53,2,2,0,0,0,.16-.23,1.72,1.72,0,0,0,.14-.24,1.41,1.41,0,0,0,.17-.66,2.06,2.06,0,0,0-.31-1,8,8,0,0,0-.85-1.16,10.38,10.38,0,0,0-2.07-1.81c-.64-.42-1.11-.66-1.08-.74a2.7,2.7,0,0,1,1.29.35,8.79,8.79,0,0,1,2.43,1.65,7.66,7.66,0,0,1,1.07,1.21,3.13,3.13,0,0,1,.56,1.46,2.57,2.57,0,0,1-.21,1.17c-.11.25-.19.39-.19.39a3.72,3.72,0,0,1-.27.33,3.63,3.63,0,0,1-.85.7,8.38,8.38,0,0,1-2.88.87A12.18,12.18,0,0,1,257.79,42.92Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-290",
    cx: 142.03,
    cy: 282.29,
    r: 21.91,
    transform: "translate(-50.23 358.88) rotate(-77.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M121.24,284.6a21.91,21.91,0,0,1,36.58-17.49,21.9,21.9,0,1,0-30.49,31.42A21.82,21.82,0,0,1,121.24,284.6Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M129.8,294.84A19.43,19.43,0,0,1,161.88,279a19.43,19.43,0,1,0-31.63,19A19.24,19.24,0,0,1,129.8,294.84Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M154.65,264.38a20,20,0,0,1-34.48,19.37,21.91,21.91,0,1,0,34.48-19.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M159.81,271.9a20.36,20.36,0,0,1,1.54,6.74A20.66,20.66,0,0,1,123,290.37a20.66,20.66,0,1,0,36.84-18.47Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M155.76,271.3c-.79,2.38-4.11,3.42-7.42,2.32s-5.34-3.91-4.55-6.29,4.1-3.41,7.41-2.32S156.55,268.93,155.76,271.3Zm-13.62.56c-1.52-.51-3,0-3.41,1.06s.58,2.39,2.1,2.9,3,0,3.41-1.07S143.66,272.36,142.14,271.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M142.14,271.86c-1.52-.51-3,0-3.41,1.06a1.79,1.79,0,0,0-.07.51,2.93,2.93,0,0,1,3.09-.54,2.88,2.88,0,0,1,2.17,2.39,1.79,1.79,0,0,0,.32-.53C144.6,273.66,143.66,272.36,142.14,271.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M151.2,265c-3.31-1.09-6.63-.06-7.41,2.32a2.17,2.17,0,0,0-.11.42c1.11-1.93,4.12-2.7,7.13-1.71s5.1,3.59,4.67,5.87a3.08,3.08,0,0,0,.28-.61C156.55,268.93,154.51,266.11,151.2,265Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M150,295.66c0,2-2.26,3.52-5,3.48s-4.91-1.66-4.88-3.61,2.25-3.52,5-3.48S150,293.7,150,295.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M149.5,294.09a1.51,1.51,0,0,1,0,.3c0,2-2.25,3.52-5,3.48a5.37,5.37,0,0,1-4.4-2c.19,1.82,2.28,3.27,4.87,3.31s5-1.52,5-3.48A2.88,2.88,0,0,0,149.5,294.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M160.84,280.05c1.47.49,1.77,3.56.66,6.87s-3.18,5.58-4.65,5.09-1.77-3.56-.66-6.87S159.37,279.56,160.84,280.05Zm-5.09,14.86c-.91.89-1.32,1.94-.92,2.34s1.45,0,2.35-.88,1.32-1.94.93-2.34S156.66,294,155.75,294.91Zm2.74-19c.42,1.7,1.38,2.93,2.14,2.74s1-1.72.6-3.43-1.38-2.93-2.14-2.75S158.06,274.19,158.49,275.9Zm-2.42,3.41c-.46,1.18-.42,2.3.11,2.51s1.33-.58,1.79-1.76.42-2.31-.1-2.51S156.54,278.13,156.07,279.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M160.34,275.07c.39,1.58.19,3-.45,3.35a.89.89,0,0,0,.74.22c.76-.19,1-1.72.6-3.43s-1.38-2.93-2.14-2.75l-.16.08A4.65,4.65,0,0,1,160.34,275.07Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M157.08,279.92a3.49,3.49,0,0,1-1.17,1.63.55.55,0,0,0,.27.27c.52.21,1.33-.58,1.79-1.76s.42-2.31-.1-2.51a.7.7,0,0,0-.63.12A3,3,0,0,1,157.08,279.92Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M157.25,294c.31.43-.1,1.43-1,2.28a4,4,0,0,1-1.5,1l0,.06c.39.4,1.45,0,2.35-.88s1.32-1.94.93-2.34A.86.86,0,0,0,157.25,294Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M160.84,280.05a1.41,1.41,0,0,0-.68,0c1.28.72,1.49,3.64.45,6.77-.94,2.82-2.6,4.89-4,5.13a.88.88,0,0,0,.22.1c1.47.49,3.55-1.79,4.65-5.09S162.31,280.54,160.84,280.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M133,265.53c1.25.91.61,3.93-1.44,6.75s-4.72,4.37-6,3.46-.61-3.93,1.44-6.75S131.78,264.62,133,265.53Zm3-2c-1.14.56-1.86,1.43-1.61,1.93s1.38.46,2.51-.1,1.86-1.43,1.61-1.94S137.2,262.92,136.07,263.49Zm-13.58,14.08c-.56,1.14-.6,2.26-.09,2.51s1.37-.48,1.93-1.62.59-2.26.09-2.51S123.05,276.43,122.49,277.57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M123.07,278.48c.48-1,1.19-1.66,1.7-1.66,0-.43-.11-.75-.35-.87-.51-.25-1.37.48-1.93,1.62s-.6,2.26-.09,2.51a.54.54,0,0,0,.22.05A4.1,4.1,0,0,1,123.07,278.48Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M127.63,269.9c2-2.81,4.69-4.35,6-3.47a1.47,1.47,0,0,0-.55-.9c-1.25-.91-3.93.64-6,3.46s-2.69,5.84-1.44,6.75h0C125.3,274.4,126,272.09,127.63,269.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M136.64,264.4a3.73,3.73,0,0,1,1.89-.45.65.65,0,0,0,.05-.57c-.25-.5-1.38-.46-2.51.11s-1.86,1.43-1.61,1.93a.77.77,0,0,0,.62.34A3.41,3.41,0,0,1,136.64,264.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M132.57,298.44c-.79.94-3.06.34-5.08-1.34s-3-3.82-2.24-4.76,3.06-.34,5.08,1.34S133.35,297.5,132.57,298.44Zm4.29.51c-1.16-.61-2.33-.67-2.61-.13s.42,1.48,1.58,2.09,2.33.67,2.61.13S138,299.56,136.86,299Zm-9.76-10.73c-.87-1-1.95-1.45-2.4-1s-.13,1.53.74,2.51,2,1.44,2.41,1S128,289.2,127.1,288.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M127.85,290.73a.74.74,0,0,0,.19-.59,2.9,2.9,0,0,1-2-1.17,3.4,3.4,0,0,1-1-1.92.57.57,0,0,0-.35.13c-.46.4-.13,1.53.74,2.51S127.39,291.13,127.85,290.73Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M136.38,300.19a3,3,0,0,1-1.63-1.69.7.7,0,0,0-.5.32c-.29.54.42,1.48,1.58,2.09s2.33.67,2.61.13a.68.68,0,0,0,.05-.4A3.33,3.33,0,0,1,136.38,300.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M128,296.37c-1.74-1.45-2.72-3.22-2.46-4.29a1.06,1.06,0,0,0-.33.26c-.79.94.21,3.07,2.24,4.76s4.29,2.28,5.08,1.34a1.23,1.23,0,0,0,.22-.46C131.81,298.5,129.82,297.86,128,296.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-311",
    cx: 142.03,
    cy: 282.29,
    r: 26.78,
    transform: "translate(-48.33 198.43) rotate(-47.9)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M133.19,270.24c1.2.94.82,3.42-.85,5.54s-4,3.09-5.18,2.15-.81-3.42.85-5.54S132,269.3,133.19,270.24Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M139,266c.47.77-.26,2-1.62,2.87s-2.84.87-3.3.1.27-2.05,1.63-2.87S138.57,265.22,139,266Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M178.47,260.36c-2.1-3.51-11.88-1.82-24.52,3.61a13.33,13.33,0,0,1,2.1,1.66c8.09-3,14.09-3.6,15.54-1.16,2.48,4.15-9.13,15.63-25.93,25.65s-32.42,14.77-34.9,10.62c-1.57-2.64,2.53-8.22,10-14.51a9.92,9.92,0,0,1-.52-2.45c-11.74,9-18.57,17.38-16.38,21.06,3,5.09,22.2-.74,42.79-13S181.51,265.45,178.47,260.36Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M157.66,263.25a1.7,1.7,0,0,1,0-.78c-1.19.46-2.42,1-3.67,1.5a13.33,13.33,0,0,1,2.1,1.66c8.09-3,14.09-3.6,15.54-1.16,2.48,4.15-9.13,15.63-25.93,25.65s-32.42,14.77-34.9,10.62c-1.57-2.64,2.53-8.22,10-14.51a9.92,9.92,0,0,1-.52-2.45c-6.47,5-11.44,9.72-14.24,13.62,3.44-3.57,9.39-9.56,9.64-8.45.35,1.56-13.47,10.91-4.07,14.06S144.14,291.94,153,286.3s19.54-15.34,21.55-21.77S158.48,266.1,157.66,263.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M111.58,304.14c0,.09-.41.1-1,.2a16.12,16.12,0,0,1-2.19.3,3.42,3.42,0,0,1-2.4-.79,2.45,2.45,0,0,1-.57-.78,2.08,2.08,0,0,1-.13-.35,2.88,2.88,0,0,1,0-.36,3.67,3.67,0,0,1,.07-.88,7.29,7.29,0,0,1,.94-2.14c.81-1.39,1.85-2.61,2-2.5s-.57,1.49-1.12,2.94a7,7,0,0,0-.55,1.9,1.49,1.49,0,0,0,.07.71,1.05,1.05,0,0,0,.25.56,2.45,2.45,0,0,0,1.55.71c.7.1,1.51,0,2.12.13S111.61,304.05,111.58,304.14Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M173.17,270.8c-.15-.13,1.39-2.19,2.6-4.42a10.16,10.16,0,0,0,1.29-3,3.15,3.15,0,0,0,0-1A2.68,2.68,0,0,0,177,262a1.59,1.59,0,0,0-.08-.33,1.91,1.91,0,0,0-.44-.72,2.61,2.61,0,0,0-1.17-.59,9.43,9.43,0,0,0-1.76-.26,13.17,13.17,0,0,0-3.4.28,6.46,6.46,0,0,1-1.57.32c0-.08.5-.47,1.41-.84a10.87,10.87,0,0,1,3.57-.74,10.18,10.18,0,0,1,2,.11,3.67,3.67,0,0,1,1.78.76,3.21,3.21,0,0,1,.86,1.19,3.35,3.35,0,0,1,.17.51,3,3,0,0,1,.07.52,4.07,4.07,0,0,1-.12,1.36,10.22,10.22,0,0,1-1.71,3.3C175.14,269.07,173.31,270.93,173.17,270.8Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-312",
    cx: 805.48,
    cy: 79.27,
    r: 16.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M680.23,68.31a16.21,16.21,0,0,1,27,13.08A16.21,16.21,0,1,0,675,78.26,16.18,16.18,0,0,1,680.23,68.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M678.26,78A14.36,14.36,0,0,1,702.2,89.23a14.37,14.37,0,1,0-25.56-9.53A14.43,14.43,0,0,1,678.26,78Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M707.33,78.29a14.5,14.5,0,0,1-2.86,3.48A14.78,14.78,0,0,1,680.23,67.3a16.21,16.21,0,1,0,27.1,11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M705.37,84.75A15.28,15.28,0,0,1,677.69,72a15.28,15.28,0,1,0,27.68,12.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M703.84,82.13c-1.74.64-3.87-.8-4.76-3.22s-.21-4.89,1.53-5.53,3.87.79,4.76,3.21S705.58,81.49,703.84,82.13Zm-6.6-7.62c-.41-1.11-1.39-1.77-2.19-1.47a1.91,1.91,0,0,0-.71,2.54c.41,1.11,1.39,1.78,2.19,1.48A1.92,1.92,0,0,0,697.24,74.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M697.24,74.51c-.41-1.11-1.39-1.77-2.19-1.47a1.09,1.09,0,0,0-.33.19,2.16,2.16,0,0,1,1.74,1.54,2.12,2.12,0,0,1-.38,2.35,1,1,0,0,0,.45-.06A1.92,1.92,0,0,0,697.24,74.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M705.37,76.59c-.89-2.42-3-3.85-4.76-3.21a1.51,1.51,0,0,0-.29.13c1.63-.25,3.47,1.14,4.28,3.33s.28,4.61-1.24,5.41a2.81,2.81,0,0,0,.48-.12C705.58,81.49,706.27,79,705.37,76.59Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M687.1,90c-1.15.89-3.07.32-4.31-1.27s-1.31-3.6-.16-4.49,3.07-.32,4.31,1.28S688.24,89.15,687.1,90Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M687.78,89l-.16.15c-1.15.88-3.08.31-4.31-1.28a4,4,0,0,1-.85-3.48c-1,1-.84,2.83.33,4.34S686,90.92,687.1,90A2,2,0,0,0,687.78,89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M701.13,89.1c.4,1.08-1.24,2.67-3.66,3.56s-4.7.73-5.09-.34,1.24-2.67,3.66-3.56S700.74,88,701.13,89.1ZM690.19,93c-.93-.11-1.72.13-1.78.54s.67.85,1.6,1,1.73-.13,1.78-.55S691.12,93.13,690.19,93Zm12.26-7.19c-.79,1-1.06,2.15-.6,2.5s1.47-.2,2.26-1.23,1.06-2.16.6-2.51S703.24,84.79,702.45,85.83Zm-3.09.18c-.9.27-1.52.82-1.4,1.22s.95.49,1.84.22,1.53-.82,1.41-1.22S700.26,85.73,699.36,86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M703.78,86.51c-.73,1-1.65,1.5-2.15,1.29a.67.67,0,0,0,.22.53c.46.35,1.47-.2,2.26-1.23s1.06-2.16.6-2.51a.31.31,0,0,0-.12,0A3.44,3.44,0,0,1,703.78,86.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M699.47,86.87A2.66,2.66,0,0,1,698,87a.39.39,0,0,0,0,.28c.12.39.95.49,1.84.22s1.53-.82,1.41-1.22a.53.53,0,0,0-.36-.3A2.29,2.29,0,0,1,699.47,86.87Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M691.44,93.44c-.11.38-.87.61-1.76.5a3,3,0,0,1-1.25-.42.08.08,0,0,1,0,0c0,.42.67.85,1.6,1s1.73-.13,1.78-.55C691.81,93.79,691.67,93.6,691.44,93.44Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M701.13,89.1a1,1,0,0,0-.29-.41c.18,1.07-1.41,2.54-3.7,3.38-2.07.76-4,.76-4.81.07a.61.61,0,0,0,0,.18c.39,1.07,2.67,1.22,5.09.34S701.53,90.18,701.13,89.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M696.69,66.33c0,1.14-2,2.16-4.56,2.28s-4.71-.71-4.76-1.85,2-2.17,4.57-2.29S696.64,65.18,696.69,66.33Zm2.58.81c-.85-.4-1.68-.41-1.86,0s.37,1,1.22,1.4,1.69.41,1.86,0S700.12,67.54,699.27,67.14Zm-14.4-1.35c-.92.21-1.59.7-1.5,1.11s.91.57,1.83.37,1.58-.7,1.49-1.11S685.79,65.59,684.87,65.79Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M684.61,66.55a1.94,1.94,0,0,1,1.74.21c.25-.19.39-.41.34-.6-.09-.41-.9-.57-1.82-.37s-1.59.7-1.5,1.11a.55.55,0,0,0,.08.15A2.9,2.9,0,0,1,684.61,66.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M691.68,65.22c2.56-.11,4.67.71,4.75,1.84a1.11,1.11,0,0,0,.26-.73c-.05-1.15-2.18-2-4.75-1.86s-4.62,1.14-4.57,2.29h0C688,66,689.67,65.32,691.68,65.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M699,67.89a2.69,2.69,0,0,1,1.13.89.47.47,0,0,0,.35-.24c.18-.37-.37-1-1.22-1.4s-1.68-.41-1.86,0a.56.56,0,0,0,.1.51A2.47,2.47,0,0,1,699,67.89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M677.45,81.25c-.9,0-1.6-1.61-1.56-3.56s.81-3.51,1.71-3.49,1.61,1.62,1.57,3.56S678.36,81.27,677.45,81.25ZM679.14,84c-.18-1-.69-1.66-1.13-1.57s-.66.92-.48,1.87.69,1.66,1.14,1.57S679.32,84.92,679.14,84Zm1.7-10.6c.16-1-.06-1.79-.51-1.87s-.94.64-1.1,1.59.06,1.79.5,1.87S680.67,74.33,680.84,73.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M679.73,75a.51.51,0,0,0,.43-.16,2.18,2.18,0,0,1-.26-1.72,2.52,2.52,0,0,1,.67-1.43.45.45,0,0,0-.24-.15c-.44-.07-.94.64-1.1,1.59S679.29,74.88,679.73,75Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M678.21,84.26a2.19,2.19,0,0,1,.22-1.72.51.51,0,0,0-.42-.14c-.45.08-.66.92-.48,1.87s.69,1.66,1.14,1.57a.44.44,0,0,0,.25-.15A2.47,2.47,0,0,1,678.21,84.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M676.56,77.68c0-1.68.61-3.06,1.35-3.4a.84.84,0,0,0-.31-.08c-.9,0-1.67,1.55-1.71,3.49s.66,3.54,1.56,3.56a.81.81,0,0,0,.37-.09C677.07,80.84,676.52,79.4,676.56,77.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-333",
    cx: 691.16,
    cy: 79.27,
    r: 19.81,
    transform: "translate(127.93 237.1) rotate(-19.66)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M694,68.6c0,1.12-1.6,2.05-3.59,2.06s-3.62-.88-3.63-2,1.6-2,3.59-2.07S694,67.47,694,68.6Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M699.2,70c-.23.62-1.31.79-2.41.38s-1.81-1.24-1.58-1.86,1.31-.79,2.41-.38S699.43,69.39,699.2,70Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M720.65,90.21c1.06-2.84-4.44-7.71-13.4-12.51a10.08,10.08,0,0,1,0,2c5.45,3.31,8.59,6.48,7.85,8.44-1.26,3.35-13.25,1.94-26.79-3.14s-23.5-11.93-22.25-15.27c.8-2.13,5.92-2.33,13-.91a7.43,7.43,0,0,1,1.18-1.43c-10.62-2.63-18.62-2.71-19.73.25-1.54,4.11,10.67,12.49,27.27,18.73S719.1,94.31,720.65,90.21Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M709.37,79.51a1.25,1.25,0,0,1,.44-.38c-.82-.48-1.67-.95-2.56-1.43a10.08,10.08,0,0,1,0,2c5.45,3.31,8.59,6.48,7.85,8.44-1.26,3.35-13.25,1.94-26.79-3.14s-23.5-11.93-22.25-15.27c.8-2.13,5.92-2.33,13-.91a7.43,7.43,0,0,1,1.18-1.43,53.45,53.45,0,0,0-14.44-1.94c3.64.33,9.85,1,9.33,1.67-.74.92-12.52-2.75-10,4.13s21.42,13.71,28.79,16.25,17.88,4.21,22.53,2.4S708.1,81.3,709.37,79.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M664.48,71.75c-.07,0-.25-.19-.57-.47a12.82,12.82,0,0,1-1.18-1.13,2.5,2.5,0,0,1-.65-1.75,1.84,1.84,0,0,1,.19-.69,2,2,0,0,1,.14-.23,2.1,2.1,0,0,1,.18-.2,2.29,2.29,0,0,1,.54-.36,5.48,5.48,0,0,1,1.67-.45,5.18,5.18,0,0,1,2.38,0,11,11,0,0,1-2.22.71,5.64,5.64,0,0,0-1.36.56,1.1,1.1,0,0,0-.37.37.72.72,0,0,0-.21.4,1.83,1.83,0,0,0,.3,1.22c.27.45.67.9.91,1.29S664.54,71.72,664.48,71.75Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M712.17,92c0-.14,1.9-.21,3.75-.54a7.2,7.2,0,0,0,2.35-.66,2.52,2.52,0,0,0,.57-.43,1.55,1.55,0,0,0,.16-.2,1.18,1.18,0,0,0,.15-.2,1.35,1.35,0,0,0,.22-.59,1.82,1.82,0,0,0-.2-1,7,7,0,0,0-.66-1.13,9.68,9.68,0,0,0-1.73-1.84c-.54-.44-.94-.69-.91-.76s.5.07,1.14.43a8.24,8.24,0,0,1,2.07,1.72,7.73,7.73,0,0,1,.86,1.2,2.79,2.79,0,0,1,.38,1.38,2.36,2.36,0,0,1-.29,1,2.64,2.64,0,0,1-.22.34,2.15,2.15,0,0,1-.27.28,3.2,3.2,0,0,1-.84.56,7.81,7.81,0,0,1-2.7.54A11,11,0,0,1,712.17,92Z",
    transform: "translate(114.32)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M-15.81,283.15s40.66-4.69,71.94,31.28,13.55,82.34,13.55,82.34,34.93-11.19,52.91,12.27,3.91,49.26,3.91,49.26,49.26-14.07,73.5,30.5S-27.54,566.21-27.54,566.21l-37.53-62.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M70.3,395c0,.13-.09.26-.13.38C70.21,395.23,70.25,395.1,70.3,395Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M70.12,395.5c0,.12-.07.24-.11.34C70.05,395.74,70.08,395.62,70.12,395.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M70.53,394.24c-.06.2-.12.39-.18.56C70.41,394.63,70.47,394.44,70.53,394.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M74.68,366.75v0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M69.75,396.59l0,.11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M70.75,393.5q-.1.36-.21.69Q70.65,393.86,70.75,393.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M70,395.93c0,.12-.08.24-.12.34C69.9,396.17,69.94,396.06,70,395.93Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M69.84,396.33a2,2,0,0,1-.07.19S69.81,396.4,69.84,396.33Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M71.23,391.81l-.18.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M72.9,384.57c-.06.33-.12.65-.19,1C72.78,385.22,72.84,384.9,72.9,384.57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M72.36,387.22c-.07.34-.15.68-.23,1C72.21,387.9,72.29,387.56,72.36,387.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M71,392.72l-.17.58Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M72.65,385.86c-.09.41-.17.82-.26,1.21C72.48,386.68,72.56,386.27,72.65,385.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M69.68,396.77a68.72,68.72,0,0,1,16.47-2.61A68.72,68.72,0,0,0,69.68,396.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M71.54,390.66c-.08.33-.17.64-.25.94C71.37,391.3,71.46,391,71.54,390.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M71.79,389.66c-.07.29-.14.58-.21.85C71.65,390.24,71.72,390,71.79,389.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M72.05,388.57l-.18.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M128.36,457.85l-1.13.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M127.16,458.13l-.56.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M130.09,457.5l-1.68.34Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M126.56,458.29h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M196.93,483.66l1,1.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M126,487.9c18.06,11.71,46.17,4.34,69.75-5.94.36.51.72,1,1.07,1.57-15.36-23.34-38.25-27.57-53.71-27.33C123.57,463.54,105.77,474.77,126,487.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M198.22,485.72c.24.39.48.78.72,1.19C198.7,486.5,198.46,486.11,198.22,485.72Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M132.29,457.12c-.81.13-1.54.25-2.19.38C130.75,457.37,131.49,457.25,132.29,457.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M126.55,458.2l0,.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M69.68,396.77l0,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M126.71,457.9l-.1.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M127.18,456.9c-.16.36-.3.65-.41.88C126.88,457.56,127,457.26,127.18,456.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M82.54,435.05c27,14.57,41.5,8.46,49.16-.8a52.19,52.19,0,0,1-4.5,22.61c2.61-5.72,10.87-27.63-4.61-47.82-9.9-12.91-24.92-15.32-36.44-14.88C67.85,405.05,54.85,420.14,82.54,435.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M137.94,456.45c-1.06.09-2.06.19-3,.31C135.88,456.64,136.88,456.54,137.94,456.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M134.92,456.76c-.94.11-1.82.23-2.62.36C133.1,457,134,456.87,134.92,456.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M143.13,456.2l-1.75.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M141.29,456.25c-1.16.05-2.27.12-3.32.2C139,456.37,140.13,456.3,141.29,456.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M74.63,369.06c0,.59,0,1.18-.07,1.76C74.59,370.24,74.62,369.65,74.63,369.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M-5.06,283.19l1,.08Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M-3.91,283.29l1,.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M-10,283c1.4,0,3,.08,4.84.22C-6.95,283-8.57,283-10,283Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M-10.76,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M73.16,383.16l-.18,1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M3.67,284.31l1.29.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M-2.76,283.4l1.11.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M-1.59,283.53c1.63.19,3.37.44,5.21.77C1.78,284,0,283.72-1.59,283.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M-15.43,283.11h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M5.15,284.59l1.2.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M-15.64,283.13h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M-15.18,283.09h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M-12.22,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M-15.74,283.14h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M-12.92,283l.6,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M-14.85,283.07l.29,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M-14.48,283.05c.42,0,.94-.05,1.54-.07C-13.54,283-14.06,283-14.48,283.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M-10.88,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M74.28,374.74c0,.55-.1,1.09-.16,1.62C74.18,375.83,74.24,375.29,74.28,374.74Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M74.1,376.62c0,.44-.1.88-.16,1.31C74,377.5,74.05,377.06,74.1,376.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M74.42,373.08c0,.43-.07.85-.1,1.28C74.35,373.93,74.39,373.51,74.42,373.08Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M74.53,371.29c0,.43,0,.84-.07,1.26C74.49,372.13,74.51,371.72,74.53,371.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M74.67,367.29c0,.58,0,1.15,0,1.72C74.65,368.44,74.67,367.87,74.67,367.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M6.58,284.89l1.22.27Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M73.68,379.94c-.07.44-.13.88-.2,1.32C73.55,380.82,73.61,380.38,73.68,379.94Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M73.88,378.4c0,.37-.09.74-.14,1.1C73.79,379.14,73.84,378.77,73.88,378.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M73.46,381.39c-.08.48-.16.95-.23,1.41C73.3,382.34,73.38,381.87,73.46,381.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M74.64,363.37c0,.5,0,1,0,1.49C74.67,364.37,74.66,363.87,74.64,363.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M8,285.2l1.31.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M74,354.63c.09.65.16,1.31.23,2C74.12,355.94,74.05,355.28,74,354.63Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M14.07,286.83c.07,41,4.66,105.09,33,100.06C64.84,383.74,71.8,369.67,74,354.62a74.91,74.91,0,0,0-17.83-40.19A90,90,0,0,0,9.46,285.55C11,285.92,12.5,286.35,14.07,286.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M74.55,361.1c0,.63.06,1.26.08,1.89C74.61,362.36,74.59,361.73,74.55,361.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M74.25,357.15c0,.48.09,1,.13,1.42C74.34,358.1,74.29,357.63,74.25,357.15Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M74.43,359.18c0,.5.07,1,.1,1.51C74.5,360.19,74.46,359.68,74.43,359.18Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M765.76,283.15s-40.66-4.69-71.94,31.28-13.55,82.34-13.55,82.34S645.34,385.58,627.36,409s-3.91,49.26-3.91,49.26-49.26-14.07-73.5,30.5,227.54,77.41,227.54,77.41L815,503.65Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M679.65,395c0,.13.09.26.13.38C679.74,395.23,679.69,395.1,679.65,395Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M679.83,395.5c0,.12.07.24.11.34C679.9,395.74,679.87,395.62,679.83,395.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M679.42,394.24c.06.2.12.39.18.56C679.54,394.63,679.48,394.44,679.42,394.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M675.27,366.75v0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M680.2,396.59l0,.11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M679.2,393.5q.1.36.21.69Q679.31,393.86,679.2,393.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M680,395.93c0,.12.08.24.12.34C680.05,396.17,680,396.06,680,395.93Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M680.11,396.33a2,2,0,0,0,.07.19A2,2,0,0,1,680.11,396.33Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M678.72,391.81q.09.35.18.66Q678.81,392.16,678.72,391.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M677.05,384.57c.06.33.12.65.19,1C677.17,385.22,677.11,384.9,677.05,384.57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M677.59,387.22c.07.34.15.68.22,1C677.74,387.9,677.66,387.56,677.59,387.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "M679,392.72c.06.2.11.4.17.58C679.08,393.12,679,392.92,679,392.72Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M677.3,385.86c.08.41.17.82.26,1.21C677.47,386.68,677.38,386.27,677.3,385.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M680.27,396.77a68.72,68.72,0,0,0-16.47-2.61A68.72,68.72,0,0,1,680.27,396.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M678.41,390.66c.08.33.17.64.25.94C678.58,391.3,678.49,391,678.41,390.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M678.16,389.66c.07.29.14.58.21.85C678.3,390.24,678.23,390,678.16,389.66Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M677.9,388.57l.18.77Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M621.59,457.85l1.13.26Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M622.79,458.13l.56.14Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M619.86,457.5l1.68.34Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M623.39,458.29h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M553,483.66l-1,1.51Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M623.93,487.9c-18.06,11.71-46.17,4.34-69.75-5.94-.36.51-.72,1-1.07,1.57,15.36-23.34,38.25-27.57,53.71-27.33C626.38,463.54,644.18,474.77,623.93,487.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M551.73,485.72c-.24.39-.48.78-.72,1.19C551.25,486.5,551.49,486.11,551.73,485.72Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M617.66,457.12c.8.13,1.54.25,2.19.38C619.2,457.37,618.46,457.25,617.66,457.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M623.39,458.2l0,.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M680.27,396.77l0,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M623.24,457.9l.1.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M622.77,456.9c.16.36.3.65.41.88C623.07,457.56,622.93,457.26,622.77,456.9Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M667.41,435.05c-27,14.57-41.5,8.46-49.16-.8a52.19,52.19,0,0,0,4.5,22.61c-2.61-5.72-10.87-27.63,4.61-47.82,9.9-12.91,24.92-15.32,36.43-14.88C682.1,405.05,695.1,420.14,667.41,435.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M612,456.45c1.06.09,2.06.19,3,.31C614.07,456.64,613.07,456.54,612,456.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M615,456.76c.94.11,1.82.23,2.62.36C616.85,457,616,456.87,615,456.76Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M606.82,456.2l1.75.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M608.66,456.25c1.16.05,2.27.12,3.32.2C610.93,456.37,609.82,456.3,608.66,456.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M675.31,369.06c0,.59.05,1.18.08,1.76C675.36,370.24,675.33,369.65,675.31,369.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M755,283.19l-1,.08Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M753.86,283.29l-1,.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M759.92,283c-1.4,0-3,.08-4.84.22C756.89,283,758.52,283,759.92,283Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "M760.71,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M676.79,383.16l.18,1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M746.28,284.31l-1.29.24Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M752.71,283.4l-1.11.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M751.54,283.53c-1.63.19-3.38.44-5.21.77C748.17,284,749.91,283.72,751.54,283.53Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M765.38,283.11h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M744.8,284.59l-1.2.25Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M765.59,283.13h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M765.13,283.09h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M762.17,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "M765.69,283.14h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M762.86,283l-.59,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M764.8,283.07l-.29,0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "M764.43,283.05c-.42,0-.94-.05-1.54-.07C763.49,283,764,283,764.43,283.05Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "M760.83,283h0Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "M675.66,374.74c.05.55.11,1.09.16,1.62C675.77,375.83,675.71,375.29,675.66,374.74Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M675.85,376.62c0,.44.1.88.16,1.31C676,377.5,675.9,377.06,675.85,376.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M675.53,373.08c0,.43.07.85.1,1.28C675.6,373.93,675.56,373.51,675.53,373.08Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M675.42,371.29c0,.43,0,.84.07,1.26C675.46,372.13,675.44,371.72,675.42,371.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M675.28,367.29c0,.58,0,1.15,0,1.72C675.3,368.44,675.28,367.87,675.28,367.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M743.37,284.89l-1.22.27Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M676.27,379.94c.07.44.13.88.2,1.32C676.4,380.82,676.34,380.38,676.27,379.94Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M676.07,378.4c0,.37.09.74.14,1.1C676.16,379.14,676.11,378.77,676.07,378.4Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M676.49,381.39c.08.48.15.95.23,1.41C676.64,382.34,676.57,381.87,676.49,381.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M675.31,363.37c0,.5,0,1,0,1.49C675.28,364.37,675.29,363.87,675.31,363.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M741.94,285.2l-1.31.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M676,354.63c-.09.65-.16,1.31-.23,2C675.83,355.94,675.9,355.28,676,354.63Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M735.88,286.83c-.07,41-4.66,105.09-33,100.06-17.76-3.15-24.72-17.22-26.88-32.27a74.84,74.84,0,0,1,17.83-40.19,90,90,0,0,1,46.67-28.88C739,285.92,737.45,286.35,735.88,286.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M675.4,361.1c0,.63-.06,1.26-.08,1.89C675.34,362.36,675.36,361.73,675.4,361.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M675.7,357.15c-.05.48-.09,1-.13,1.42C675.61,358.1,675.65,357.63,675.7,357.15Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "M675.52,359.18c0,.5-.07,1-.1,1.51C675.45,360.19,675.49,359.68,675.52,359.18Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M455.54,322.15l6.84-.89q5.43,41.36-14.76,56.25,11.91-23.55,7.92-55.36",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M416.83,240.79s2.73,35.44,4.6,41.53q3.93,23.22-5.73,23.07-9.69-18-13-31.65c-27.77,28.4-13.21-42,14.15-33",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M322.62,402.11a17.62,17.62,0,0,0,4.26,1.8,7.49,7.49,0,0,1,10.82,1.19q3.19-.06,6.89-.47a7.49,7.49,0,0,1,12.81-2.18q2.78-.6,5.73-1.35a7.48,7.48,0,0,1,13.06-3.67l1.54-.48q-1.67-3.69-3.06-6.68c0,2.85-25.7,12.26-52.05,11.84",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M415.7,305.39q-9.69-18-13-31.65a8.17,8.17,0,0,1-3.67,2.05,51.81,51.81,0,0,1-20.16,1.42,8.45,8.45,0,0,1-1.45-.28l.19,3.18a8.43,8.43,0,0,1-7.88,8.89l-30.13,1.82-11.85.71a8.12,8.12,0,0,1-2.71-.28l-4.64.28a8.33,8.33,0,0,1-8.8-7.8l-.18-2.84-7.26.32a5.41,5.41,0,0,1-1.4-.12q7.68,52.85,20.77,80.65a83.72,83.72,0,0,0,10,0l.3.15q13.29-.92,30.56-7.33a149.62,149.62,0,0,0,3.3-20.94c10.33,8.63,18,14.13,23.28,16a46,46,0,0,0,21.45,2.8,97.29,97.29,0,0,0,4.31-9.73,67.69,67.69,0,0,0,4.62-27.36q-3.06-5.14-5.65-10",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M372.19,374.59a117.3,117.3,0,0,0-7.63-19.78,96.77,96.77,0,0,1-30.7,7.18c.85,1.9,1.75,4,2.54,6.22,2.11,5.87,3.39,12.13.68,15.19a2.85,2.85,0,0,1-.23.26c-5.73,6.2-13.31,4.28-16,.45-.29.07-.58.13-.89.18-3.1.52-4.62,5-4.26,9.36,1.28,2.11,4.29,2.71,9.09,2.12a230.1,230.1,0,0,0,36.91-7.37,14.22,14.22,0,0,1,10.41-13.81Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M361.68,388.4a230.1,230.1,0,0,1-36.91,7.37c-4.8.59-7.81,0-9.09-2.12.37,4.36,2.63,8.61,7.11,8.68H323l-.39-.22c26.35.42,52.07-9,52.05-11.84l.15.34a.49.49,0,0,0,0-.12,62.67,62.67,0,0,0-2.64-15.9h-.1a14.22,14.22,0,0,0-10.41,13.81",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M337.08,383.4c3.73-4.21-.09-14.43-3.22-21.41a82.31,82.31,0,0,1-10.18,0c5.2,12.2,4.42,20.34-2.85,22.15,2.75,3.89,10.49,5.8,16.25-.71",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M407.89,252.7A46.26,46.26,0,0,1,424.71,254a80.38,80.38,0,0,1,0,23.18c-.49,3.15-2.61,5.8-5.8,5.8h-5c-3.19,0-6.1-2.62-5.81-5.8a131.9,131.9,0,0,0-.18-24.45",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M310.39,264.08l1,16.81.18,2.84a8.33,8.33,0,0,0,8.8,7.8l4.64-.28,14.56-.88.1-17.29-13.74-5.36.22-14.13-8,.49a8.33,8.33,0,0,0-7.8,8.8Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M325.94,267.72l13.74,5.36-.1,17.29L362,289a8.34,8.34,0,0,0,7.8-8.8l-1.26-20.85a8.34,8.34,0,0,0-7.62-7.79,6.75,6.75,0,0,0-1.19,0l-33.54,2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M355.21,253.53s5.49,28.22-16.44,31l.42,1.33.39,2.32.55,1.8,18.46-.71,8-1.56,3.76-7.29L369.1,268l-.92-11.63-4-3.51-8.45-.13Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M368.51,259.37l1.26,20.85A8.34,8.34,0,0,1,362,289l-22.39,1.35v.45L369.71,289a8.43,8.43,0,0,0,7.88-8.89l-.19-3.18c-2.38-.67-4.28-2.31-4.46-4.84a.34.34,0,0,0,0-.1,9.82,9.82,0,0,1,.61-5.35c.53-1.65,1.48-2.95,3.06-2.94l-.28-4.64a8.43,8.43,0,0,0-8.89-7.88l-6.54.4a8.34,8.34,0,0,1,7.62,7.79",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M368.51,259.37l1.26,20.85A8.34,8.34,0,0,1,362,289l-22.39,1.35v.45L369.71,289a8.43,8.43,0,0,0,7.88-8.89l-.19-3.18c-2.38-.67-4.28-2.31-4.46-4.84a.34.34,0,0,0,0-.1,9.82,9.82,0,0,1,.61-5.35c.53-1.65,1.48-2.95,3.06-2.94l-.28-4.64a8.43,8.43,0,0,0-8.89-7.88l-6.54.4a8.34,8.34,0,0,1,7.62,7.79",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M373.54,266.64a15.7,15.7,0,0,0-.61,5.35v.1c.18,2.53,2.08,4.17,4.46,4.84a8.45,8.45,0,0,0,1.45.28A51.81,51.81,0,0,0,399,275.79a8.17,8.17,0,0,0,3.67-2.05,4.88,4.88,0,0,0,1.46-3.85c-.21-2.92-1.77-9.56-6.06-7.36Q388,267.71,377.91,264a3.75,3.75,0,0,0-1.31-.26c-1.21,0-2.35,1.22-3.06,2.94m-.61,5.35a6,6,0,0,0,4.47,4.94c-2.38-.67-4.28-2.31-4.46-4.84A.34.34,0,0,0,372.93,272Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M407.89,252.7a43.53,43.53,0,0,1,9.68,0,56.38,56.38,0,0,1,8,1.2c4.95,1.11,9.57,2.86,15,2q12.38,14.52,13.2-1.25c35.47,10.06,22.82-25.14-39.71-38.6-5.76-1.24-11.95-2.29-18.56-3.11q-5.93-.73-12.31-1.2a63.71,63.71,0,0,1-77,2.5C226.45,247.35,212.07,268,245,266.83q.56,14.16,16.25-2.29a423.28,423.28,0,0,0,44.14-10,39.74,39.74,0,0,0-1.22,9.78l6.25-.27-.07-1.2a8.33,8.33,0,0,1,7.8-8.8l8-.49,33.54-2a6.75,6.75,0,0,1,1.19,0l6.54-.4a8.43,8.43,0,0,1,8.89,7.88l.28,4.63a4,4,0,0,1,1.31.27q10.08,3.77,20.17-1.43l0-8.43a87.4,87.4,0,0,1,9.85-1.4",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M410,216.33s-53.17,49.52-107.2,2.65l11.54-5.54L343,208.56S399.87,207.11,410,216.33Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M311.4,280.89l-1-16.81-6.25.27a6,6,0,0,0-5.87,5.86v5.14a5.9,5.9,0,0,0,4.47,5.74,5.41,5.41,0,0,0,1.4.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M416.73,342.74a97.29,97.29,0,0,1-4.31,9.73c11.54.78,15.34,8.15,16.19,13a5.65,5.65,0,0,0,5.78-.14,5.94,5.94,0,0,0,2.61-5.17c-.06-9.57-6.68-15.38-20.27-17.45",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M416.73,342.74c13.59,2.07,20.21,7.88,20.27,17.45a5.94,5.94,0,0,1-2.61,5.17,5.65,5.65,0,0,1-5.78.14c.08.48.14.95.17,1.37.26,3.65,5.06,7.07,9.69,8.56,3.13-1.51,6.75-6.51,7.43-9.89,2.83-14,3.62-23.53,2.48-33.79a10.54,10.54,0,0,1-7.57-13.44c-5.21-1-11.8-1.95-19.46-2.93a67.69,67.69,0,0,1-4.62,27.36",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M448.38,331.75c1.14,10.26.35,19.84-2.48,33.79-.68,3.38-4.3,8.38-7.43,9.89,3.07,1,6.07,1.13,7.62-.07,8.88-6.86,12.55-29.91,7.65-51.32-.57-2.47-5.23-4.21-12.93-5.73a10.54,10.54,0,0,0,7.57,13.44",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M457.85,322.68c-.33-9,7-2.23,9.14-7.29a3.33,3.33,0,0,0-.52-3.47c-2.14-2.53-12.46-.88-13.09,2-.67,3.08-1.46,4.84-1.54,7.41,2.23-.31,4.81,1.65,6,1.31",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M461.36,348.08a2.19,2.19,0,1,0,2.19-2.19,2.18,2.18,0,0,0-2.19,2.19",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M461.38,365.29a2.19,2.19,0,1,0,1.51,2.7,2.18,2.18,0,0,0-1.51-2.7",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M462.44,330.77a2.19,2.19,0,1,0-2.19-2.19,2.19,2.19,0,0,0,2.19,2.19",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M349.43,407.2a2.19,2.19,0,1,0,2.19-2.18,2.19,2.19,0,0,0-2.19,2.18m18.9-4.9a2.19,2.19,0,1,0,2.19-2.18A2.19,2.19,0,0,0,368.33,402.3Zm-34.41,7.81a2.19,2.19,0,1,0-2.19,2.19A2.19,2.19,0,0,0,333.92,410.11Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M353.81,407.2a2.19,2.19,0,1,1-2.19-2.18,2.19,2.19,0,0,1,2.19,2.18m-9.67,0a7.46,7.46,0,1,0,.45-2.57A7.48,7.48,0,0,0,344.14,407.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M363,402.3a7.5,7.5,0,1,0,.1-1.2,8,8,0,0,0-.1,1.2m7.49,2.19a2.19,2.19,0,1,1,2.18-2.19A2.19,2.19,0,0,1,370.52,404.49Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M395.47,212.92c6.61.82,12.8,1.87,18.56,3.11a46.16,46.16,0,0,0-7.4-11.35q-6.42,4.5-11.16,8.24",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M395.47,212.92q4.74-3.75,11.16-8.24L391,204.2a64.36,64.36,0,0,1-7.79,7.52q6.38.47,12.31,1.2",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M382.78,387.06a43.72,43.72,0,0,0-8,.18,8,8,0,0,1,.11,3.4l1.05,2.29c7.35-1.11,2.9,6.63,8.05,7.77a3.34,3.34,0,0,0,3.31-1.16c2.08-2.59-1.48-12.41-4.47-12.48",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M332.84,364.66q11.09,23.14-8.31,20.48,14.43-.36,8.31-20.48",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M468.3,245.34q5.86,12.85-18.49,2.44,3.29,4.16,10.43,5.95c4.47.73,7.57.42,9.31-.65,1.09-.66,1.44-1.85,1.05-3.37A13,13,0,0,0,468.3,245.34Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M339.57,292.78l.23,0a1.76,1.76,0,0,0,1-.5,1.78,1.78,0,0,0,.22-.26l-2.79.18a1.67,1.67,0,0,0,.23.23A1.78,1.78,0,0,0,339.57,292.78Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M379,275.62c-3.83-.37-5.1-2.14-4.32-6.42.08,3.44,2.9,4.33,8,4.06,14-.72,19.69-4,17.22-9.15,3.85,3.64,3.18,8.13.2,9.48Q391.77,276.86,379,275.62Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M348.71,347.57q-2,8.58-12,11.67c1.63-.16,3.25-.36,4.85-.61l.1,0h0a124.76,124.76,0,0,0,20.61-5.72q1.2-5.67,1.9-10.16c.42-2.62.72-5,.92-7.21q-13.17,2.61-30.16-1.73.78,3.93,9.43,6.85c3.29,1.56,4.81,3.52,4.59,5.9A6.73,6.73,0,0,1,348.71,347.57Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M304.06,279.61l5.46-.25-.32-5.21a8.63,8.63,0,0,1-9.14.55v1a4.26,4.26,0,0,0,1.22,2.77,3.69,3.69,0,0,0,2.62,1.13Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M337.84,284.44c-9,3-21.14,4-24.48-.64a6.56,6.56,0,0,0,6.85,6.14h0l-4.52.27q5.55,2.48,22.15-.81v-.53Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M364.54,255.16c-.17-.15-.35-.29-.54-.43l-.39-.26A7,7,0,0,1,364.54,255.16Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M364.88,255.48a7.11,7.11,0,0,1,1.66,2.93A6.64,6.64,0,0,0,364.88,255.48Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M366.54,258.43v0Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M320.21,289.94h0Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M243.62,262.06q-4.23,2.83-12.6-.84a1.76,1.76,0,0,0,1.06,1.67c2.1,1.23,6.12,1.8,11.95,1.65q1.92-3.21,6.9-5.62A19.31,19.31,0,0,0,243.62,262.06Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M406.05,264.58c0-2.52-.16-5-.33-7.51,0-.49-.07-1-.11-1.46-1.55.18-3,.4-4.47.64l-.32.21-.28,0,0,4.13a4.52,4.52,0,0,1,1.95.93,7.2,7.2,0,0,1,1.81,2.34,17.13,17.13,0,0,1,1.6,6.1,6.54,6.54,0,0,1-.76,3.61c.17.69.36,1.4.56,2.12C406,271.77,406.11,268.1,406.05,264.58Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M410.68,256.41c2.23-.19,4.71-.29,7.46-.29q2.06,0,4.32.06c-1.46-.32-2.92-.58-4.39-.76l-.89-.1a59.36,59.36,0,0,0-6.5-.11h-.09Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M416.49,294.4a6.44,6.44,0,0,1-.47,2.71,11.6,11.6,0,0,1-.93,1.87c.63,1.27,1.3,2.56,2,3.86q1.77-.7,2.47-3.56,1.14-4.61-.15-13.66h-5.51l-.76,0a8.62,8.62,0,0,1-4.84-2.07c.5,1.38,1.05,2.77,1.64,4.2a11,11,0,0,0,5.2,1.16Q417,289.89,416.49,294.4Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M391.6,293.94q9.07,22.19,22.06,35.74a4.21,4.21,0,0,1,1,2.93,4.64,4.64,0,0,0-1-2.93c2.6,1.49,4.17.51,4.68-2.82.28-2,.46-4,.55-5.91q.09-2.34,0-4.65Q405.6,293.8,401,277.17a12.19,12.19,0,0,1-1.47.52c-.6.16-1.2.32-1.8.46a51.34,51.34,0,0,1-8.24,1.28l-.58,0a59.45,59.45,0,0,1-9.55-.23l.05.94a10.2,10.2,0,0,1-8.53,10.66,8.86,8.86,0,0,1-1,.12l-30.25,1.82-11.73.71a10.06,10.06,0,0,1-1.65,0,11.92,11.92,0,0,1-1.33-.23l-1.24.07a19.94,19.94,0,0,1-3.85.21,10,10,0,0,1-4.1-.93h0a7.94,7.94,0,0,1-1.5-.87,9.68,9.68,0,0,1-.95-.74A10.08,10.08,0,0,1,309.8,284l-.07-1.09c.1,10.75,6.69,14.85,19.89,14.21,21.71-1.05,37.52-.34,46.85-2.56,2.68-.65,3.89-2.37,4.83-4.38a5.65,5.65,0,0,1,3.92-3.32q4.17.36,6.38,7.07",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M385.51,257.36a2,2,0,0,1-.14,3.64h0c-.33,0-.68-.07-1.05-.13-.53-.07-1.13-.17-1.82-.3a3.33,3.33,0,0,1-.95-.18,4.23,4.23,0,0,1-2.5-3.16q-1.43-6.38-9.23-7.49a10.22,10.22,0,0,1,8.28,9.39l.2,3.25.23.09a22,22,0,0,0,9.32,1.41c.49,0,1-.09,1.46-.16a23.9,23.9,0,0,0,6.27-1.8l0-6.1c-.91-.13-1.87-.28-2.9-.45-1.57-.26-3.27-.56-5.12-.91l.13,0-.4-.08q3.59-1,7-1.83l1.28-.29v0l1-.2,1-.19q3.6-.72,7-1.12c1-.11,1.93-.21,2.93-.29h.11a45.55,45.55,0,0,1,9-.15l1.05.09.39,0a59.62,59.62,0,0,1,8.11,1.24c1.25.28,2.16.51,3.07.74a32,32,0,0,0,9.17,1.41,17.75,17.75,0,0,1,1.48-7,12.27,12.27,0,0,0,2.94,8.1,40.58,40.58,0,0,0,3.2,3.33,12.62,12.62,0,0,0,2.72,2,2,2,0,0,0,1.13.35c.09,0,.23-.21.41-.56a21.75,21.75,0,0,1-7.83-7.6h0a20.39,20.39,0,0,1-2-5.39c-.69-2.61-1.38-2.75-2.07-.4a167,167,0,0,0-21.12-1.27,89.87,89.87,0,0,0-19.17,2,49.06,49.06,0,0,0-13.47,5.08c-2.09,2-2,3.58.41,4.74l.5.2Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M314.37,242.8a13.36,13.36,0,0,0-6.38,2.92Q280.1,253,264.1,257.55c1.12-12.26-9.31,8.43-16.05,12.85.55,1.17.32.73.92.64q2.59-.36,7.86-5.43c.56-.55,1.15-1.13,1.76-1.76l0,0a13.88,13.88,0,0,0,3.65-5.74,23.42,23.42,0,0,1,.32,3.86q10.71-1.89,20.77-4.17,10.86-2.44,21.3-5.43a29.16,29.16,0,0,1,7.73-7.77l-.3.08C312.85,244,313.61,243.39,314.37,242.8Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M430.44,326.74v-.26a2.26,2.26,0,0,0,0,.26m1.13,2.14a2.92,2.92,0,0,1-.32-.28A2.79,2.79,0,0,0,431.57,328.88Zm2.13.62h-.27Zm1.93-1a3.73,3.73,0,0,1-.35.34A3.73,3.73,0,0,0,435.63,328.5Zm.72-1.95a2.89,2.89,0,0,1-.32,1.35l0,0a3.08,3.08,0,1,1-5.05-3,3,3,0,0,1,5.35,1.73Zm5.25,12.07a23.23,23.23,0,0,1,1.23,3.58,26,26,0,0,1,.51,2.57,44.79,44.79,0,0,1-4,28.15l-.4.2.11,0a15.38,15.38,0,0,0,2.6-2.76,13.69,13.69,0,0,0,2.56-5,144.45,144.45,0,0,0,2.69-18.06,80.78,80.78,0,0,0-.12-14,12.08,12.08,0,0,1-3.3-1.78,12.29,12.29,0,0,1-4.83-8.57,12.09,12.09,0,0,1,0-2.33c-4.14-.76-9.08-1.47-14.66-2.2,0,2.67-.66,8.7-1,11.42-.18,4.16,2.23,3.22,6.21,3.88l1.12.13c.51.07,1,.13,1.48.21a3.21,3.21,0,0,0-.84,2.2,3,3,0,0,1,1.7-2.07h0l.06,0h0l.16-.06h0l.09,0h1.64l0,0h0l.08,0h0l.1,0h0l.07,0h0l.1,0,0,0h0l0,0h0l0,0h.06l0,0h0l0,0,.05,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0,0,0h0l0,0,0,0h0l0,0h0l0,0h0v0l0,0h0l0,0h0l0,0v0h0l0,0h0l0,0a2.53,2.53,0,0,1,.31.42,3,3,0,0,1-.05,3.19h0a3.19,3.19,0,0,0,.85-3.29,18.22,18.22,0,0,1,1.83.67l.1,0A4.72,4.72,0,0,1,441.6,338.62Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M357.09,372.43a3.39,3.39,0,0,1,.54-.66,3.46,3.46,0,0,0-.54.66m-.19.38c0-.08.08-.17.12-.26C357,372.64,356.93,372.73,356.9,372.81Zm-.14,1.9a3.07,3.07,0,0,1-.1-.74c0-.08,0-.16,0-.23A3.14,3.14,0,0,0,356.76,374.71Zm1.15,1.67a3.8,3.8,0,0,1-.48-.42A3.21,3.21,0,0,0,357.91,376.38Zm2.32-5.31a3,3,0,0,1-.61,5.85,3.08,3.08,0,0,1-.61-.06,3,3,0,1,1,1.22-5.79Zm-.61-.06.38,0a3,3,0,0,0-1.19.09A2.73,2.73,0,0,1,359.62,371Zm-6.11,4.36.09.59a3.14,3.14,0,0,0-2.85-1.54,3,3,0,0,1-.62,5.86,2.86,2.86,0,0,1-1.06-.2,3.12,3.12,0,0,0,3.71,0,3.07,3.07,0,0,0,1.15-1.73c.14,1,.28,2.11.42,3.34a6.07,6.07,0,0,1-3.34,4.89,10.68,10.68,0,0,1-1.13.5,64.58,64.58,0,0,1-8.81,3q-13.67,4.2-23,3.61a4.27,4.27,0,0,0,1.08.42l.06,0a15.88,15.88,0,0,0,5.36,0c6.44-.8,12.72-1.78,18.82-3,5.67-1.12,11.21-2.43,16.58-4a15.93,15.93,0,0,1,9.3-13.31,118.23,118.23,0,0,0-6.09-16,102.6,102.6,0,0,1-19,5.3l-.6.11-1.19.21-.9.15q9.07-.6,11.5,8.9c.1.35.23.94.38,1.8,0,.1,0,.21.05.33S353.48,375.14,353.51,375.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M321.39,399.56a4.28,4.28,0,0,0,1.27.24,130.86,130.86,0,0,0,36.15-4.87l13.36-4.48v0a55.16,55.16,0,0,0-1.78-12.25,13.1,13.1,0,0,0-5.25,10.47,1.31,1.31,0,0,1,0,.68c-1.06,4.15-38.19,9.89-43.76,10.24",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M350.13,374.36a3,3,0,0,0-2.38,4.72,2.73,2.73,0,0,1,2.38-4.72m-8.4,1.86a50.21,50.21,0,0,0-2.82-12.13c-.73.1-1.45.18-2.16.26a57.88,57.88,0,0,1,3,9.14c1,4.48,1,8.65-1.35,11.27a15.7,15.7,0,0,1-3.52,3,12.4,12.4,0,0,1-7.77,1.82,11.49,11.49,0,0,1-6.36-2.71l-.23-.21.18.18-.18-.18-.36.06c-1,.17-1.71,1.58-2,3.43,1.09-2.38,2.44-3,4.07-2l0,0,0,0q6.09,4.69,14.52-.17c.32-.19.66-.39,1-.61Q342.22,384.28,341.73,376.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M435.72,371.68c-1.6-1.36-3.12-2.72-.39-3.23,11.41-6,4.19-24.59-15.07-28.08-.14.43-.28.86-.43,1.28,5.74,1.19,10.15,3.13,13.28,5.83a16.33,16.33,0,0,1,5.67,12.88,8.39,8.39,0,0,1-.87,3.84,7.21,7.21,0,0,1-2.57,2.84,7.38,7.38,0,0,1-3.61,1.14,5.72,5.72,0,0,0,.39.56,12.24,12.24,0,0,0,3.6,2.94",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M432.66,335.32a2.16,2.16,0,0,1,2.07.42,2.2,2.2,0,0,1,.72,2,1.86,1.86,0,0,0-2.79-2.41",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M432.11,325.31a2.16,2.16,0,0,1,2.07.42,2.19,2.19,0,0,1,.72,2,1.86,1.86,0,0,0-2.79-2.41",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M443.73,321.67q0,6.42,7.47,7.94,2.88,28.06-3.49,40.36c2.31-3.65,4-9,4.94-15.21a83.4,83.4,0,0,0-1.34-30c-.23-1-2.94-2-7.58-3.1",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M430.84,336.58a3,3,0,0,0,5.29,2.12,2.85,2.85,0,0,1-5.29-2.12",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M352.55,406.45a1.68,1.68,0,0,1-1.95,2.24,1.74,1.74,0,0,0,.66.31,1.82,1.82,0,0,0,1.42-.21,1.93,1.93,0,0,0,.86-1.16,1.88,1.88,0,0,0-.22-1.42,1.85,1.85,0,0,0-1.16-.85,1.91,1.91,0,0,0-1,0,1.68,1.68,0,0,1,1.37,1.07",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M354.05,409a5,5,0,0,1-6.2,2.19,5.34,5.34,0,1,0,4.22-9.1,5,5,0,0,1,2.34,6.14,2.86,2.86,0,0,1-.36.77",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M353.16,404.92a2.9,2.9,0,1,1-3.47,4.63,3,3,0,1,0,3.47-4.63",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M351,402.08a5.33,5.33,0,0,0-3.95,8q-1-5.85,3.95-8",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M333.7,410.32a2.19,2.19,0,1,1-2.19-2.19,2.19,2.19,0,0,1,2.19,2.19m-9.67,0a7.49,7.49,0,0,0,15,0,7.5,7.5,0,0,0-7.49-7.48,7.48,7.48,0,0,0-7,4.91A7.28,7.28,0,0,0,324,410.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M332.45,409.56a1.69,1.69,0,0,1-1.95,2.25,1.83,1.83,0,0,0,.66.31,1.88,1.88,0,0,0,1.42-.22,1.88,1.88,0,0,0,.64-2.57,1.93,1.93,0,0,0-1.16-.86,1.84,1.84,0,0,0-1,0,1.69,1.69,0,0,1,1.38,1.06",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M333.94,412.09a5,5,0,0,1-6.2,2.18,5.34,5.34,0,1,0,4.22-9.09,5,5,0,0,1,2.34,6.14,2.84,2.84,0,0,1-.36.77",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M333.05,408a2.9,2.9,0,1,1-3.47,4.63,3,3,0,1,0,3.47-4.63",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M330.85,405.2a5.34,5.34,0,0,0-4,8q-1-5.83,4-8",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M458.73,374.59a7.48,7.48,0,1,0,4.1-14.39,7.48,7.48,0,0,0-5.23,14,7.28,7.28,0,0,0,1.13.42m4.16-6.6a2.19,2.19,0,1,1-1.51-2.7A2.21,2.21,0,0,1,462.89,368Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M460.31,366.29a1.67,1.67,0,0,1,1.56.75,1.7,1.7,0,0,1,.06,1.74,2,2,0,0,0,.49-.55,1.94,1.94,0,0,0,.18-1.43,1.88,1.88,0,0,0-3.44-.44,1.77,1.77,0,0,0-.25,1,1.68,1.68,0,0,1,1.4-1",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M463.15,365.54a5,5,0,0,1,.4,6.57,5.35,5.35,0,1,0-7.59-6.56,5,5,0,0,1,6.55-.56,2.82,2.82,0,0,1,.64.55",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M459,365.29a2.9,2.9,0,1,1,3.5,4.6,3,3,0,1,0-3.5-4.6",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M455.68,366.63a5.32,5.32,0,0,0,6.59,6q-5.89-.64-6.59-6",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M464.15,346a2.19,2.19,0,1,0,1.5,2.71,2.19,2.19,0,0,0-1.5-2.71",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M463.61,355.39a7.28,7.28,0,1,0-1.18-.08,6.63,6.63,0,0,0,1.18.08m2.08-7.33a2.14,2.14,0,1,1-2.16-2.12A2.14,2.14,0,0,1,465.69,348.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M462.8,347.17a1.65,1.65,0,0,1,2.21,1.89,1.83,1.83,0,1,0-3.24-.54,1.66,1.66,0,0,1,1-1.35",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M465.26,345.69a4.91,4.91,0,0,1,2.19,6,5.22,5.22,0,1,0-8.93-4.05,4.91,4.91,0,0,1,6-2.34,2.92,2.92,0,0,1,.76.35",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M461.3,346.59a2.84,2.84,0,0,1,2.66-1.34,2.81,2.81,0,0,1,2.39,1.76,2.84,2.84,0,0,1-.49,2.94,2.92,2.92,0,1,0-4.56-3.36",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M458.55,348.77a5.22,5.22,0,0,0,7.84,3.8q-5.72,1-7.84-3.8",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M462.5,335.9a7.29,7.29,0,1,0-1.17-.08,9,9,0,0,0,1.17.08m2.08-7.34a2.14,2.14,0,1,1-2.16-2.12A2.14,2.14,0,0,1,464.58,328.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M461.69,327.68a1.63,1.63,0,0,1,2.21,1.88,1.76,1.76,0,0,0,.3-.65,1.83,1.83,0,0,0-.22-1.38,1.82,1.82,0,0,0-2.53-.6,1.81,1.81,0,0,0-.82,1.13,1.87,1.87,0,0,0,0,1,1.63,1.63,0,0,1,1-1.35",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M464.07,326.22a5.05,5.05,0,0,1,2.25,6.21,5.37,5.37,0,0,0-3.87-9.12,5.41,5.41,0,0,0-3.78,1.6,5.35,5.35,0,0,0-1.52,3.36,5.05,5.05,0,0,1,6.15-2.4,3.15,3.15,0,0,1,.77.35",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M460.07,327.23a2.84,2.84,0,1,1,4.55,3.35,2.91,2.91,0,1,0-4.55-3.35",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M457.29,329.61a5.22,5.22,0,0,0,7.84,3.79q-5.7,1-7.84-3.79",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M418.58,345c18.09,2.44,20.14,19.12,12.36,19.56q6.31-10.74-12.36-19.56",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M359.62,371a3,3,0,1,1-3,3,3,3,0,0,1,3-3",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M350.13,374.36a3,3,0,1,1-3,3,3,3,0,0,1,3-3",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M433.79,333.93a3,3,0,1,1-3,3,3,3,0,0,1,3-3",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M433.39,323.59a3,3,0,1,1-3,3,3,3,0,0,1,3-3",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M365.56,331c.73-.16,1.42-.33,2.08-.5q1.75,1.58,3.78,3.24a45.48,45.48,0,0,1-4.9,1.44q-13.87,3.21-32.15-1.55c5.17-1.3,17.47.55,31.19-2.63",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M373.38,393.67a9.4,9.4,0,0,1,1,.39h0l-.37-.8-.63.41M357,399.84a8.7,8.7,0,0,1,1,.83l1.82-.42,1.83-.44a10.34,10.34,0,0,1,.56-1.43c-.72.23-1.48.45-2.25.67C359,399.32,358,399.58,357,399.84Zm-18.7,3.42.2.21q1.13,0,2.4-.12c.8-.05,1.62-.12,2.47-.21.11-.2.22-.4.34-.6C342,402.81,340.15,403.06,338.31,403.26Zm-14.4,1.67a18.85,18.85,0,0,1-2.2-1.11h0a1.76,1.76,0,0,1-.87-1.55,1.78,1.78,0,0,1,1.81-1.75h2.65a132.78,132.78,0,0,0,33.7-4.91c8.23-2.32,13.66-4.42,13.88-5.14h0a1.78,1.78,0,0,1,3.39-.75c.48,1,1,2.08,1.48,3.19l1.6,3.51h0l.08.21a1.79,1.79,0,0,1-1.18,2.23l-1.41.43a1.78,1.78,0,0,1-2-.49,5.71,5.71,0,0,0-8-.63h0a5.69,5.69,0,0,0-1.91,3.32,1.8,1.8,0,0,1-1.35,1.55c-1,.26-2,.5-2.94.72s-1.92.44-2.84.64h0a1.79,1.79,0,0,1-1.75-.61,5.89,5.89,0,0,0-2-1.54,5.69,5.69,0,0,0-7.78,3.2h0a1.78,1.78,0,0,1-1.48,1.16c-1.26.14-2.47.25-3.65.33s-2.18.12-3.29.14a1.76,1.76,0,0,1-1.57-.7,5.71,5.71,0,0,0-6.52-1.91,5.84,5.84,0,0,0-1.67.95,1.76,1.76,0,0,1-1.71.41A23.37,23.37,0,0,1,324,405Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M332.77,409.25a1.43,1.43,0,0,0-1-.43,1.45,1.45,0,0,0-1,.43,1.47,1.47,0,0,0-.43,1,1.43,1.43,0,0,0,.43,1,1.45,1.45,0,0,0,1,.43,1.47,1.47,0,0,0,1.47-1.47,1.47,1.47,0,0,0-.43-1m-1-1.86a2.9,2.9,0,1,1-2.05,4.95,2.9,2.9,0,0,1,0-4.1A2.86,2.86,0,0,1,331.73,407.39Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M352.66,406.34a1.47,1.47,0,0,0-1-.43,1.47,1.47,0,0,0-1.47,1.47,1.49,1.49,0,0,0,1.47,1.48,1.49,1.49,0,0,0,1.47-1.48,1.47,1.47,0,0,0-.43-1m-1-1.86a2.9,2.9,0,0,1,2.05.85,2.86,2.86,0,0,1,.85,2.05,2.9,2.9,0,1,1-5.8,0,2.86,2.86,0,0,1,.85-2.05A2.9,2.9,0,0,1,351.62,404.48Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M371.56,401.44a1.51,1.51,0,0,0-1-.43,1.47,1.47,0,0,0-1.47,1.47,1.49,1.49,0,0,0,1.47,1.48,1.48,1.48,0,0,0,1-.44,1.43,1.43,0,0,0,.43-1,1.47,1.47,0,0,0-.43-1m-1-1.86a2.9,2.9,0,0,1,2.05.85,2.86,2.86,0,0,1,.85,2.05,2.9,2.9,0,1,1-5.8,0,2.86,2.86,0,0,1,.85-2.05A2.9,2.9,0,0,1,370.52,399.58Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M461.83,366.53a1.48,1.48,0,0,0-2.09,0,1.51,1.51,0,0,0-.43,1,1.48,1.48,0,0,0,2.95,0,1.51,1.51,0,0,0-.43-1m-1.05-1.86a2.9,2.9,0,1,1-2,.85A2.9,2.9,0,0,1,460.78,364.67Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M464.59,347.22a1.44,1.44,0,0,0-1-.44,1.48,1.48,0,0,0-1,.44,1.43,1.43,0,0,0-.43,1,1.47,1.47,0,0,0,.43,1,1.51,1.51,0,0,0,1,.43,1.47,1.47,0,0,0,1.47-1.47,1.43,1.43,0,0,0-.43-1m-1-1.87a2.91,2.91,0,1,1-2.9,2.91,2.94,2.94,0,0,1,.85-2.06A2.9,2.9,0,0,1,463.55,345.35Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M463.48,327.72a1.43,1.43,0,0,0-1-.43,1.47,1.47,0,0,0-1.47,1.47,1.51,1.51,0,0,0,.43,1,1.47,1.47,0,0,0,1,.43,1.43,1.43,0,0,0,1-.43,1.48,1.48,0,0,0,.44-1,1.44,1.44,0,0,0-.44-1m-1-1.86a2.9,2.9,0,1,1,0,5.8,2.86,2.86,0,0,1-2.05-.85,2.9,2.9,0,0,1,0-4.1A2.86,2.86,0,0,1,462.44,325.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M301.66,263.21a15.53,15.53,0,0,0,5.42-4.36,28.32,28.32,0,0,1,5.3-14.27q-11.13,7.93-10.72,18.63",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M400.54,256.35q5.47-3.62,4-5.65a107.38,107.38,0,0,0-17.3,3.65q8.64,1.6,13.27,2",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M400.82,256.46q5.48-3.6,4-5.64a106.12,106.12,0,0,0-17.31,3.64q8.64,1.6,13.28,2",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M443.42,262.56c.09-2.58.94-4,2.57-4.37q-6.39-5.59-6.15-11.44-4.23,10.47,3.58,15.81",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M460.24,253.73q-8.44.28-9.25,3.64a35,35,0,0,0-1.18-9.59q3.29,4.16,10.43,5.95",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M256.83,265.61a4.93,4.93,0,0,0,2.36,4.59q4.44-3.65,3.07-12.11-.75,3.14-5.43,7.52",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M243.57,272.75c1.5-2.91,2.87-4.07,4.13-3.5q-.45-5.07,3.23-10.33-10.56,5.11-7.36,13.83",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M371.45,401.55a1.68,1.68,0,0,1-1.95,2.24,1.74,1.74,0,0,0,.66.31,1.84,1.84,0,0,0,1.42-.21,1.88,1.88,0,0,0,.85-1.16,1.84,1.84,0,0,0-.21-1.42,1.88,1.88,0,0,0-1.16-.85,2,2,0,0,0-1,0,1.7,1.7,0,0,1,1.38,1.07",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M373,404.07a5,5,0,0,1-6.21,2.19,5.35,5.35,0,1,0,4.22-9.1,5,5,0,0,1,2.34,6.14,2.84,2.84,0,0,1-.35.77",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M372.05,400a2.9,2.9,0,1,1-3.46,4.63,3,3,0,1,0,3.46-4.63",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M369.85,397.18a5.34,5.34,0,0,0-4,8q-1-5.85,4-8",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M377.06,391.18c4.4-.24,5,2.45,5.57,5.24.25,1.21.52,2.46,1.7,2.71a1.62,1.62,0,0,0,.85-.05,1.54,1.54,0,0,0,.68-.48,2.13,2.13,0,0,0,.23-1.15c-.66,1.39-1.4.76-2.2-1.9-.05-.19-.11-.4-.17-.61a6,6,0,0,0-5.5-4.62l-.25-1.39-.85,0c0,.5,0,1,0,1.47a1.13,1.13,0,0,1-.1.75",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M351.24,375.56a2.25,2.25,0,0,1-1.08,3.4,1.81,1.81,0,0,0,1.08-3.4m9.21-3.29a2.25,2.25,0,0,1-1.07,3.41,1.81,1.81,0,0,0,1.07-3.41Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M379.68,388.94c3.45.38,5.59,3,6.39,7.79a14.47,14.47,0,0,0-1-4,9.08,9.08,0,0,0-2.16-3.54l-.18-.15-1.42,0-1.64,0",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M432.16,336.45a1.73,1.73,0,0,1,3.16,1.31,1.73,1.73,0,1,0-3.16-1.31",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M431.78,326.18a1.73,1.73,0,0,1,3.17,1.31,1.74,1.74,0,1,0-3.17-1.31",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M455.58,318.17a1.09,1.09,0,0,1-1.42.14c-.14.54-.26,1.06-.35,1.59a15.76,15.76,0,0,1,2.32.75c.48-4.74,3.31-4.73,6.26-4.71,1.22,0,2.5,0,3-1.08a1.53,1.53,0,0,0,.11-.84,1.58,1.58,0,0,0-.34-.77,2.18,2.18,0,0,0-1.08-.43,7.14,7.14,0,0,0-1.09-.16q1.88,1.95-.49,2l-.71,0q-4.46-.06-6.17,3.58",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M454.52,317c.64-2.21,2.66-3.63,6-4.26-.46.05-.92.11-1.38.2a9.07,9.07,0,0,0-3.87,1.46l-.18.14c-.2.92-.41,1.72-.61,2.46",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M248.8,276.21a5.48,5.48,0,0,1-2-.36c-2.76-1-3.72-3.89-4.07-6.15-10.15.05-15.55-2.17-16.55-6.76-1.17-5.36,4.87-12.2,18.47-20.9s34.57-19,60.64-29.86l1.94,4.67c-64.64,26.86-76.86,41.6-76.11,45,.24,1.11,3.44,3.11,13.83,2.73l2.51-.09.1,2.52c.14,3.6,1,4.09,1,4.09s2.45.79,10.87-8l.57-.6.83-.14a423.78,423.78,0,0,0,43.88-9.91l4.19-1.2-1.05,4.24a37.54,37.54,0,0,0-1.15,9.15l-5.05,0a40.59,40.59,0,0,1,.47-6.25c-12.55,3.43-25.85,6.38-39.62,8.78C256.6,273.32,252.23,276.21,248.8,276.21Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M304,283.32a7.22,7.22,0,0,1-5-2.05,7.8,7.8,0,0,1-2.4-5.62v-5.14a7.78,7.78,0,0,1,7.59-7.67l8-.34,1.23,20.4-9.1.41Zm.32-16.87a4.18,4.18,0,0,0-4.14,4.06v5.14a4.2,4.2,0,0,0,1.3,3,3.6,3.6,0,0,0,2.68,1l5.44-.24-.8-13.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M320,293.65a10.15,10.15,0,0,1-10.1-9.51l-1.26-20.85a10.15,10.15,0,0,1,9.5-10.72h0l41.58-2.51a10.13,10.13,0,0,1,10.72,9.5l1.26,20.85a10.12,10.12,0,0,1-9.5,10.71l-41.58,2.51C320.37,293.65,320.17,293.65,320,293.65Zm-1.64-37.47a6.51,6.51,0,0,0-6.11,6.89l1.26,20.85a6.52,6.52,0,0,0,6.89,6.11L362,287.52a6.53,6.53,0,0,0,6.11-6.9l-1.26-20.84a6.53,6.53,0,0,0-6.9-6.12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M327.31,293.65a10,10,0,0,1-2.67-.36l-10.55-2.88L362,287.52a6.53,6.53,0,0,0,6.11-6.9l-1.26-20.84a6.54,6.54,0,0,0-6-6.1l-25.28-2.08,31.85-1.92a10.23,10.23,0,0,1,10.81,9.57l.39,6.55h-1.92c-.37,0-1.65,1.45-1.94,4-.16,1.4-.17,4.76,3.23,5.71l1.24.35.27,4.46a10.24,10.24,0,0,1-9.57,10.8l-42,2.53C327.72,293.65,327.52,293.65,327.31,293.65Zm43.85-21.57.5,8.33a10.1,10.1,0,0,1-2.35,7.11l.38,0a6.52,6.52,0,0,0,4.53-2.21,6.59,6.59,0,0,0,1.66-4.77l-.13-2A7.94,7.94,0,0,1,371.16,272.08Zm-3.47-18.8a10.06,10.06,0,0,1,2.71,6.28l.67,11.11a12.25,12.25,0,0,1,.12-1.57c.37-2.65,1.67-5.33,3.61-6.41l-.2-3.22a6.61,6.61,0,0,0-6.91-6.19Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M385.62,279.71a62.6,62.6,0,0,1-6.89-.4c-4.3-.49-7.24-3.16-7.5-6.79,0-.29-.45-7,2.84-9.47a4.57,4.57,0,0,1,4.56-.49h0c6.26,2.34,12.38,1.91,18.71-1.34a4.67,4.67,0,0,1,4.61-.06c3.49,2,4,8.19,4.07,8.9.26,3.56-2.27,6.61-6.44,7.77A51.9,51.9,0,0,1,385.62,279.71Zm-8.93-13.91a.72.72,0,0,0-.46.14c-1,.77-1.57,3.95-1.4,6.32.16,2.21,2.33,3.23,4.31,3.46a50.28,50.28,0,0,0,19.47-1.37c.95-.26,4-1.33,3.81-4-.16-2.38-1.11-5.37-2.24-6-.14-.07-.44-.25-1.19.14-7.19,3.68-14.46,4.18-21.62,1.5h0A2,2,0,0,0,376.69,265.8Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M329.52,364.89a51.66,51.66,0,0,1-6.21-.35,2.51,2.51,0,0,1-2-1.43c-8.8-18.67-15.86-46-21-81.36l5-.73c4.94,34,11.65,60.46,20,78.64,10,.85,22.42-1.39,37-6.67a140.53,140.53,0,0,0,2.95-19.21A2.53,2.53,0,0,1,369.4,332c10.73,9,17.88,13.92,22.52,15.58a44.37,44.37,0,0,0,18.94,2.81c5.79-11.77,8.51-23.19,8.08-34-9.53-16.16-15.8-30.22-18.62-41.79l4.91-1.2c2.73,11.22,8.92,25,18.38,40.95a2.57,2.57,0,0,1,.35,1.17c.62,12.22-2.48,25.13-9.2,38.35a2.55,2.55,0,0,1-1.93,1.36,48.68,48.68,0,0,1-22.62-2.92c-4.69-1.69-11.06-5.88-20.37-13.43-.56,4.66-1.53,10.19-2.89,16.5a2.53,2.53,0,0,1-1.59,1.84C351.67,362.33,339.65,364.89,329.52,364.89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M449.8,265.68c-2.82,0-6.07-2.19-10.2-6.83-4.22.37-7.94-.58-11.56-1.5-1-.24-2-.49-2.94-.71a60.52,60.52,0,0,0-24.44-.14l0,6.32-5.05,0-.05-10.53,2.06-.4c7.38-1.42,17.31-2.73,28.56-.2,1.05.23,2.08.49,3.07.74,3.69.94,7.17,1.83,11,1.23l1.4-.21.91,1.07c5.43,6.36,7.35,6.07,7.36,6.07s1.14-.71,1.41-5.82l.16-3.16,3,.86c9.34,2.65,14.33,1.74,15.76.15.9-1,.51-2.62,0-3.81-3.79-9.4-30.11-30.15-87.26-34.29l.37-5c57.39,4.15,86.63,25.17,91.57,37.44,1.94,4.81.23,7.75-1,9.08-3.07,3.42-9.25,4.13-18,2.09-.47,3.12-1.61,6.29-4.53,7.28A5.37,5.37,0,0,1,449.8,265.68Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M413.68,253a48.86,48.86,0,0,1,9.73-35.12l2.9,2.14a45.41,45.41,0,0,0-9,32.6Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M284.49,261.54c-8.19-5.12-11.66-16.46-10.3-33.72l3.6.28c-1.25,15.81,1.65,26,8.61,30.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M324.55,405.17l-1.72,0c-5.24-.08-9.09-4.56-9.59-11.14-.4-5.32,1.66-11.12,6.37-11.91a5.35,5.35,0,0,0,4.14-2.59c1.68-3.06.86-8.84-2.3-16.26l-1.61-3.78,4.09.27c12.9.82,26.28-1.52,39.77-7l2.15-.87,1,2.06c3.6,7.08,10.43,23.87,10.55,36.81a3.54,3.54,0,0,1-1.19,2.58C372,397.62,348,405.17,324.55,405.17Zm3-40.23c2.59,7.34,2.81,13.05.65,17a10.36,10.36,0,0,1-7.74,5.15c-1.23.2-2.42,3-2.16,6.54.05.65.6,6.41,4.63,6.47,23.94.38,46-7.42,49.47-10.05-.33-10.79-5.52-24.4-9-31.74A95.81,95.81,0,0,1,327.53,364.94Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M328.46,389.77a9.94,9.94,0,0,1-1.09,0,10.74,10.74,0,0,1-8.23-4.73l-1.09-1.79,1.93-.81a7.61,7.61,0,0,0,4.43-4.16c1.34-3.3.51-8.51-2.47-15.49l-1.15-2.7,2.93.19a82,82,0,0,0,9.79,0l.46,0,1.33.63.27.61c5.43,12.12,6.37,19.56,2.95,23.42A13.39,13.39,0,0,1,328.46,389.77Zm-4.9-5.2a8,8,0,0,0,4.13,1.56,9.71,9.71,0,0,0,8.13-3.63c1.54-1.74,2.21-6.38-3.12-18.58-2.13.1-4.26.11-6.38.05,2.51,6.69,3,11.82,1.44,15.62A10.54,10.54,0,0,1,323.56,384.57Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M321.68,398.1c-3.09,0-6.26-.73-7.71-3.68l3.25-1.58c.72,1.47,3.22,2,7.42,1.44A230.1,230.1,0,0,0,360,387.33a16.06,16.06,0,0,1,11.69-14.18l1,3.48a12.42,12.42,0,0,0-9.08,12.05,1.82,1.82,0,0,1-1.3,1.75,231.33,231.33,0,0,1-37.2,7.43A27.9,27.9,0,0,1,321.68,398.1Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M443,379a19.49,19.49,0,0,1-7.62-1.82c-5.39-2.41-8.77-6.09-9.05-9.86-.13-1.86-1.44-11.21-14-12.07l.34-5c13,.88,18.19,9.57,18.7,16.75.13,1.73,2.68,4.09,6.07,5.61,3.54,1.58,6.44,1.63,7.18,1.06C452,368,456.44,347,451.37,324.9c0,0-.71-1.49-8.09-3.2-5.78-1.33-14.07-2.48-22.16-3.51l.64-5c24.4,3.12,33.29,5.19,34.53,10.59,5.08,22.15,1.23,46.32-8.57,53.89A7.58,7.58,0,0,1,443,379Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M439.34,377.35l-1.57-3.25c2.54-1.22,5.85-5.65,6.45-8.62,2.74-13.51,3.48-22.64,2.57-32.06a12.35,12.35,0,0,1-7.62-15.35l3.45,1.09a8.72,8.72,0,0,0,6.27,11.13,1.8,1.8,0,0,1,1.37,1.55c1.14,10.25.44,19.88-2.5,34.36C446.94,370.24,442.85,375.66,439.34,377.35Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M419,285.78h-5a8.57,8.57,0,0,1-6.33-2.8,7.44,7.44,0,0,1-2-5.77,130.62,130.62,0,0,0-.19-24l-.21-2.45,2.44-.28a48.19,48.19,0,0,1,17.73,1.33l1.66.42.23,1.69a82.71,82.71,0,0,1,0,23.9C426.56,282.58,423.22,285.78,419,285.78Zm-8.28-30.48a131.27,131.27,0,0,1,0,22.38,2.49,2.49,0,0,0,.69,1.9,3.61,3.61,0,0,0,2.6,1.14h5c2,0,3.05-2,3.32-3.67a76.43,76.43,0,0,0,.2-20.73A43.67,43.67,0,0,0,410.71,255.3Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M415.9,308.22h-.15l.07-5.06a2.89,2.89,0,0,0,2.52-1c1.22-1.42,2.94-5.8.68-19.11l5-.84c2,12,1.45,19.41-1.84,23.24A8,8,0,0,1,415.9,308.22Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M411.79,217.31a42.17,42.17,0,0,0-6.29-9.84L391,207l.16-5.06,16.81.51.73.87a48.84,48.84,0,0,1,7.79,12Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M397.12,215.2l-3.13-4c3.17-2.49,7-5.3,11.28-8.32l2.9,4.13C403.93,210,400.21,212.76,397.12,215.2Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M339.67,292.92h0a1.81,1.81,0,0,1-1.8-1.81l.08-14.49a2.94,2.94,0,0,0-1.86-2.74l-7.64-3a6.55,6.55,0,0,1-4.16-6.2l.17-10.84a1.8,1.8,0,0,1,1.8-1.78h0a1.81,1.81,0,0,1,1.77,1.84l-.16,10.84a2.92,2.92,0,0,0,1.86,2.77l7.64,3a6.56,6.56,0,0,1,4.16,6.13l-.08,14.48A1.8,1.8,0,0,1,339.67,292.92Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M431.47,368.33a7.47,7.47,0,0,1-3.66-1l1.77-3.15a3.82,3.82,0,0,0,3.93-.09,4.12,4.12,0,0,0,1.77-3.63c0-8.64-6.18-13.77-18.74-15.68l.55-3.57c14.4,2.19,21.74,8.67,21.8,19.23a7.76,7.76,0,0,1-3.45,6.7A7.38,7.38,0,0,1,431.47,368.33Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M331.82,420.06a9.65,9.65,0,1,1,9.65-9.65A9.66,9.66,0,0,1,331.82,420.06Zm0-15a5.32,5.32,0,1,0,5.32,5.32A5.33,5.33,0,0,0,331.82,405.09Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M351.71,417.15a9.65,9.65,0,1,1,9.65-9.65A9.66,9.66,0,0,1,351.71,417.15Zm0-15A5.32,5.32,0,1,0,357,407.5,5.33,5.33,0,0,0,351.71,402.18Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M370.6,412.25a9.65,9.65,0,1,1,9.65-9.65A9.65,9.65,0,0,1,370.6,412.25Zm0-15a5.32,5.32,0,1,0,5.32,5.31A5.31,5.31,0,0,0,370.6,397.29Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M460.87,377.34a9.65,9.65,0,1,1,9.65-9.65A9.66,9.66,0,0,1,460.87,377.34Zm0-15a5.32,5.32,0,1,0,5.32,5.32A5.33,5.33,0,0,0,460.87,362.37Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M463.64,358a9.65,9.65,0,1,1,9.65-9.64A9.65,9.65,0,0,1,463.64,358Zm0-15a5.32,5.32,0,1,0,5.31,5.32A5.32,5.32,0,0,0,463.64,343.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M462.53,338.53a9.65,9.65,0,1,1,9.65-9.65A9.66,9.66,0,0,1,462.53,338.53Zm0-15a5.32,5.32,0,1,0,5.32,5.32A5.32,5.32,0,0,0,462.53,323.56Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M420.81,356l-2.89-2.16a44.41,44.41,0,0,0,5.51-9.47l3.34,1.37A47.63,47.63,0,0,1,420.81,356Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M425,358.93l-1.64-3.22c4.19-2.14,6.44-4.52,6.69-7.09l3.59.35C433.26,352.84,430.36,356.19,425,358.93Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M428.05,363l-.95-3.49c3.56-1,6.19-2.63,7.82-5l3,2.08C435.75,359.7,432.44,361.84,428.05,363Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M331.06,371.54a18.15,18.15,0,0,1-5.61-1l1.12-3.43a11.8,11.8,0,0,0,9.14-.28l1.56,3.26A14.25,14.25,0,0,1,331.06,371.54Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M334.52,377.64a25,25,0,0,1-6.86-1l1-3.47a18.25,18.25,0,0,0,9.28.5l.85,3.51A18,18,0,0,1,334.52,377.64Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M336.92,385.77c-5.17-.55-9-2.63-11.29-6.16l3-2c1.72,2.62,4.56,4.11,8.66,4.55Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M337.79,407.2a1.8,1.8,0,0,1-1.44-.71,5.67,5.67,0,0,0-8.21-.9,1.85,1.85,0,0,1-1.68.36,19.94,19.94,0,0,1-4.68-2,1.8,1.8,0,0,1,.93-3.35h0c25.26.41,48-8.1,50.27-10.51a1.81,1.81,0,0,1,3.38-.29c.95,2,2,4.28,3.07,6.71a1.74,1.74,0,0,1,0,1.48,1.77,1.77,0,0,1-1.11,1l-1.54.48a1.8,1.8,0,0,1-1.9-.55,5.68,5.68,0,0,0-9.91,2.79,1.81,1.81,0,0,1-1.34,1.46c-2,.49-3.92,1-5.79,1.36a1.8,1.8,0,0,1-1.78-.61,5.65,5.65,0,0,0-4.38-2.08,5.72,5.72,0,0,0-5.34,3.73,1.78,1.78,0,0,1-1.49,1.17c-2.52.28-4.9.44-7.06.48Zm.65-3.8.17.17c1.52-.05,3.14-.16,4.84-.33.1-.18.2-.37.31-.55C342,403,340.24,403.2,338.44,403.4ZM357.17,400a8.44,8.44,0,0,1,.93.77c1.18-.26,2.39-.55,3.61-.85a10.14,10.14,0,0,1,.51-1.33C360.63,399.07,358.94,399.54,357.17,400Zm16.68-6.09.57.23-.21-.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M384.76,402.88a5.33,5.33,0,0,1-1.12-.12c-3.43-.76-4-3.6-4.44-5.48-.2-1-.4-1.87-.83-2.14-.22-.14-1-.42-3,.05l-1.36.32-.65-1.25a5.6,5.6,0,0,1-.21-3.34,7,7,0,0,0,0-2.81l-.68-2,2.11-.34a36.63,36.63,0,0,1,7-.23l1.39,0c2.4.06,4.11,2.68,5.13,4.88,1.25,2.69,2.8,7.93.7,10.54A5.09,5.09,0,0,1,384.76,402.88Zm-7.45-11.56a5.37,5.37,0,0,1,3,.78c1.7,1.08,2.09,2.94,2.41,4.43.42,2,.66,2.48,1.69,2.7a1.5,1.5,0,0,0,1.51-.53c.24-.29.48-1.84-.33-4.56-.89-3-2.27-4.76-2.82-5l-1.37,0c-1.7-.05-3.15-.1-4.55,0a15.18,15.18,0,0,1-.17,2.22C376.91,391.32,377.11,391.32,377.31,391.32Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M457.61,324.82a7.66,7.66,0,0,1-2.64-.69,6.77,6.77,0,0,0-2.8-.67l-2.12.29.07-2.14a20.92,20.92,0,0,1,.91-5.05c.23-.82.46-1.68.68-2.69.5-2.34,3.4-3.53,5.74-4.11,2.88-.72,8.33-1.26,10.49,1.29a5.12,5.12,0,0,1,.8,5.35c-1.41,3.27-4.34,3.25-6.28,3.24-.94,0-1.89,0-2.22.33-.18.18-.58.83-.5,2.94l.05,1.4-1.35.4A2.91,2.91,0,0,1,457.61,324.82ZM453.92,320a16.33,16.33,0,0,1,2.3.75,5.6,5.6,0,0,1,1.43-3.3c1.4-1.44,3.3-1.42,4.83-1.42,2,0,2.53-.11,2.94-1.06a1.52,1.52,0,0,0-.24-1.59c-.24-.28-1.71-.81-4.53-.52-3.08.31-5.11,1.33-5.43,1.83-.23,1.07-.48,2-.7,2.82S454.06,319.2,453.92,320Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.8,198.83c51.89,77.4,161.94,9.19,120.28-70.31C353.84,48,240.15,118.65,284.8,198.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.8,198.83c51.89,77.4,161.94,9.19,120.28-70.31C353.84,48,240.15,118.65,284.8,198.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.8,198.83c51.89,77.4,161.94,9.19,120.28-70.31C353.84,48,240.15,118.65,284.8,198.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M343.64,234.11a66.29,66.29,0,0,1-12.72-1.22c-18.67-3.63-35-15.16-47.18-33.36l-.05-.08c-10.59-19-13.11-38.82-7.3-57.31,5.18-16.49,16.63-30.69,32.23-40s33.4-12.51,50.2-9.09c18.94,3.86,35.3,15.88,47.33,34.78l.06.09c9.89,18.87,12,38.43,6.1,56.57a73.49,73.49,0,0,1-68.67,49.61Zm-57.75-36C312,237.1,351.51,238,379.07,221.6c26.92-16,46.19-51.77,24.9-92.44-25.66-40.27-66.73-41.1-94-24.82C282.35,120.77,263.07,157.14,285.89,198.16Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M284.8,198.82c43.66,67.64,142.74,25.18,127.77-50.74-3.28,25-11.79,26.47-24.18,39.79-37.88,43.54-102.45,16.49-113.09-33.14A69.69,69.69,0,0,0,284.8,198.82Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M343.64,234.62a67.33,67.33,0,0,1-12.82-1.22c-18.8-3.66-35.23-15.27-47.5-33.58l-.08-.13c-10.66-19.13-13.19-39.08-7.34-57.7a72.52,72.52,0,0,1,32.46-40.28C324,92.36,342,89.11,358.92,92.56c19.08,3.88,35.56,16,47.67,35l.07.13c10,19,12.08,38.69,6.14,57a74,74,0,0,1-69.16,50Zm-57.31-36.73c25.94,38.64,65.13,39.53,92.48,23.27,26.71-15.89,45.83-51.38,24.72-91.74-25.48-40-66.24-40.79-93.34-24.64C282.83,121.09,263.7,157.18,286.33,197.89Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M343.64,235.37a68,68,0,0,1-13-1.24c-19-3.69-35.6-15.41-48-33.89l-.11-.18c-10.75-19.32-13.31-39.47-7.4-58.29A73.32,73.32,0,0,1,308,101.06c15.84-9.44,34-12.72,51.09-9.24C378.35,95.75,395,108,407.22,127.16l.11.19c10.05,19.18,12.19,39.07,6.19,57.54a74.73,74.73,0,0,1-69.88,50.48ZM287,197.5c25.67,38.21,64.42,39.1,91.45,23,26.42-15.71,45.32-50.79,24.46-90.71-25.22-39.52-65.51-40.35-92.3-24.38C283.52,121.55,264.6,157.23,287,197.5Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M295.87,212.83c70.34,41.79,130.42-40.25,77.12-88.11C310,74.73,238.94,152.11,295.87,212.83Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M277.19,164.31c-.54,73.95,105.2,80.44,116.79,12.91C360,216.92,296.9,200.16,277.19,164.31Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M337.77,232.8a57.55,57.55,0,0,1-14.84-1.92c-15.67-4.15-29.38-14.91-39.64-31.1h0c-8.65-13.88-12-31.73-9.14-49,3-18.27,12.48-33.9,26.67-44l.26-.16c16.95-8.17,37.47-8.66,56.31-1.35s33.52,21.4,40.46,38.72c6.29,16.94,6,34.08-.89,49.6a66.6,66.6,0,0,1-31.38,32.59A62.72,62.72,0,0,1,337.77,232.8Zm-51.46-34.93C309,233.59,342.3,233.71,364,223c24.92-12.35,43.4-43,30.52-77.7-6.56-16.37-20.56-29.75-38.42-36.68s-37.29-6.5-53.32,1.18C273.24,130.91,270.41,172.36,286.31,197.87Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M334.61,226.11c-13.07,0-26.57-4-39.65-11.75l-.22-.13-.17-.18c-13.67-14.58-21-31.18-21.32-48a58.16,58.16,0,0,1,15.43-40.55,57.09,57.09,0,0,1,38-18.42c16.15-1.18,32.56,4.45,47.45,16.27l.08.07c12.43,11.15,19.63,24.88,20.83,39.7a57,57,0,0,1-11.18,38.29,60.45,60.45,0,0,1-37,23.53A62.63,62.63,0,0,1,334.61,226.11ZM297,211.42c36.13,21.34,68.19,9.29,83.95-12.16,14.32-19.48,17.05-49.65-9.12-73.18-31.48-25-63.12-17.08-80.52,1.81S268.44,180.8,297,211.42Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423.44,177.47c-4.56,32.54-37.55,30.72-36.34-.79C390.62,142.4,425.89,144.34,423.44,177.47Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M402.76,201.19c-9.9-.48-17.17-12.5-15.51-26.16,6.31,14.26,21.18-9.44,22.19-16.2C434.89,165.06,420.91,202.45,402.76,201.19Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M403.61,203.64q-.74,0-1.44-.06c-9.25-.83-18.28-9.49-17.61-27v-.16c1.95-19,13.48-28,23.87-27.11,9.39.83,18.88,10.06,17.53,28.35l0,.16C423.44,195.8,412.89,203.64,403.61,203.64Zm-14-26.78c-.52,14.12,6.14,21,13,21.66,7.26.65,16.09-5.75,18.29-21.32C422,162.39,415,155,408,154.37,400.11,153.68,391.27,161.17,389.63,176.86Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M424.73,179.27c-3.72,26.37-28.46,25.42-27.49-.06C400,151.1,426.89,152.16,424.73,179.27Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M409.39,200.47c-.34,0-.67,0-1,0-6.81-.61-13.45-7.43-12.92-21.29V179c1.52-15.52,10.31-22.94,18.2-22.24,7,.62,14,8,12.85,22.62v.11C424.44,194.1,416.39,200.47,409.39,200.47ZM399,179.33c-.43,11.48,4.55,17.08,9.67,17.54,5.57.49,12.41-4.86,14.25-17.79.95-12.2-4.31-18.26-9.61-18.73C407.21,159.8,400.33,166.15,399,179.33Zm25.7-.06Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-489"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M380.65,162.56C377,175.91,361.77,172,363,159.93,365.36,144.8,383.39,149.12,380.65,162.56Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-489"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372.74,183.53c-1.69,5-8.38,3.45-7.05-2.18C367.38,176.33,374.07,177.91,372.74,183.53Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-489"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.33,168.93c-9.41-50.67,43.15-58.12,59.29-47.59C311.9,124.2,297.29,145.29,286.33,168.93Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M396,185.19a23.68,23.68,0,0,1,1.2-11.12c5,17.72,22.75,9.59,26.71-3.24C428.28,197.09,401.71,209.81,396,185.19Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M388.61,157a3.45,3.45,0,0,1-1.49-.33c-2.71-1.28-3-5.63-3-6.93a1.79,1.79,0,1,1,3.57-.06c0,1.73.57,3.52,1,3.76a2.78,2.78,0,0,0,1.12-.64,1.79,1.79,0,0,1,2.23,2.8A5.51,5.51,0,0,1,388.61,157Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "M348.7,267.45c0,.84,1.15,7.67,1.15,7.67l4.81,0c3.31,0,6-3.39,6-7.62s-2.64-7.68-5.95-7.7l-4.81,0S348.71,266.07,348.7,267.45Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M348.7,267.45c0,.84,1.15,7.67,1.15,7.67l4.81,0c3.31,0,6-3.39,6-7.62s-2.64-7.68-5.95-7.7l-4.81,0S348.71,266.07,348.7,267.45Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M354.69,276.51h0l-4.81,0a1.38,1.38,0,0,1-1.35-1.15c-.27-1.63-1.16-7-1.16-7.9h0c0-1.43,1.05-6.84,1.26-7.91a1.38,1.38,0,0,1,1.35-1.11l4.81,0a6.71,6.71,0,0,1,5.31,2.8,10.11,10.11,0,0,1,2,6.27C362,272.49,358.73,276.51,354.69,276.51ZM351,273.75l3.66,0h0c2.54,0,4.62-2.8,4.64-6.26a7.4,7.4,0,0,0-1.44-4.58,4,4,0,0,0-3.15-1.74l-3.67,0c-.45,2.37-1,5.49-1,6.28C350.08,267.93,350.53,270.85,351,273.75Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-490",
    cx: 349.89,
    cy: 267.45,
    rx: 7.66,
    ry: 6,
    transform: "translate(194.71 615.77) rotate(-89.66)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M355.89,267.49c0,4.23-2.73,7.65-6,7.63s-6-3.47-6-7.7a9.09,9.09,0,0,1,.16-1.67c.83,2.91,3,5,5.59,5,2.86,0,5.27-2.52,5.89-5.95A9.77,9.77,0,0,1,355.89,267.49Z",
    transform: "translate(114.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.89,267.49a7.92,7.92,0,0,1-.05.85c-.64-3.32-3-5.78-5.77-5.8-3.09,0-5.66,2.95-6,6.78a9.87,9.87,0,0,1-.18-1.9c0-4.23,2.73-7.65,6-7.63S355.91,263.26,355.89,267.49Z",
    transform: "translate(114.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M349.87,276.49h0c-4.07,0-7.35-4.1-7.32-9.08h0c0-5,3.34-9,7.39-9h0a6.74,6.74,0,0,1,5.31,2.8,10.62,10.62,0,0,1-.07,12.53A6.79,6.79,0,0,1,349.87,276.49Zm-4.61-9.06c0,3.46,2,6.3,4.59,6.31h0A4.06,4.06,0,0,0,353,272a7.86,7.86,0,0,0,.05-9.14,4,4,0,0,0-3.15-1.74h0c-2.55,0-4.63,2.81-4.65,6.27Z",
    transform: "translate(114.32)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodBg);
export default __webpack_public_path__ + "static/media/good-bg.1d6e39ec7214ed80e722bd5f2bd44e24.svg";
export { ForwardRef as ReactComponent };